/* eslint-disable eqeqeq */
/* eslint-disable default-case */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-concat */
/* eslint-disable no-eval */
import $, { error } from "jquery";
import "../tweaked/jquery-contextMenu";
import "bootstrap-4-autocomplete/dist/bootstrap-4-autocomplete";
import ReactDOM from "react-dom";
import React from "react";
import orderListUtil, {
  update,
  updatePrintersStatus,
  getTableOccupation,
  updateOrders,
  printNewOrders,
  getTable,
  updateTableOccupations,
  playNewAcceptedOrderSound,
  updateTableMates,
  processAllOrders,
  getTableOccupationTablesForTable,
  mateInState,
  deleteOrders,
  preProcessOrders,
  updateOrderList,
  setSelected,
  showDetails,
  _show,
  updateAndCloseModal,
  getQuantity2,
  getMenuItemCategory,
  getOrdersPaidBy,
  tmplparams,
  setPrinterForProductionLine,
  unsetPrinterForProductionLine,
  unsetPrinterForPrinterAction,
  setPrinterForPrinterAction,
  resetOrderListUtil,
  addRejectionReason,
  simpleChangeStateByTableAndMenuItem,
  setTakeAway,
  updatePayingMates,
  deleteTableOccupations,
  setTakeAwayOrder,
  toggleSound,
  _keyDownHandler,
  getOrderById,
  getAddresses,
  initSound,
  getTableName,
  playClickSound,
  getMaxModificationTimeStamp,
  setVoipphone,
  compressToBase64,
  countTableOccupationTablesForTableAndDate,
  buildOrderIndex,
  addOrder
} from "./order-list-util";
import admin, {
  getTableMate,
  getMyStatus,
  updatePrices,
  isAdmin,
  getMenuItem,
  moveOrdersToCustomer,
  cancelOrder,
  printHtml,
  getLocalPrinterSettings,
  getPrinter,
  printPdf,
  unlockTable,
  lockTable,
  getQuantity,
  getDiscount,
  getProductionLine,
  unlockme,
  changeToUser,
  unlock,
  quickChangeToUser,
  lock,
  incrementTableMates,
  activateTableMate,
  unjoinTableMate,
  getMenuCategory,
  getPickupTableNumber,
  getHomeDeliveryTableNumber,
  updateTimeahead,
  settings,
  selectTableOccupationSelected,
  hasRole,
  selectTableNumberSelected,
  isHomeDelivery,
  isPickup,
  getNonLocalPrinterForPrinterAction,
  getPrinterForProductionLine,
  resultHandler
} from "./admin";
import languages, { admin_locals } from "../langs/languages";
import AI from "./ai/ai";
import auth, {
  ajaxCallStart,
  ajaxCallEnd,
  ajaxErrorEnd,
  navigateToLogin,
  startpoll,
  replaceContent,
  isVisible,
  getOrientation,
  select,
  confirmDialog,
  choiceDialog2,
  messageDialog,
  choiceDialog,
  isTop,
  updateCheckBoxesById,
  avoidMultipleClick,
  clickHandler123,
  post,
  del,
  loadMyImage,
  updateToolTips,
  getLocale2,
  isDuplicateClickEvent,
  cleanLogin,
  relogin,
  avoidMultipleClick2,
  touchStart,
  touchClick,
  deactivateToggleRadioButton,
  getImageById,
  settingEnabled,
  get,
  scaleMeasure,
  getQuantityLabel,
  getLocale,
  featureEnabled,
  getReportUrl,
  _logError,
  getInputDialog2,
  getInputDialog,
  incomingCallChanged,
  lighten,
  getSetting,
  resetLockTimeout,
  setRem,
  setData,
  getData,
  _log
} from "./auth";
import tableLayout from "./table-layout";
import { gotoTop, onsave } from "./chooseMenuItem";
import moment from "moment";
import chooseMenuItems from "./chooseMenuItem";
import SortedSet from "js-sorted-set";
import { customerComparator, getOrderElement, _preProcessOrders, alltimings, allstates, allstates2 } from "./order-grouping";
import { orderMenuItem, editOrder, orderAnother, additionSearchChanged, additionOptionIsIncluded, additionOptionIsChecked, includedInCategoryOption, switchKeyboard, deleteOne, updateBookingComment, updateBookingUserComment, addAllergenComment } from "./orderMenuItem";
import { _qrcode } from "./qrcode";
import X2JS from "x2js";
import { dayOpen, dayClose, dayCloseReprint, checkPayments, setAmount, amountChanged, selectCurrency, getPaymentMethod, getCurrencyEchangeRate, createNewPartner, showPayments, printReceipt, postPayment, isThereReceiptsToPrint, reprintReceipts, reprintReceipt, storno, registerTip, selectTerminal, cashin, cashout, setServiceFee, stornoReceipt, getRestaurantPaymentMethodsOrderedByCashRegister, addCashReceivedNote, clearCashReceivedAmount, toggleCashReturnCalculation, refreshCashReturnFocusState } from "./tableMatePaid";
import ReactQRCode from "./react-qrcode";
//import BookTable from "./bookTable";
import menuitemutil from "./admin/menuitem";
import { updateFooterButtons as kioskModeUpdateFooterButtons, cancelOrders, payit } from "./point-of-sale";
import { chooseCustomer } from "./choose_customer";
import { I18n } from "react-redux-i18n";
import TableReservationComponent from "../main/tableReservations/TableReservationComponent";
import { Provider } from "react-redux";
import { store } from "..";
import BookingMap from "../components/BookingMap";
import "jquery-typeahead/src/jquery.typeahead.js";
import "jquery-typeahead/dist/jquery.typeahead.min.css";
import "./keyboard";
import { insertCharacter, insertEnter, backspaceCharacter, leftCharacter, rightCharacter, clearInput } from "./keyboard";
import { cashierChanged, reprintInvoice } from "./admin/tableOccupations";
import { capturePhotoWithData } from "./camera-util";
import EatWithMeActions from "../actions/EatWithMeActions";
import Softphone, { callANumber } from "../main/tablesOverview/Softphone";
import VoiceOrderButton from "../components/icon-buttons/VoiceOrderButton";
import CategoryList from "../components/CategoryList";
import { hasAccess } from "./authProvider";
import { showCustomerScreen, toggleCustomerScreen, updateDataOnCustomerScreen } from "../main/pointOfSale/PointOfSale";
import menuitemUtils from "./menuitem-utils";

const BookTable = {}

const canPrintHomeDeliveryLabels = () => !!auth.myStatus?.restaurant_settings?.["enabled-features"]?.homedelivery?.printAllLabels || featureEnabled("homedelivery/printAllLabels");
const isLabelPrintingTable = () => isHomeDelivery() || isPickup();

const hasLabelPrinterForOrder = order => {
  if (!order || order.state === "cancelled") return false;
  const labelCount = Number(order.labelCount ?? order.menuItem?.labelCount ?? 0);
  if (!(labelCount > 0)) return false;
  if (!order.defaultProductionLinesIds) return false;
  const r = order.defaultProductionLinesIds.split(",").some(id => {
    if (!id) return false;
    const productionLine = getProductionLine(id);
    return !!productionLine?.labelPrinter?.id;
  });
  return r;
};

const hasPrintableHomeDeliveryLabelOccupation = occupation => {
  if (!occupation || !Array.isArray(occupation.orderIds) || !occupation.orderIds.length) return false;
  return occupation.orderIds.some(id => hasLabelPrinterForOrder(getOrderById(id)));
};

const isHomeDeliveryLabelOccupationPrinted = occupation => {
  if (!occupation || !Array.isArray(occupation.orderIds) || !occupation.orderIds.length) return false;
  const printableOrderIds = occupation.orderIds
    .map(id => getOrderById(id))
    .filter(Boolean)
    .filter(order => hasLabelPrinterForOrder(order))
    .map(order => order.id);

  return printableOrderIds.length > 0 && printableOrderIds.every(id => !!getOrderById(id)?.printed);
};

const hasPrintedHomeDeliveryLabels = occupations => {
  const list = occupations.filter(Boolean);
  return list.length > 0 && list.every(isHomeDeliveryLabelOccupationPrinted);
};

const getHomeDeliveryLabelPrinterHtml = occupation => {
  if (!canPrintHomeDeliveryLabels() || !isLabelPrintingTable()) return "";
  if (!hasPrintableHomeDeliveryLabelOccupation(occupation)) {
    return "<div class='label-printer label-printer-empty' aria-hidden='true'>&nbsp;</div>";
  }
  const labelPrinted = isHomeDeliveryLabelOccupationPrinted(occupation) ? " printed" : "";
  return "<div class='label-printer icon-printer" + labelPrinted + "' style='display:flex;justify-content:center;align-items:center' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.print_all_labels") + "'/>";
};

const printHomeDeliveryLabelsForOccupations = (occupations, reprint = false) => {
  const list = occupations.filter(Boolean);
  if (!list.length) return;
  if (!reprint && hasPrintedHomeDeliveryLabels(list)) {
    confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.do_you_really_want_to_reprint_only_the_selected_orders")).done(() => {
      printHomeDeliveryLabelsForOccupations(list, true);
    });
    return;
  }
  const occupation = list.shift();
  const orderIds = occupation.orderIds ? occupation.orderIds.map(id => getOrderById(id)).filter(Boolean).filter(hasLabelPrinterForOrder).map(o => o.id) : [];
  if (!orderIds.length) {
    if (list.length) printHomeDeliveryLabelsForOccupations(list, reprint);
    return;
  }

  const selectedProductionLines = typeof window !== "undefined" && window.getSelectedProductionLines ? window.getSelectedProductionLines() : [];
  const productionLines = selectedProductionLines.length ? selectedProductionLines : auth.myStatus.restaurant_production_lines.map(p => String(p.id));
  const productionLineId = productionLines[0];
  const productionLine = auth.myStatus.restaurant_production_lines.find(p => String(p.id) === String(productionLineId));
  if (!productionLine?.labelPrinter?.id) {
    if (list.length) printHomeDeliveryLabelsForOccupations(list, reprint);
    return;
  }

  get("adminService/" + localStorage.restaurantSelected + "/" + occupation.tableOccupation + "/printLabel?orderIds=" + orderIds.join(",") + "&printer=" + productionLine.labelPrinter.id + "&productionLines=" + productionLineId + "&reprint=" + reprint).done(() => {
    if (list.length) setTimeout(() => printHomeDeliveryLabelsForOccupations(list, reprint), 150);
  });
};

export const ensureOrderStatePopup = () => {
  const stateTitle = admin_local.change_order_items_state;
  const editOrderTitle = admin_local.edit_order || local.edit || "Edit order";
  let popup = $("#orderStatePopup");
  if (popup.length) {
    return popup;
  }

  popup = $(
    '<div id="orderStatePopup" class="order-state-popup">' +
    '  <div class="order-state-popup-card">' +
    '    <div class="order-state-popup-header">' +
    '      <div class="order-state-popup-title">' + stateTitle + '</div>' +
    '      <div class="order-state-popup-header-actions">' +
    '        <button type="button" class="order-state-popup-edit btn btn-primary hidden" aria-label="' + editOrderTitle + '"></button>' +
    '        <button type="button" class="order-state-popup-close" aria-label="Close">x</button>' +
    '      </div>' +
    '    </div>' +
    '    <div class="order-state-popup-track"></div>' +
    '  </div>' +
    '</div>'
  );

  $("body").append(popup);

  popup.on("click", function (event) {
    if ($(event.target).is(".order-state-popup")) {
      popup.removeClass("open");
    }
  });

  popup.find(".order-state-popup-close").on("click", function () {
    popup.removeClass("open");
  });

  return popup;
}

export const getOrderStatePopupItems = (sourceCell, sourceElement) => {
  const row = sourceCell.closest("tr");
  const table = sourceCell.closest("table");
  const items = [];
  const readAttr = function (element, names) {
    for (let index = 0; index < names.length; index++) {
      const value = element.attr(names[index]);
      if (typeof value !== "undefined" && value !== null && value !== "") {
        return value;
      }
    }

    return "";
  };

  const sourceCellOrders = readAttr(sourceCell, ["orders"]);
  const sourceCellAllOrders = readAttr(sourceCell, ["allorders"]);
  const sourceCellTableOccupation = readAttr(sourceCell, ["tableoccupation", "tableOccupation"]);
  const sourceCellTableNumber = readAttr(sourceCell, ["tablenumber", "tableNumber"]);
  const sourceCellOrderSequenceNumber = readAttr(sourceCell, ["ordersequencenumber", "orderSequenceNumber"]);
  const $sourceElement = $(sourceElement);
  const sourceOrderItem = $sourceElement.is(".orderTableItem") ? $sourceElement : $sourceElement.find(".orderTableItem").first();
  const fallbackOrders = sourceCellOrders || sourceOrderItem.attr("orders") || sourceOrderItem.attr("order") || sourceOrderItem.attr("orderId") || "";
  const fallbackAllOrders = sourceCellAllOrders || sourceOrderItem.attr("allorders") || "";
  const fallbackTiming = readAttr(sourceOrderItem, ["timing"]);
  const fallbackOrderSequenceNumber = sourceCellOrderSequenceNumber || readAttr(sourceOrderItem, ["ordersequencenumber", "orderSequenceNumber"]);
  const fallbackTableOccupation = sourceCellTableOccupation || readAttr(sourceOrderItem, ["tableoccupation", "tableOccupation"]);
  const fallbackTableNumber = sourceCellTableNumber || readAttr(sourceOrderItem, ["tablenumber", "tableNumber"]);

  row.find("td.state").each(function () {
    const cell = $(this);
    if (!cell.is(":visible")) {
      return;
    }

    const state = cell.attr("state");
    const orderItem = cell.find(".orderTableItem").first();
    const orders = (cell.attr("orders") || (orderItem.length ? (orderItem.attr("orders") || orderItem.attr("order") || orderItem.attr("orderId")) : "")) || fallbackOrders;
    const allorders = (cell.attr("allorders") || (orderItem.length ? (orderItem.attr("allorders") || "") : "")) || fallbackAllOrders;
    const timing = (orderItem.length ? readAttr(orderItem, ["timing"]) : "") || fallbackTiming;
    const orderSequenceNumber = (orderItem.length ? readAttr(orderItem, ["ordersequencenumber", "orderSequenceNumber"]) : "") || fallbackOrderSequenceNumber;
    const tableOccupation = (orderItem.length ? readAttr(orderItem, ["tableoccupation", "tableOccupation"]) : "") || fallbackTableOccupation;
    const tableNumber = (orderItem.length ? readAttr(orderItem, ["tablenumber", "tableNumber"]) : "") || fallbackTableNumber;

    if (!state || !orders) {
      return;
    }

    const countText = $.trim(cell.find(".mainrowtd, .orderrowtd").first().text());
    items.push({
      state: state,
      countText: countText,
      orders: orders,
      allorders: allorders,
      timing: timing,
      orderSequenceNumber: orderSequenceNumber,
      tableOccupation: tableOccupation,
      tableNumber: tableNumber
    });
  });

  // Some single-order layouts render only one state cell in the active row.
  // In that case derive states from table header/columns first, then fallback to full list.
  if (items.length <= 1) {
    const currentState = sourceCell.attr("state") || (items.length ? items[0].state : "");
    const payloadOrders = fallbackOrders || (items.length ? items[0].orders : "");
    const payloadAllOrders = fallbackAllOrders || (items.length ? items[0].allorders : "");
    const knownStates = (allstates2 && allstates2.length ? allstates2 : allstates).slice();
    const knownStateSet = new Set(knownStates);
    const configuredStatesRaw = orderListUtil && orderListUtil.statesShown;
    const configuredStates = (Array.isArray(configuredStatesRaw)
      ? configuredStatesRaw
      : (typeof configuredStatesRaw === "string" ? configuredStatesRaw.split(",") : []))
      .map(function (value) {
        return (value || "").trim();
      })
      .filter(function (stateName) {
        return !!stateName && knownStateSet.has(stateName);
      });
    const visibleStateSet = new Set();
    table.find("th[state],th[id],td.state[state]").each(function () {
      const cellOrHeader = $(this);
      if (!cellOrHeader.is(":visible")) {
        return;
      }

      const stateName = (cellOrHeader.attr("state") || cellOrHeader.attr("id") || "").trim();
      if (!stateName || !knownStateSet.has(stateName)) {
        return;
      }

      visibleStateSet.add(stateName);
    });

    const configuredVisibleStates = configuredStates.filter(function (stateName) {
      return visibleStateSet.size === 0 || visibleStateSet.has(stateName);
    });
    const statesFromTable = [];
    const seenStates = new Set();

    table.find("th[id],th[state],col[state]").each(function () {
      const header = $(this);
      const stateName = (header.attr("state") || header.attr("id") || "").trim();
      if (!stateName || !knownStateSet.has(stateName) || seenStates.has(stateName) || (visibleStateSet.size > 0 && !visibleStateSet.has(stateName))) {
        return;
      }

      seenStates.add(stateName);
      statesFromTable.push(stateName);
    });

    let stateCandidates = configuredVisibleStates.length > 0
      ? configuredVisibleStates
      : (statesFromTable.length > 1
        ? statesFromTable
        : (visibleStateSet.size > 0
          ? knownStates.filter(function (stateName) {
            return visibleStateSet.has(stateName);
          })
          : knownStates));
    if (currentState && stateCandidates.indexOf(currentState) === -1 && knownStateSet.has(currentState)) {
      stateCandidates = stateCandidates.concat([currentState]);
    }

    if (!payloadOrders) {
      return items;
    }

    return stateCandidates.map(function (stateName) {
      return {
        state: stateName,
        countText: stateName === currentState && items.length ? items[0].countText : "",
        orders: payloadOrders,
        allorders: payloadAllOrders,
        timing: fallbackTiming,
        orderSequenceNumber: fallbackOrderSequenceNumber,
        tableOccupation: fallbackTableOccupation,
        tableNumber: fallbackTableNumber
      };
    });
  }

  return items;
}

export const openOrderStatePopup = (sourceElement, event) => {

  /* we should limit this functionality to tablesOverview and pointOfSales screens, this depends on hash */
  if (!window.location.hash.startsWith("#/tablesOverview") && !window.location.hash.startsWith("#/pointOfSales")) {
    return;
  }

  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const sourceCell = $(sourceElement).closest("td.state");
  const $sourceElement = $(sourceElement);
  const sourceOrderItem = $(sourceElement).closest(".orderTableItem");
  const editableTarget = sourceOrderItem.length ? sourceOrderItem : sourceCell.find(".orderTableItem").first();
  const sourceOrders = sourceOrderItem.attr("orders") || sourceOrderItem.attr("order") || sourceOrderItem.attr("orderId") || sourceCell.attr("orders") || "";
  const sourceAllOrders = sourceOrderItem.attr("allorders") || sourceCell.attr("allorders") || "";
  const isHeaderClick = sourceCell.closest("tr.mainrow").length > 0;
  const forceTimingGroupPayload = isHeaderClick && (sourceCell.find(".mainrowtd").length > 0 || !!sourceAllOrders);
  const sourceState = sourceCell.attr("state");
  const showEditOption = !isHeaderClick && editableTarget.length > 0;
  const items = getOrderStatePopupItems(sourceCell, sourceElement);

  if (items.length === 1 && !showEditOption) {
    if ($(sourceElement).parents(".mainrow").length > 0) {
      return
    }
    const fallbackTarget = editableTarget.length ? editableTarget : $sourceElement;
    editOrder(fallbackTarget.get(0), event);
    return;
  }

  const distinctStates = Array.from(new Set(items.map(function (item) {
    return item.state;
  })));
  if (distinctStates.length <= 1) {
    const fallbackTarget = editableTarget.length ? editableTarget : $sourceElement;
    editOrder(fallbackTarget.get(0), {});
    return;
  }

  const popup = ensureOrderStatePopup();
  const track = popup.find(".order-state-popup-track");
  const headerEditButton = popup.find(".order-state-popup-edit");
  const html = [];

  headerEditButton.off("click");
  if (showEditOption) {
    const editOrderTitle = admin_local.edit_order;
    headerEditButton
      .text(editOrderTitle)
      .attr("aria-label", editOrderTitle)
      .removeClass("hidden")
      .on("click", function (clickEvent) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        popup.removeClass("open");
        const fallbackTarget = editableTarget.length ? editableTarget : $sourceElement;
        if (fallbackTarget.length) {
          editOrder(fallbackTarget.get(0), clickEvent);
        }
      });
  } else {
    headerEditButton.addClass("hidden");
  }

  items.forEach(function (item) {
    const effectiveOrders = forceTimingGroupPayload ? (sourceAllOrders || sourceOrders) : item.orders;
    const effectiveAllOrders = forceTimingGroupPayload ? sourceAllOrders : item.allorders;
    const parsedCount = Number(item.countText);
    const showCount = Number.isFinite(parsedCount) && parsedCount > 0;

    html.push(
      '<button type="button" class="order-state-popup-option state-' + item.state + (item.state === sourceState ? ' active' : '') + '" ' +
      'data-state="' + item.state + '" ' +
      'data-orders="' + effectiveOrders + '" ' +
      'data-allorders="' + effectiveAllOrders + '" ' +
      'data-timing="' + item.timing + '" ' +
      'data-order-seq="' + item.orderSequenceNumber + '" ' +
      'data-table-occupation="' + item.tableOccupation + '" ' +
      'data-table-number="' + item.tableNumber + '">' +
      '<div class="label">' + (local[item.state] || item.state) + '</div>' +
      (showCount ? '<div class="count">' + parsedCount + '</div>' : '') +
      '</button>'
    );
  });

  track.html(html.join(""));
  popup.addClass("open");

  track.off("click", ".order-state-popup-option");
  track.on("click", ".order-state-popup-option", function () {
    const option = $(this);
    const selectedState = option.attr("data-state");
    const allordersValue = option.attr("data-allorders") || "";
    const payloadMode = allordersValue ? "allorders" : undefined;

    if (!selectedState) {
      popup.removeClass("open");
      return;
    }

    const trigger = $("<div class=\"orderTableItem order order-state-popup-trigger hidden\"></div>")
      .attr("orders", option.attr("data-orders") || "")
      .attr("allorders", allordersValue)
      .attr("timing", option.attr("data-timing") || "")
      .attr("orderSequenceNumber", option.attr("data-order-seq") || "")
      .attr("tableOccupation", option.attr("data-table-occupation") || "")
      .attr("tableNumber", option.attr("data-table-number") || "")
      .attr("state", selectedState);

    $("body").append(trigger);

    if (selectedState === "cancelled") {
      const selectedOrderIds = (option.attr("data-orders") || "")
        .split(",")
        .map(function (value) {
          return (value || "").trim();
        })
        .filter(function (value) {
          return !!value;
        });

      let blockingPaymentState = false;
      selectedOrderIds.forEach(function (orderId) {
        if (blockingPaymentState) {
          return;
        }

        const order = getOrderById(orderId);
        if (!order) {
          return;
        }

        const tableMate = getTableMate(order.forWhomId);
        const tableOccupation = getTableOccupation(order?.tableOccupationId);
        const cancellable = tableOccupation?.bookedProperties?.cancellable;
        const payingMate = tableMate ? getTableMate(tableMate.payingMateId) : undefined;
        if (!cancellable && (order.paid || mateInState(payingMate, "wantsToPay"))) {
          blockingPaymentState = true;
        }
      });

      if (blockingPaymentState) {
        trigger.remove();
        popup.removeClass("open");
        return;
      }

      if (payloadMode) {
        trigger.attr("ordersPayloadMode", payloadMode);
      }
      trigger.attr("state", sourceState || "");

      const rejectionReasonModal = $("div#rejectionReason");
      rejectionReasonModal.one("hidden.bs.modal.orderStatePopupCleanup", function () {
        trigger.remove();
      });
      rejectionReasonModal.find("input#reasonText").val("");
      rejectionReasonModal.modal({
        focus: true,
        keyboard: false
      });
      orderListUtil.focusElement = trigger;
      rejectionReasonModal.modal("show");
      select($(rejectionReasonModal.find(".selectable[level=2]").get(0)));
      orderListUtil.revert = true;
      popup.removeClass("open");
      return;
    }

    const result = admin.processchangeStateByTableAndMenuItem(trigger[0], undefined, selectedState, undefined, "", undefined, update, undefined, payloadMode);
    if (result && typeof result.always === "function") {
      result.always(function () {
        trigger.remove();
      });
    } else {
      setTimeout(function () {
        trigger.remove();
      }, 1500);
    }
    popup.removeClass("open");
  });
}

SortedSet.find = (sortedSet, item) => {
  const node = sortedSet.findIterator(item).node;
  if (node != null && sortedSet.priv.comparator(node.value, item) == 0) return node.value;
  return null;

};

export const tablesOverview = {};

const { admin_local, local } = languages;

var showTableNumber = false;
if (typeof localStorage.extra_frame_left == "undefined") {
  localStorage.extra_frame_left = "";
  localStorage.extra_frame_right = "";
  localStorage.extra_frame_top = "";
  localStorage.extra_frame_bottom = "";
}

localStorage.removeItem("_editTable");

var command = "";

function startThisPoll() {
  if (this.props.myStatus.sessionId) {
    startpoll(orderListUtil.serverSideMessageHandler, [
      {
        Restaurant: localStorage.restaurantSelected,
        TableOccupation: "*"
      },
      {
        Restaurant: localStorage.restaurantSelected,
        Menu: "*"
      },
      {
        Restaurant: localStorage.restaurantSelected,
        Settings: "*"
      },
      {
        Restaurant: localStorage.restaurantSelected,
        Printer: "*"
      }
    ], undefined, recoverFromEventSourceError);
  }
}

export const fullReload = (props) => {
  tableLayout.reset();
  $("div#main").empty();
  ready(props);
}

var updateCycle;
var lockCycle;
var history;
var includableFrames;
var voipphone;
export const ready = (props, context, customServerSideMessageHandler) => {

  if (localStorage.instance == "null" || typeof localStorage.instance == "undefined" || localStorage.instance == null) {
    navigateToLogin();
    return;
  }


  orderListUtil.ordersTemplate = "ordersTemplate";
  orderListUtil.additionFilter = undefined;
  delete sessionStorage.productionLineSelected;
  setRem();
  voipphone = props.voipphoneSelected;
  if (auth.device.platform === "Android")
    scaleMeasure("Mérleg");

  auth.identityJustChecked = false;

  initSound();

  tablesOverview.selectedDate = moment().startOf("day").valueOf();

  tableSelectorHash = "";

  document.addEventListener("resume", recoverFromEventSourceError);

  includableFrames = {
    "": { name: admin_local.empty },
    "#/drinkbar": { name: admin_local.drinkbar },
    "#/kitchen": { name: admin_local.serving }
  };


  var def = $.Deferred();

  localStorage.removeItem("productionLineSelected");
  history = props.history;

  resetOrderListUtil();
  orderListUtil.serverSideMessageHandler = customServerSideMessageHandler || serverSideMessageHandler;
  ajaxCallStart("processing", 0);

  window.hideEditTable = hideEditTable;
  window.hideEditTable2 = hideEditTable2;
  window.avoidMultipleClick = avoidMultipleClick;
  window.unlockTable = unlockTable;
  window.tableMatePaid = tableMatePaid;
  window.editOrder = editOrder;
  window.isDuplicateClickEvent = isDuplicateClickEvent;
  window.editDiscounts = editDiscounts;
  window.getDiscount = getDiscount;
  window.selectNewOrders = selectNewOrders;
  window.markTableMateForPayment = markTableMateForPayment;
  window.checkPrint = checkPrint;
  window.admin = admin;
  window.update = update;
  window.getTable = getTable;
  window.setAmount = setAmount;
  window.addCashReceivedNote = addCashReceivedNote;
  window.clearCashReceivedAmount = clearCashReceivedAmount;
  window.toggleCashReturnCalculation = toggleCashReturnCalculation;
  window.refreshCashReturnFocusState = refreshCashReturnFocusState;
  window.moment = moment;
  window.gotoTop = gotoTop;
  window.orderMenuItem = orderMenuItem;
  window.additionSearchChanged = additionSearchChanged;
  window.submitNewOrders = submitNewOrders;
  window.unlockme = unlockme;
  window.changeToUser = changeToUser;
  window.cleanLogin = cleanLogin;
  window.relogin = relogin;
  window.showqrcode_to_link_teammate = showqrcode_to_link_teammate;
  window.setPrinterForPrinterAction = setPrinterForPrinterAction;
  window.unsetPrinterForProductionLine = unsetPrinterForProductionLine;
  window.printQRCode = printQRCode;
  window.setPrinterForProductionLine = setPrinterForProductionLine;
  window.unsetPrinterForPrinterAction = unsetPrinterForPrinterAction;
  window.setVoipphone = setVoipphone;
  window.avoidMultipleClick2 = avoidMultipleClick2;
  window.printNewOrders = printNewOrders;
  window.unlock = unlock;
  window.getProductionLine = getProductionLine;
  window.touchStart = touchStart;
  window.touchClick = touchClick;
  window.orderAnother = orderAnother;
  window.deleteOne = deleteOne;
  window.pickFrame = pickFrame;
  window.pickSkin = pickSkin;
  window.addRejectionReason = addRejectionReason;
  window.changeLayout = changeLayout;
  window.showTableOccupationList = showTableOccupationList;
  window.getMenuItem = getMenuItem;
  window.getTableMate = getTableMate;
  window.simpleChangeStateByTableAndMenuItem = simpleChangeStateByTableAndMenuItem;
  window.deactivateToggleRadioButton = deactivateToggleRadioButton;
  window.increase = increase;
  window.decrease = decrease;
  window.BookTable = BookTable;
  window.lockTable = lockTable;
  window.afterLockTable = afterLockTable;
  window.menuitemutil = menuitemutil;
  window.onsave = onsave;
  window.setTakeAway = setTakeAway;
  window.setTakeAwayOrder = setTakeAwayOrder;
  window.orderListUtil = orderListUtil;
  window.cancelOrders = cancelOrders;
  window.selectTableOccupation = selectTableOccupation;
  window.addAdditionalTable = addAdditionalTable;
  window.changeToTable = changeToTable;
  window.incrementTableMates = incrementTableMates;
  window.unjoinTableMate = unjoinTableMate;
  window.activateTableMate = activateTableMate;
  window.chooseCustomer = chooseCustomer;
  window.updateTableOccupations = updateTableOccupations;
  window.tableLayout = tableLayout;
  window.ajaxErrorEnd = ajaxErrorEnd;
  window.amountChanged = amountChanged;
  window.cashierChanged = cashierChanged;
  window.showNapiAjanlatDialog = showNapiAjanlatDialog;
  window.showMenuItemAvailabilityDialog = showMenuItemAvailabilityDialog;
  window.checkPayments = checkPayments;
  window.getMenuCategoryOptions = getMenuCategoryOptions;
  window.getMenuCategory = getMenuCategory;
  window.additionOptionIsChecked = additionOptionIsChecked;
  window.additionOptionIsIncluded = additionOptionIsIncluded;
  window.updateOrders = updateOrders;
  window.chooseMenuItems = chooseMenuItems;
  window.settingEnabled = settingEnabled;
  window.tableReadyForDelivery = tableReadyForDelivery;
  window.selectCurrency = selectCurrency;
  window.bookTable = bookTable;
  window.includedInCategoryOption = includedInCategoryOption;
  window.showMap = showMap;
  window.toggleSound = toggleSound;
  window.scaleMeasure = scaleMeasure;
  window.setSelectedScale = setSelectedScale;
  window.createNewPartner = createNewPartner;
  window.getQuantityLabel = getQuantityLabel;
  window.getActiveMenuItems = activeMenuItems;
  window.getActiveMenuCategories = activeMenuCategories;
  window.switchKeyboard = switchKeyboard;
  window.insertCharacter = insertCharacter;
  window.insertEnter = insertEnter;
  window.backspaceCharacter = backspaceCharacter;
  window.leftCharacter = leftCharacter;
  window.rightCharacter = rightCharacter;
  window.clearInput = clearInput;
  window.featureEnabled = featureEnabled;
  window.customerDblClickHandler = customerDblClickHandler;
  window.printDailyClosing = printDailyClosing;
  window.updateTimeahead = updateTimeahead;
  window.settings = settings;
  window.showPayments = showPayments;
  window.printReceipt = printReceipt;
  window.reprintInvoice = reprintInvoice;
  window.reprintReceipts = reprintReceipts;
  window.reprintReceipt = reprintReceipt;
  window.dayOpen = dayOpen;
  window.dayClose = dayClose;
  window.dayCloseReprint = dayCloseReprint;
  window.storno = storno;
  window.cashin = cashin;
  window.cashout = cashout;
  window.playClickSound = playClickSound;
  window.getInputDialog2 = getInputDialog2;
  window.getInputDialog = getInputDialog;
  window.updateBookingComment = updateBookingComment;
  window.updateBookingUserComment = updateBookingUserComment;
  window.registerTip = registerTip;
  window.stornoReceipt = stornoReceipt;
  window.reprintReceipts = reprintReceipts;
  window.selectTerminal = selectTerminal;
  window.get = get;
  window.sendMessage = auth.sendMessage;
  window.getTableName = getTableName;
  window.capturePhotoWithData = capturePhotoWithData;
  window.incomingCallChanged = incomingCallChanged;
  window.lighten = lighten;
  window.increasePersonCount = increasePersonCount;
  window.decreasePersonCount = decreasePersonCount;
  window.toggleShowState = toggleShowState;
  window.maptoggleShowState = maptoggleShowState;
  window.centerTableOccupationOnMap = centerTableOccupationOnMap;
  window.callANumber = callANumber;
  window.isHomeDelivery = isHomeDelivery;
  window.isPickup = isPickup;
  window.setBookedPaymentMethod = setBookedPaymentMethod;
  window.setBookingComment = setBookingComment;
  window.setUserComment = setUserComment;
  window.setServiceFee = setServiceFee;
  window.addAllergenComment = addAllergenComment;
  window.payit = payit;
  window.processchangeStateByTableAndMenuItem = admin.processchangeStateByTableAndMenuItem;
  window.update = update;
  window.lock = lock;
  window.getTableOccupation = getTableOccupation;
  window.toggleCustomerScreen = toggleCustomerScreen;
  window.showCustomerScreen = showCustomerScreen;
  window.ensureOrderStatePopup = ensureOrderStatePopup;
  window.getOrderStatePopupItems = getOrderStatePopupItems;
  window.openOrderStatePopup = openOrderStatePopup;


  tableLayout.reset();

  selectTableNumberSelected(0);
  $("div#editTableData").remove();
  $("div#editRoom").remove(); 
  $("script#editTableTemplate").tmpl(props).appendTo("div#main");
  $("script#editRoomTemplate").tmpl(props).appendTo("div#main");

  initEditTable();
  //resetCustomerScreen();




  var searchTimeout = null;

  try {
    tableLayout.reset();

    tablesOverview.context = context;

    orderListUtil.ai = props.ai;

    props.ai.setContext({ page: "tables-overview", tableOccupation: null });
    orderListUtil.processOrdersDone = processOrdersDone;
    orderListUtil.updateOrdersDone = updateOrdersDone;
    orderListUtil.show = show;
    orderListUtil.filter = filter;
    orderListUtil.orderAnother = orderAnother;
    orderListUtil.deleteOne = deleteOne;
    orderListUtil.tablesOverview = true;
    orderListUtil.keyDownHandler = keyDownHandler;
    orderListUtil.hideSelectNewOrders = hideSelectNewOrders;
    orderListUtil.processRestaurant = processRestaurant;
    orderListUtil.startThisPoll = startThisPoll;
    delete sessionStorage._editTable;

    orderListUtil.states = allstates;
    orderListUtil.statesShownOriginal = orderListUtil.statesShown = auth.myStatus.restaurant_settings["tables-overview"].statesShown;
    orderListUtil.hidePaid = auth.myStatus.restaurant_settings["tables-overview"]["hide-paid-state"];

    auth.resize = resize;

    if (typeof auth.myStatus.restaurant_id == "undefined") {
      navigateToLogin();
      return;
    }


    // $('#restaurantStyle').text(auth.myStatus.restaurant_css);

    $("script#tablesOverviewMainTemplate")
      .tmpl({ ...orderListUtil.props, ...tmplparams() })
      .appendTo("div#main");
    $("#editTable #right_pane .keyboard").hide();
    $(".bar").replaceWith($("script#tablesOverviewBarTemplate").tmpl({ includableFrames: includableFrames, ...tmplparams() }));
    loadMyImage();
    ReactDOM.render(<Softphone store={store} />, $("#softphonePlaceholder").get(0));
    // the edit table view covers the page header, so it needs its own mic button; the panel itself belongs to the header one
    if ($("#voiceOrderPlaceholder").get(0)) {
      if (hasRole(["superadmin"])) ReactDOM.render(<VoiceOrderButton withPanel={false} />, $("#voiceOrderPlaceholder").get(0));
      else $("#voiceOrderPlaceholder").remove();
    }

    const customerScreenState = store.getState().rootReducer.customerScreen;
    if (customerScreenState.showCustomerScreen && (customerScreenState.customerScreen || customerScreenState.session)) {
      $("#customerScreenButton").addClass("active");
    } else {
      $("#customerScreenButton").removeClass("active");
    }


    tableLayout.constuctor();

    ajaxCallEnd("processing");

    ajaxCallStart("processing2", 0);
    try {
      ajaxCallStart("processing21");
      admin.getTables(function (tableLayouts) {
        try {
          tableLayout.tables = tableLayouts.restaurantTables;
          tableLayouts.restaurantTables.forEach(function (table) {
            tableLayout.tableMap.set(Number(table.number), table);
          });

          orderListUtil.pointOfSales = [];

          tableLayout.tables.forEach(table => {
            if (table.pos == true) orderListUtil.pointOfSales.push(table);
          });

          ajaxCallStart("processing3", 0);
          processRestaurant();

          def.resolve(tablesOverview, tableLayout);
        } finally {
          ajaxCallEnd("processing21");
        }
      });

      //const incomingcall = $("div#incomingcall");
      if (auth.incomingcall)
        $("#incomingcall").addClass("active");

      updateCheckBoxesById($("input#incomingcall"));

      // canvas = new fabric.Canvas('c');
      // canvas.selection = true; // disable group selection

      // initializeLayout();

      resize(1);
    } catch (ex) {
      alert(ex);
    }

    $("#language.dropdown-menu").empty();
    auth.myStatus.restaurant_languages.forEach(function (lang) {
      $("#language.dropdown-menu").append('<button onclick="pickLanguage(&quot;' + lang + '&quot;)"  class="dropdown-item">' + lang + "</button>");
    });
    $("button#language").text(localStorage.language);
    admin.getPrintersStatus(updatePrintersStatus);

    function updateCycl() {
      if (orderListUtil.dragged || orderListUtil.drag) return;
      if (orderListUtil.allOrders.tables && orderListUtil.allOrders.tables.find(table => table.stateMap["ordered"].length > 0)) {
        playNewAcceptedOrderSound();
      }
      if (featureEnabled("inventory") && featureEnabled("inventory/capacityCheck")) {
        get(`adminService/${localStorage.restaurantSelected}/getCapacity`, undefined, undefined, undefined, false).done(data => {
          const dataMap = data.reduce((acc, item) => {
            acc[item.i + "-" + item.q] = item;
            return acc;
          }, {});
          store.dispatch(EatWithMeActions.setCapacity(dataMap));
        }).fail(() => {
          auth.ajaxError = false;
        });
      }


      if (sessionStorage._editTable === "true") {
        updateTableOccupationSelector();
        return;
      }

      if (typeof orderListUtil.ordersCache != "undefined" && typeof admin.tableMates != "undefined") {
        if (auth.myStatus.restaurant_id > 0) {
          var selected = $(".selectable.selected");
          orderListUtil.processAllOrdersDone = false;
          processAllOrders(orderListUtil.ordersCache);
          if (orderListUtil.tablesOverview) {
            const now = new Date().getTime();

            var decorationTime = tableLayout.updateTableOccupations();
            //console.log("updateTableOccupations", new Date().getTime() - now);
            !auth.minspeed && (auth.minspeed = 100000);
            !auth.maxspeed && (auth.maxspeed = 0);
            $('#updateLabel').html((auth.speed = new Date().getTime() - now) + " (" + decorationTime + ")");
            auth.minspeed = Math.min(auth.minspeed, auth.speed);
            auth.maxspeed = Math.max(auth.maxspeed, auth.speed);
          }
        }
      }
    }

    //eslint-disable-next-line no-restricted-globals
    updateCycle = setInterval(updateCycl, location.port == 3000 ? 5000 : 10000);


    const pickupNumber = getPickupTableNumber();
    const homeDeliveryNumber = getHomeDeliveryTableNumber();

    const freezelock = $("#freezelock");

    lockCycle = setInterval(function () {
      if (auth.myStatus.restaurant_settings["tables-overview"].timeout) {
        const countdown = Math.max(0, Math.round(auth.myStatus.restaurant_settings["tables-overview"].timeout - (new Date().getTime() - auth.lastEventTimestamp) / 1000));
        if (countdown < auth.myStatus.restaurant_settings["tables-overview"].timeout) {
          freezelock.html("<span>" + countdown + "s</span>");
        } else
          freezelock.html("");
        if (countdown < 5) {
          freezelock.css("background", "red");
          freezelock.css("color", "white");
        } else if (countdown < 10) {
          freezelock.css("background", "orange");
          freezelock.css("color", "");
        } else {
          freezelock.css("background", "");
          freezelock.css("color", "");
        }
      }
      if (freezelock.hasClass("icon-lock")) {
        freezelock.html("");
        freezelock.css("background", "");
        freezelock.css("color", "");
        return;
      }
      if (window.mobileAndTabletcheck()) return;
      if (localStorage.selectNewOrders == "true") return;
      if ($(".modal.markTableMateForPayment.show").length > 0) return;
      if ($("#tableMatePaid.modal.show").length > 0) return;
      if ($(".modal.splitInvoice.show").length > 0) return;
      if (sessionStorage.tableNumberSelected == pickupNumber || sessionStorage.tableNumberSelected == homeDeliveryNumber) return;
      if (auth.myStatus && auth.myStatus.restaurant_settings && auth.myStatus.restaurant_settings["tables-overview"].timeout > 0 && new Date().getTime() - auth.lastEventTimestamp > auth.myStatus.restaurant_settings["tables-overview"].timeout * 1000) {
        lock();
        auth.lastEventTimestamp = undefined;
      }
    }, 1000);

  } finally {
    ajaxCallEnd("processing2");
  }

  return def;
}

export const initEditTable = () => {
  $("#editTableData").on("shown.bs.modal", () => {
    Object.keys(tableLayout.tableTemplates).forEach(key => {
      const svg = $("#editTableData .svg label#" + key + " svg");
      svg.html(tableLayout.tableTemplates[key].svg);
      const t = svg.find(".eatwithme-table");
      t.off("click");
      t.off("mousedown");
      t.removeClass("eatwithme-table");
      t.removeClass("ui-draggable");
      svg.find(".selectable").removeClass("selectable");
      t.removeClass("ui-draggable-handle");
      const s = svg.find(".eatwithme-seat-number");
      s.off("click");
      s.off("mousedown");
      s.off("remove");
      s.removeClass("eatwithme-seat-number");
      s.removeClass("ui-draggable");
      s.removeClass("ui-draggable-handle");
    })
    const svg = $("#editTableData .svg label svg");
    svg.each((ind, svg) => {
      svg = $(svg);
      svg.parent().parent().off("click");
      const g = svg.find(">g");
      g.find("text").remove();
      const rect = g.get(0).getBBox();
      svg.attr("viewBox", rect.x + " " + rect.y + " " + rect.width + " " + rect.height);
      svg.attr("width", rect.width);
      svg.attr("height", rect.height);
    })

  });
}

function recoverFromEventSourceError(recovery = true, clearCache = false) {
  ajaxCallStart("processing3", 0);
  orderListUtil.processRestaurant && orderListUtil.processRestaurant(recovery, false, clearCache);
}

export const changeLayout = id => {
  admin.updateFloorPlan(id, function () {
    auth.myStatus.restaurant_active_floorplan = id;
    if (orderListUtil.tablesOverview) {
      tableLayout.renderLayoutModeControls();
      $(".floorplan-picker").removeClass("checked");
      $("#" + id + ".floorplan-picker").addClass("checked");
    }
  });
};

var canvas = null;
var activeObject = null;
var editPoints = null;
var editMode = false;

var tableSelectorMap = {}
var tableSelectorHash = "";
var tableSelectorHashTableNumber = ""

function updateTableOccupationSelector(first) {
  if (orderListUtil.noSelector === true)
    return;

  var selector = $("#tableOccupation-selector");
  const printAllLabelsEnabledForSelector = canPrintHomeDeliveryLabels() && isLabelPrintingTable();
  selector.toggleClass("print-all-labels-enabled", !!printAllLabelsEnabledForSelector);

  if (!getNonLocalPrinterForPrinterAction("printInvoice"))
    selector.addClass("no-invoice-printing");

  if (!auth.myStatus.restaurant_production_lines.find(pl => getPrinterForProductionLine(pl))) {
    selector.addClass("no-block-printing");
  }

  var selectorulold = $("#tableOccupation-selector > ul");

  if (sessionStorage.tableNumberSelected != tableSelectorHashTableNumber) {
    tableSelectorHash = "";
    selectorulold.empty();
  }
  tableSelectorHashTableNumber = sessionStorage.tableNumberSelected;

  //tableSelectorMap = {};

  if (!$("#tableOccupation-selector-map").hasClass("hidden")) {
    showMap(true);
  }

  const now = new Date().getTime();

  const checked = $("#tableOccupation-selector > ul > li input.custom-control-input:checked");

  $("body > *[role='tooltip']").remove();

  var selectorul = $("<ul class='nav nav-tabs.nav-tabs--vertical nav-tabs--left' role='navigation'/>");

  const pickupTableNumber = getPickupTableNumber();
  const homeDeliveryTableNumber = getHomeDeliveryTableNumber();

  if (orderListUtil.occupationsSelected.length > 1 || sessionStorage.tableNumberSelected == pickupTableNumber || sessionStorage.tableNumberSelected == homeDeliveryTableNumber) {
    $(selector).show();

    orderListUtil.occupationsSelected.sort(function (a, b) {
      const aNumber = a.restaurantTables[0].restaurantTable.number;
      const bNumber = b.restaurantTables[0].restaurantTable.number;
      const aIsScheduled = aNumber == pickupTableNumber || aNumber == homeDeliveryTableNumber;
      const bIsScheduled = bNumber == pickupTableNumber || bNumber == homeDeliveryTableNumber;
      var atime = a.occupationStart != null && !aIsScheduled ? a.occupationStart : a.bookedOccupationStart;
      var btime = b.occupationStart != null && !bIsScheduled ? b.occupationStart : b.bookedOccupationStart;
      return atime - btime;
    });

    var lastTime = null;

    function sortit(a, b) {
      if (moment(a.date).startOf("day").valueOf() != moment(b.date).startOf("day").valueOf())
        return a.date - b.date;
      if (a.deliveredById && !b.deliveredById)
        return -1;
      else if (!a.deliveredById && b.deliveredById)
        return 1;

      if (a.deliveredById != b.deliveredById) {
        return a.deliveredById - b.deliveredById;
      }

      if (a.deliveredById != null && b.deliveredById != null) {
        if (a.deliveredByIndex != b.deliveredByIndex) {
          return a.deliveredByIndex - b.deliveredByIndex;
        }
      }
      if (a.date != b.date)
        return a.date - b.date;

      return a.tableOccupation - b.tableOccupation;
    }

    var deliveredById = undefined;

    const occupationsShown = [];

    //const occupations = 

    const occupations = [];

    const isDelivery = isHomeDelivery() || isPickup();

    /*
    const selectedOccupationIds = new Set(orderListUtil.occupationsSelected.map(o => o.id));

    orderListUtil.allOrders.tables.forEach(t => {
      if (selectedOccupationIds.has(t.tableOccupation)) {
        const date = t.bookedProperties?.bookedOccupationStart || t.occupationStart;
        const alreadyExists = occupations.some(
          oo => (!isDelivery || oo.date === date) && oo.tableOccupation === t.tableOccupation
        );

        if (!alreadyExists) {
          occupations.push(t);
        }
      }
    });*/

    orderListUtil.allOrders.tables.filter(t => orderListUtil.occupationsSelected.filter(o => o.id === t.tableOccupation).length).forEach(o => {
      const date = o.bookedProperties && o.bookedOccupationStart ? o.bookedOccupationStart : o.occupationStart;
      if (!occupations.find(oo => (!isDelivery || oo.date == date) && oo.tableOccupation == o.tableOccupation)) {
        occupations.push(o);
      }
    });


    orderListUtil.occupationsSelected.filter(o => !occupations.find(oo => oo.tableOccupation === o.id)).forEach(o => {
      const date = o.bookedProperties && o.bookedOccupationStart ? o.bookedOccupationStart : o.occupationStart;
      //if (!occupations.find(oo => oo.date == date && oo.tableOccupation == o.tableOccupation)) {
      if (!occupations.find(oo => (!isDelivery || oo.date == date) && oo.tableOccupation == o.tableOccupation)) {
        occupations.push({
          tableOccupation: o.id,
          tableNumber: o.restaurantTables[0].restaurantTable.number,
          date: date,
          created: date,
          price: 0,
          orderIds: [],
          stateMap: {
            accepted: [],
            producing: [],
            ready: [],
            delivering: [],
            delivered: [],
            ordered: [],
            cancelled: []
          },
          forWhomId: o.tableMates.length > 0 ? o.tableMates[0].id : 0
        });
      }
    });

    const occupations2 = {};

    const date = moment().startOf("day").valueOf();
    const todayTableOccupations = occupations.filter(occupation => moment(occupation.date).startOf("day").valueOf() === date);

    occupations.filter(o => localStorage.selectNewOrders !== "true" || o.forWhomId).sort(sortit).forEach(o => {
      //o = getTableOccupation(o.tableOccupation);
      if (occupationsShown.indexOf(o.tableOccupation + "-" + moment(o.date).startOf("day").valueOf()) !== -1) {
        const oo = occupations2[o.tableOccupation + "-" + moment(o.date).startOf("day").valueOf()];
        o.orderIds.forEach(p => oo.orderIds.push(p));
        Object.keys(o.stateMap).forEach(key => {
          oo.stateMap[key] = [...oo.stateMap[key], ...o.stateMap[key]];
        });
        oo.printFailed += o.printFailed;
        oo.beingprinted += o.beingprinted;
        oo.partprinted += o.partprinted;
        oo.printed += o.printed;
        oo.unprinted += o.unprinted;
        return;
      }
      occupationsShown.push(o.tableOccupation + "-" + moment(o.date).startOf("day").valueOf());
      const oo = { ...o };
      if (oo.orderIds)
        oo.orderIds = [...oo.orderIds];
      if (oo.stateMap)
        oo.stateMap = JSON.parse(JSON.stringify(oo.stateMap));
      occupations2[o.tableOccupation + "-" + moment(o.date).startOf("day").valueOf()] = oo;
    });

    const occs = Object.values(occupations2).sort(sortit);

    const v = occs.map(o => {
      const occupation = getTableOccupation(o.tableOccupation);
      if (!occupation || occupation.occupationStart == null && (now - occupation.bookedOccupationStart) / 60000 > auth.myStatus.restaurant_settings["enabled-features"].prebooking.maxLateDuration) {
        return null;
      }
      return occupation.id + "-" + o.date + "-" + occupation.modificationTimeStamp;
    }).filter(o => o).join(",");

    if (tableSelectorHash !== v) {
      tableSelectorHash = v;

      occs.sort(sortit).forEach(o => {

        const occupation = getTableOccupation(o.tableOccupation);

        if (!occupation)
          return;
        var now = new Date().getTime();

        if (occupation.occupationStart == null && (now - occupation.bookedOccupationStart) / 60000 > auth.myStatus.restaurant_settings["enabled-features"].prebooking.maxLateDuration) {
          return;
        }

        occupation.restaurantTables.forEach(function (restaurantTableOccupation) {
          var number = restaurantTableOccupation.restaurantTable.number;

          const aIsScheduled = number === pickupTableNumber || number === homeDeliveryTableNumber;
          var start = o.date; //.occupation.occupationStart != null && !aIsScheduled ? occupation.occupationStart : occupation.bookedOccupationStart;
          var end = o.date; //occupation.occupationEnd != null && !aIsScheduled ? occupation.occupationEnd : occupation.bookedOccupationEnd ? occupation.bookedOccupationEnd : occupation.bookedOccupationStart;
          //var occupationStart = occupation.occupationStart != null && !aIsScheduled ? occupation.occupationStart : occupation.bookedOccupationStart;
          //var occupationEnd = occupation.occupationEnd != null && !aIsScheduled ? occupation.occupationEnd : occupation.bookedOccupationEnd ? occupation.bookedOccupationEnd : occupation.bookedOccupationStart;

          const isPickupTable = number == pickupTableNumber;
          const isHomeDeliveryTable = number == homeDeliveryTableNumber;
          if (isPickupTable || isHomeDeliveryTable) {

            if (occupation.occupationStart == null && !occupation.bookedOccupationStart)
              return;
            /*
          if (moment(o.date).startOf("day").valueOf() === moment(occupationStart).startOf("day").valueOf()) {
            start = occupationStart;
            end = occupationEnd;
          }
          */
          } else {
            /*
            start = occupationStart;
            end = occupationEnd;
            */
          }

          if (number == sessionStorage.tableNumberSelected) {
            if (start) {

              if (lastTime === null || lastTime !== moment(start).format("YYYY-MMM-DD")) {

                const count = countTableOccupationTablesForTableAndDate(occs, sessionStorage.tableNumberSelected, moment(start).startOf("day"));


                const prevInstance = tableSelectorMap["header-" + sessionStorage.tableNumberSelected + "-" + moment(o.date).startOf("date").valueOf() + "-" + count];
                if (false && prevInstance) {
                  $(selectorul).append(prevInstance.d1.clone());
                  $(selectorul).append(prevInstance.d2.clone());

                } else {
                  const startOfDay = moment(o.date).startOf("day").valueOf();
                  var $li1 = makeElement("li", { class: "nav-item separator ", date: startOfDay });
                  var states = [
                    { state: 'ordered', class: 'new-orders', tooltip: 'admin_local.tooltip.header_filter_new_incoming_order' },
                    { state: 'accepted', class: 'accepted', tooltip: 'admin_local.tooltip.header_filter_accepted_order' },
                    { state: 'producing', class: 'producing', tooltip: 'admin_local.tooltip.header_filter_order_in_production' },
                    { state: 'ready', class: 'ready', tooltip: 'admin_local.tooltip.header_filter_order_ready' },
                    { state: 'assigned', class: 'assigned', tooltip: 'admin_local.tooltip.header_filter_order_assigned' },
                    { state: 'delivering', class: 'delivering', tooltip: 'admin_local.tooltip.header_filter_order_under_delivering' },
                    { state: 'delivered', class: 'delivered', tooltip: 'admin_local.tooltip.header_filter_order_delivered' }
                  ];

                  let stateSelectors = `<div class='stateSelectors'>`;

                  states.forEach(({ state, class: className, tooltip }) => {
                    stateSelectors += `
                      <div state='${state}' onClick='toggleShowState(event)' 
                           class='t-state ${className} ${localStorage["mapShowState" + state] == "true" ? "active" : ""}' 
                           data-placement='top' 
                           data-toggle='tooltip' 
                           title='${I18n.t(tooltip)}'>
                      </div>`;
                  });

                  stateSelectors += `</div>`;

                  let mapStateSelectors = `<div class='mapStateSelectors'>`;

                  states.forEach(({ state, class: className, tooltip }) => {
                    mapStateSelectors += `
                      <div state='${state}' onClick='maptoggleShowState(event)' 
                           class='t-state ${className} ${localStorage["mapmapShowState" + state] == "true" ? "active" : ""}' 
                           data-placement='top' 
                           data-toggle='tooltip' 
                           title='${I18n.t(tooltip)}'>
                      </div>`;
                  });

                  mapStateSelectors += `</div>`;

                  const formattedDate = moment(startOfDay).format("YYYY-MMM-DD dddd");

                  $($li1).html(`${stateSelectors}${mapStateSelectors}<a class='date-header' id='header${startOfDay}'><div class='date' style=''>${formattedDate}</div><div class='count'>${count}</div></a>`);

                  const homeDeliveryMode = isHomeDelivery(sessionStorage.tableNumberSelected);
                  const pickupMode = isPickup(sessionStorage.tableNumberSelected);
                  const printAllLabelsEnabled = (homeDeliveryMode || pickupMode) && canPrintHomeDeliveryLabels();
                  var $li = makeElement("li", { class: "nav-item group-functions new-orders accepted producing ready delivering delivered " + (isPickupTable ? "pickup" : isHomeDeliveryTable ? "homedelivery" : "") });
                  let groupPart = `<a class='nav-link'>
                    <div onClick="event.stopPropagation()" class="custom-control custom-checkbox" style="display: flex; justify-content: center; padding-left: 2.5rem !important;">
                    <input type="checkbox" class="custom-control-input" id="s${startOfDay}" date="${startOfDay}"/>
                    <label class="custom-control-label" for="s${startOfDay}"></label>
                    </div>`;

                  var states = [
                    { state: 'ordered', class: 'new-orders', tooltip: 'admin_local.tooltip.header_new_incoming_order' },
                    { state: 'accepted', class: 'accepted', tooltip: 'admin_local.tooltip.header_accepted_order' },
                    { state: 'producing', class: 'producing', tooltip: 'admin_local.tooltip.header_order_in_production' },
                    { state: 'ready', class: 'ready', tooltip: 'admin_local.tooltip.header_order_ready' },
                    { state: 'delivering', class: 'delivering', tooltip: 'admin_local.tooltip.header_order_under_delivering' },
                    { state: 'delivered', class: 'delivered', tooltip: 'admin_local.tooltip.header_order_delivered' }
                  ];

                  states.forEach(({ state, class: className, tooltip }) => {
                    groupPart += `<div state='${state}' class='t-state ${className}' data-placement='top' data-toggle='tooltip' title='${I18n.t(tooltip)}'></div>`;
                  });

                  groupPart += `<div class='seqnr'></div>
                                <div class='dummy'></div>
                                <div class='deliveryUsers' data-placement='top' data-toggle='tooltip' title='${I18n.t("admin_local.tooltip.couriers")}'>${hasRole("sales.homedelivery.assigntocourier") ? I18n.t("admin_local.couriers") : ""}</div>
                                <div id="chooseOption" class="deliveryUsers">
                                <ul class="list-group radio-list-box">
                                ${tablesOverview.context && hasRole("sales.homedelivery.assigntocourier") ? tablesOverview.context.props.deliveryUsers.sort((a, b) => a.name.localeCompare(b.name)).map(
                    user => {
                      const count = new Set(todayTableOccupations.filter(o => o.courierId === user.id).map(t => t.tableOccupation)).size;
                      const done = new Set(todayTableOccupations.filter(o => o.courierId === user.id && o?.stateMap?.delivered?.length > 0).map(t => t.tableOccupation)).size;

                      return `<div class="courier-state-f"><input class="courier" type="radio" id="check${o.date}-${user.id}" name="coption${o.date}">
                            <div class='courier courier-state-${user.courierState}' courier='${user.id}'/>
                                  <label style="background-color:${user.backgroundColor};color:${user.color}" courier="${user.id}" class="courier list-group-item" for="check${o.date}-${user.id}" data-toggle="tooltip" title="${I18n.t("admin_local.tooltip.link_courier")}">${user.name}</label><span class="courier-progress">${done} / ${count}</span></div>`
                    }).join("") : ""}
                                </ul>
                                </div>
                                <div class='pr print' data-placement='top' data-toggle='tooltip' title='${I18n.t("admin_local.tooltip.header_print_receipt")}'></div>
                                ${printAllLabelsEnabled ? "<div class='label-printer icon-printer' aria-hidden='true'>&nbsp;</div>" : ""}
                                <div class='invoice' data-toggle='tooltip' title='${I18n.t("admin_local.tooltip.header_print_invoice")}'></div>
                                <div class='dollar'></div>
                                <div class='unlock' data-toggle='tooltip' title='${I18n.t("admin_local.tooltip.header_unlock")}'></div>
                                </a>`;


                  $li = $($li);

                  $li.data("date", startOfDay);

                  $li.html($(groupPart));

                  $li.find("input#" + o.date + ".custom-control-input").on("change", event => {
                    $("li[date='" + event.currentTarget.id + "'] input.custom-control-input").prop('checked', event.currentTarget.checked);
                  })

                  $li.attr("id", startOfDay);

                  Object.keys(tableSelectorMap).forEach(key => {
                    if (key.split("-")[0] === "header") {
                      var d = key.split("-")[1];
                    }
                  });

                  tableSelectorMap["header-" + sessionStorage.tableNumberSelected + "-" + moment(o.date).startOf("date").valueOf() + "-" + count] = { d1: $($li1).clone(), d2: $($li).clone() };
                  $(selectorul).append($li1);
                  $(selectorul).append($li);

                }

              }


              lastTime = moment(start).format("YYYY-MMM-DD");

              const prevInstance = tableSelectorMap[o.date + "-" + o.tableOccupation];
              if (prevInstance && prevInstance.t === getMaxModificationTimeStamp(occupation)) {
                $(selectorul).append(prevInstance.d);
                if (tablesOverview.selectedDate !== o.date)
                  $(prevInstance.d).addClass("hidden");
                setData(prevInstance.d, o);
                return;
              }


              var $a = makeElement("a", {
                //href: '#maintab',
                style: "text-align:center;font-weight:bold;transform: unset;top:0%",
                class: "nav-link ",
                id: occupation.id,
                onclick: "selectTableOccupation(" + occupation.id + ", event)",
                //'data-toggle': 'tab',
                role: "tab",
                "aria-controls": "maintab"
              });
              var text = `
                <div class="custom-control custom-checkbox d-flex justify-content-center pl-4" onclick="event.stopPropagation()">
                  <input type="checkbox" class="custom-control-input" data-delivery-id="${o.deliveredById}" id="${o.tableOccupation}-${o.date}" />
                  <label class="custom-control-label" for="${o.tableOccupation}-${o.date}"></label>
                </div>`;


              //$($a).on("mouseenter", (event) => { selectTableOccupation(occupation.id, event) })


              var stateMap = o.stateMap;


              var cancelled = false;
              var clazz = (isPickupTable ? " pickup" : isHomeDeliveryTable ? " homedelivery" : "");
              var clazz2 = '';
              var states = ['accepted', 'producing', 'ready', 'delivering', 'delivered', 'ordered'];

              if (stateMap) {
                states.forEach(state => {
                  if (stateMap[state] && stateMap[state].length > 0) {
                    clazz2 += ` ${state === 'ordered' ? 'new-orders' : state}`;
                  }
                });

                if (!clazz2 && stateMap['cancelled'] && stateMap['cancelled'].length) {
                  clazz2 = ' cancelled';
                  cancelled = true;
                }
              }

              if (o.courierId || occupation?.bookedProperties?.woltDelivery) clazz2 += " assigned";


              clazz += clazz2;

              var states = [
                { state: 'ordered', class: 'new-orders', tooltip: 'set_new_incoming_order' },
                { state: 'accepted', class: 'accepted', tooltip: 'set_accepted_order' },
                { state: 'producing', class: 'producing', tooltip: 'set_order_in_production' },
                { state: 'ready', class: 'ready', tooltip: 'set_order_ready' },
                { state: 'delivering', class: 'delivering', tooltip: 'set_order_under_delivering' },
                { state: 'delivered', class: 'delivered', tooltip: 'set_order_delivered' }
              ];

              states.forEach(({ state, class: className, tooltip }) => {
                text += `<div state='${state}' class='t-state ${className}' ${!cancelled ? `data-placement='top' data-toggle='tooltip' title='${I18n.t("admin_local.tooltip." + tooltip)}'` : ''
                  }></div>`;
              });


              var cdate = undefined;

              const date = moment(o.date).startOf("day").valueOf();
              const minmax = orderListUtil.allOrders.tables.filter(t => t.tableOccupation === o.tableOccupation).map(t => t.date.valueOf()).reduce((a, b) => { return { min: a.min == null ? b : Math.min(a.min, b), max: a.max == null ? b : Math.max(a.max, b) } }, { min: null, max: null });
              if (occupation.bookedProperties && occupation.bookedProperties.installments_strategy)
                switch (occupation.bookedProperties.installments_strategy) {
                  case "start":
                    if (date === minmax.min) {
                      cdate = undefined;
                    } else {
                      cdate = date;
                    }
                    break;
                  case "by_each":
                    cdate = o.date;
                    break;
                  case "end":
                    if (date === minmax.max) {
                      cdate = undefined;
                    } else {
                      cdate = date;
                    }
                    break;
                }




              const image = orderListUtil.occupationsSelected?.length > 5 && occupation.leadCustomerId !== 0 && getTableMate(occupation.leadCustomerId)?.tableMate && getTableMate(occupation.leadCustomerId).tableMate.hasImage ? "<img src='" + getImageById(getTableMate(occupation.leadCustomerId).tableMate.id) + "'/>" : "";
              if (restaurantTableOccupation.tableMateIds.length)
                clazz += " " + getTableMate(restaurantTableOccupation.tableMateIds[0]) ? getTableMate(restaurantTableOccupation.tableMateIds[0]) && getTableMate(restaurantTableOccupation.tableMateIds[0]).states.reduce((a, b) => a + " " + b.state, "") + " " : "";

              var thirdPartyOrder = occupation?.bookedProperties?.["thirdparty-order-number"];
              const platform = occupation?.bookedProperties?.platform || "";
              const seqnr = occupation?.seqnr;
              const startDateFormatted = moment(start).format("YYYY-MMM-DD");
              const todayFormatted = moment().format("MMM-DD");
              const tomorrowFormatted = moment().add(1, 'day').format("MMM-DD");
              const yesterdayFormatted = moment().add(-1, 'day').format("MMM-DD");

              if (!thirdPartyOrder && o?.channel?.length) {
                thirdPartyOrder = o.channel[0] + " " + seqnr;
              }

              if (thirdPartyOrder) {
                var seq = thirdPartyOrder.split(" ")[1];
                if (!seq.startsWith("#")) seq = "#" + seq;
                text += `<span style='display:flex;align-items:center' class='orderNumber thirdparty ${thirdPartyOrder}'>${seq}</span>`;
              } else if (seqnr) {
                var encoded_seqnr = !occupation.encodedSeqnr || occupation.encodedSeqnr == occupation.seqnr ? "" : `<text>@${occupation.encodedSeqnr}</text>`;
                text += `
                    <span class='seqnr ${platform}' style='display:flex;flex-flow:column;justify-content:space-evenly;align-items:center'>
                      <div><span><div><text>#${seqnr}</text>${encoded_seqnr}</div></span></div>
                    </span>`;
              } else {
                text += "<span class='icon-clock'></span>";
              }

              if (!o.created) {
                console.log("Strange");
              }

              text += `${image}
                <span class='created' style='flex-flow:column'>
                 <span class='c' date='${o.created}' >${moment(o.created).fromNow()}</span>
                 <span style='font-size:60%'>${moment(occupation.occupationStart).format("HH:mm")}</span>
                </span>
                <span class='time' data-placement='top' data-toggle='tooltip' title='${isHomeDelivery ? I18n.t("admin_local.tooltip.delivery_time") : I18n.t("admin_local.tooltip.pickup_time")}'>`;

              if (start === moment().startOf("day").valueOf()) {
                text += `<div class='date' style='font-size:100%'>${admin_local.today}</div>`;
              } else if (start === moment().add(-1, 'day').startOf("day").valueOf()) {
                text += `<div class='date' style='font-size:100%'>${admin_local.yesterday}</div>`;
              } else if (start === moment().add(1, 'day').startOf("day").valueOf()) {
                text += `<div class='date' style='font-size:100%'>${admin_local.tomorrow}</div>`;
              } else if (startDateFormatted === todayFormatted) {
                text += `<div class='date' style='font-size:100%'>${admin_local.today} ${moment(start).format("HH:mm")}${end ? `-${moment(end).format("HH:mm")}` : ""}</div>`;
              } else if (startDateFormatted === tomorrowFormatted) {
                text += `<div class='date' style='font-size:100%'>${admin_local.tomorrow} ${moment(start).format("HH:mm")}${end ? `-${moment(end).format("HH:mm")}` : ""}</div>`;
              } else if (startDateFormatted === yesterdayFormatted) {
                text += `<div class='date' style='font-size:100%'>${admin_local.yesterday} ${moment(start).format("HH:mm")}${end ? `-${moment(end).format("HH:mm")}` : ""}</div>`;
              } else if (moment(start).isAfter(moment().add(1, 'day').startOf("day"))) {
                text += `<div class='date' style='font-size:100%'>${moment(start).format("MMM-DD")}</div>`;
              } else {
                text += `<div class='date' style='font-size:100%'>${moment(start).format("HH:mm")}</div>`;
              }

              text += "</span>";

            }

            var amount = getAmountToPay(restaurantTableOccupation.tableMateIds[0], cdate);
            var totalamount = getAmountToPay(restaurantTableOccupation.tableMateIds[0]);
            var roundedAmount = Math.round(amount);

            amount = getAmountPaid(restaurantTableOccupation.tableMateIds[0], cdate);
            const roundedPaidAmount = Math.round(amount);

            var deliveryStart = false;
            if (o.deliveredById) {
              clazz += " courierSet ";
              if (deliveredById !== o.deliveredById) {
                clazz += " deliveryStart ";
                deliveryStart = true;
                deliveredById = o.deliveredById;
              }
              var courier = tablesOverview.context ? tablesOverview.context.props.deliveryUsers.find(u => u.id === o.courierId) : null;
              var unlink_courier = `<span class='icon-cancel' data-placement='top' data-toggle='tooltip' title='${I18n.t("admin_local.tooltip.unlink_courier")}'></span>`;
              if (!courier) {
                text += '<div class="courier">' + "<span class='icon-qrcode' data-placement='top' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.qrcode") + "'/>" + '<span>' + o.deliveredByName + "</span>" + unlink_courier + "</div>";
              } else {
                const eta = !occupation.bookedProperties?.["wolt-drive-pickup-eta"] || occupation.bookedProperties?.["wolt-drive-pickup-state"] === "finished" ? "" : `<text eta="${occupation.bookedProperties?.["wolt-drive-pickup-eta"]}" class='pickup-eta'>${moment(occupation.bookedProperties?.["wolt-drive-pickup-eta"]).fromNow()}</text>`;

                if (occupation.bookedProperties?.["drive-order"]) {
                  if (occupation.bookedProperties?.["wolt-drive-pickup-state"])
                    unlink_courier = "";
                  text += `<div class="courier wolt-drive pickup-state-${occupation.bookedProperties?.["wolt-drive-pickup-state"]}"><span>${o.deliveredByName}</span>${unlink_courier}${eta}</div >`;
                } else
                  text += `<div class="courier"><span class='icon-qrcode' data-placement='top' data-toggle='tooltip' title='${I18n.t("admin_local.tooltip.qrcode")}'/><span style="background-color:${courier.backgroundColor};color:${courier.color}">${o.deliveredByName}</span>${unlink_courier}${eta}</div>`;
              }
            } else {
              if (occupation.bookedProperties && occupation.bookedProperties.expiryDate && o.stateMap && o.stateMap["ordered"].length > 0) {
                const diff = Math.max(0, moment(Number(occupation.bookedProperties.expiryDate)).diff(moment(), "seconds"));
                const difffromstart = moment(Number(occupation.bookedProperties.expiryDate)).diff(moment(Number(occupation.bookedProperties.createdDate)), "seconds");
                const timeup = 100 - (diff / difffromstart * 100);
                const bcolor = timeup < 50 ? "lightgreen" : timeup < 75 ? "orange" : "red";
                const color = timeup < 50 ? "gray" : timeup < 75 ? "gray" : "white";
                text += '<div class="courier" style="color:' + color + ';background:linear-gradient(90deg, ' + bcolor + ' 0%, ' + bcolor + ' ' + timeup + '%, transparent ' + timeup + '%, transparent)" >' + moment((diff * 1000)).format("mm:ss") + '</div>';
              } else {
                if (occupation?.bookedProperties?.preOrder)
                  text += `<div class="courier">${I18n.t("admin_local.preorder")}</div>`;
                else
                  text += '<div class="courier"/>';
              }
              if (deliveredById) {
                clazz += " deliveryStart ";
              }
              deliveredById = undefined;
            }

            if (occupation.bookedProperties) {
              text += "<span class='name' style='display: flex;flex-wrap: wrap;justify-content: center;'>";
              text += occupation.bookedProperties.surname ? occupation.bookedProperties.surname + " " : "";
              text += (occupation.bookedProperties.name ? occupation.bookedProperties.name : occupation.bookedProperties.email ? occupation.bookedProperties.name : "");
              const userCommentText = "<text data-toggle='tooltip' data-placement='top' title='" + I18n.t("admin_local.tooltip.user_comment") + "' class='" + (occupation?.bookedProperties?.user_comment ? ' comment' : 'icon-comment') + "' onclick='event.stopPropagation(); getInputDialog(\"" + I18n.t("admin_local.comment") + "\", \"" + I18n.t("admin_local.tooltip.user_comment") + "\", $(this).html(), \"text\").done((i,v) => updateBookingUserComment(" + occupation.id + ",v))' >" + (occupation?.bookedProperties?.user_comment ? occupation?.bookedProperties?.user_comment.replace(/\n/g, "<br/>") : '') + "</text > ";
              text += userCommentText;
              if (isHomeDeliveryTable) {
                text += "</span><span class='address' style='display: flex;flex-wrap: wrap;justify-content: center;'><div target='new' onclick2='event.stopPropagation()' href2='https://www.google.com/maps/dir//" + (occupation.bookedProperties.postcode ? occupation.bookedProperties.postcode + "&nbsp;" : "") + (occupation.bookedProperties.town && occupation.bookedProperties.town !== auth.myStatus.restaurant_town ? occupation.bookedProperties.town + " " : "") + (occupation.bookedProperties.address ? occupation.bookedProperties.address : "") + "' class='address'>" + (occupation.bookedProperties.postcode ? occupation.bookedProperties.postcode + "&nbsp;" : "") + (occupation.bookedProperties.town && occupation.bookedProperties.town !== auth.myStatus.restaurant_town ? occupation.bookedProperties.town + " &shy;" : "") + (occupation.bookedProperties.address ? occupation.bookedProperties.address : "");
                text += "</div>";
              }
              const commentText = "<text data-toggle='tooltip' data-placement='top' title='" + I18n.t("admin_local.tooltip.comment") + "' class='" + (occupation?.bookedProperties?.comment ? 'comment' : 'icon-comment') + "' onclick='event.stopPropagation(); getInputDialog(\"" + I18n.t("admin_local.comment") + "\", \"" + I18n.t("admin_local.tooltip.comment") + "\", \"" + (occupation?.bookedProperties?.comment || '') + "\", \"text\").done((i,v) => updateBookingComment(" + occupation.id + ",v))' >&nbsp;" + (occupation?.bookedProperties?.comment || '') + "</text > ";
              if (isHomeDeliveryTable)
                text += commentText;
              if (isPickupTable || isHomeDeliveryTable) {
                if (auth.device.platform === "browser") {
                  if (voipphone)
                    text += "</span><span class='phone'>" + (occupation.bookedProperties.phone ? "<span onclick='event.stopPropagation();callANumber(\"" + occupation.bookedProperties.phone + "\");' class='icon-phone btn btn-positive' style='display: flex;flex-wrap: wrap;justify-content: center;align-items:center'><div>" + (occupation.bookedProperties.phone ? occupation.bookedProperties.phone.replace(/ /g, "") : "") + "</div>" : "") + "</span>";
                  else
                    text += "</span><span class='phone icon-phone' style='display: flex;flex-wrap: wrap;justify-content: center;'><div>" + (occupation.bookedProperties.phone ? occupation.bookedProperties.phone.replace(/ /g, "") : "") + "</div>";
                } else
                  text += "</span><span class='phone' style='display: flex;flex-wrap: wrap;justify-content: center;'><div onClick='event.stopPropagation();device.platform===\"iOS\"&&cordova.plugins.phonedialer.call(\"" + occupation.bookedProperties.phone + "\", () => {},() => {}, \"\");' class='phone' target='_system' href2='tel://" + (occupation.bookedProperties.phone ? occupation.bookedProperties.phone.replace(/ /g, "") : "") + "'>" + (occupation.bookedProperties.phone ? occupation.bookedProperties.phone.replace(/ /g, "") : "") + "</div>";
              } if (isPickupTable)
                text += commentText;

            } else if (occupation.tableMates[0]?.name) {
              text += "<span class='name'>";
              text += occupation.tableMates[0]?.name;
              text += "</span>";
              text += "<span  class='address'/>";
              text += "<span  class='phone'/>";
            } else {
              text += "<span class='address'/>";
              text += "<span class='phone'/>";
              text += "<span/>";
            }
            text += "</span>";

            if (occupation?.bookedProperties?.amountToPay) {
              roundedAmount = Math.round(occupation.bookedProperties?.amountToPay);
            }


            if (roundedAmount !== 0 || o.price > roundedAmount) {
              if (roundedAmount)
                text += "<div class='amount'>" + roundedAmount + " " + auth.myStatus.restaurant_base_currency.name + "</div>";
              else
                if (roundedPaidAmount)
                  text += "<div class='amount' style='text-decoration:line-through; background-color: lightgreen'>" + roundedPaidAmount + " " + auth.myStatus.restaurant_base_currency.name + "</div>";
                else if (totalamount === roundedPaidAmount)
                  text += "<div class='amount' style='text-decoration:line-through; background-color: lightgreen'></div>";
                else
                  text += "<div class='amount' style=''></div>";
              if (occupation.bookedProperties && occupation.bookedProperties.payment_method && getPaymentMethod(occupation.bookedProperties.payment_method)) {
                text += "<div class='payment_method'>" + getPaymentMethod(occupation.bookedProperties.payment_method)?.method?.name + "</div>";
              } else {
                text += "<span class='payment_method'>" + "</span>";
              }
            } else if (roundedAmount > 0) {
              text += "<span>" + I18n.t("local.paid") + "" + "</span><span/>";
              clazz += " paid ";
            } else {
              text += "<span class='amount'/>";
              text += "<span class='payment_method'/>";
            }
            if (occupation.bookedProperties && occupation.bookedProperties.installments_strategy)
              text += "<div class='installments_strategy'>" + admin_local.allowed_installments[occupation.bookedProperties.installments_strategy] + "</div>";
            else
              text += '<div class="installments_strategy"/>';

            if (o.beingprinted) {
              text += "<div class='pr printing cogwheel' data-placement='top' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.printing") + "'/>";
              clazz += " beingprinted";
            } else if (o.printFailed) {
              text += "<div class='pr printfailed blink2' data-placement='top' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.printfailed") + "'/>";
              clazz += " printfailed";
            } else if (o.unprinted) {
              text += "<div class='pr unprinted' data-placement='top' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.unprinted") + "'/>";
            } else if (o.printed) {
              text += "<div class='pr printed' data-placement='top' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.printed") + "'/>";
            } else {
              text += "<div class='pr print-none'/>";
            }


            var allDelivered = false;
            try {
              allDelivered = !stateMap ? false : ((stateMap['accepted'] ? stateMap['accepted'].length : 0) + (stateMap['producing'] ? stateMap['producing'].length : 0) + (stateMap['producing'] ? stateMap['ready'].length : 0) + (stateMap['delivering'] ? stateMap['delivering'].length : 0) + (stateMap['ordered'] ? stateMap['ordered'].length : 0) == 0);

              if (allDelivered) {
                allDelivered = !occupations.filter(oo => oo.tableOccupation === o.tableOccupation).map(o => o.stateMap).filter(stateMap => {
                  return !stateMap ? true : !((stateMap['accepted'] ? stateMap['accepted'].length : 0) + (stateMap['producing'] ? stateMap['producing'].length : 0) + (stateMap['delivering'] ? stateMap['ready'].length : 0) + (stateMap['delivering'] ? stateMap['delivering'].length : 0) + (stateMap['ordered'] ? stateMap['ordered'].length : 0) == 0)
                }).length;
              }

            } catch (ex) {
              console.error(ex);
            }

            function unlockit() {
              if (allDelivered || (roundedAmount == 0 && !isHomeDelivery && !isPickup)) {
                text += "<div class='unlock' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.unlock") + "'/>";;
                clazz += " unlock ";
              } else if (!o.orderIds) {
                text += "<div class='unlock' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.unlock") + "'/>";;
                clazz += " unlock ";
              } else
                text += "<div class='col'/>";
            }

            const hasReceipt = occupation.tableMatePayments?.some(tmp => tmp.receiptNo);
            const dollarPaidClass = "dollar-paid" + (hasReceipt ? " has-receipt" : "");

            if (occupation.bookedProperties && occupation.bookedProperties.installments_strategy) {
              const date = moment(o.date).startOf("day").valueOf();
              const minmax = orderListUtil.allOrders.tables.filter(t => t.tableOccupation === o.tableOccupation).map(t => moment(t.date.valueOf()).startOf('day').valueOf()).reduce((a, b) => { return { min: a.min == null ? b : Math.min(a.min, b), max: a.max == null ? b : Math.max(a.max, b) } }, { min: null, max: null });


              switch (occupation.bookedProperties.installments_strategy) {
                case "start":
                  if (date === minmax.min) {
                    text += getHomeDeliveryLabelPrinterHtml(o);
                    text += "<div class='invoice " + (getStateIndex(occupation.tableMates[0], "wantsToPay") >= 0 ? "wantsToPay" : "") + " " + (!roundedAmount ? "paid" : "") + "' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.print_invoice") + "'/>";

                    if (roundedAmount !== 0) {
                      text += "<div class='dollar' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.register_payment") + "'/>";
                      text += "<div class='col'/>";
                    } else {
                      if (roundedAmount === totalamount) {
                        text += "<div class='" + dollarPaidClass + "'/>";
                        unlockit();
                      } else {
                        if (date === minmax.max)
                          text += "<div class='dollar' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.register_payment") + "'/>";
                        else
                          text += "<div class='icon-attention'/>";
                        text += "<div class='col'/>";
                      }
                    }
                  } else {
                    text += "<div class='icon-up-open'/>";
                    if (roundedAmount !== 0) {
                      text += "<div class='icon-up-open'/>";
                      text += "<div class='col'/>";
                    } else {
                      if (roundedAmount === totalamount) {
                        text += "<div class='" + dollarPaidClass + "'/>";
                        unlockit();
                      } else {
                        text += "<div class='icon-attention'/>";
                        text += "<div class='col'/>";
                      }
                    }
                  }
                  break;
                case "by_each":
                  text += getHomeDeliveryLabelPrinterHtml(o);
                  text += "<div class='invoice " + (getStateIndex(occupation.tableMates[0], "wantsToPay") >= 0 ? "wantsToPay" : "") + " " + (!roundedAmount ? "paid" : "") + "' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.print_invoice") + "'/>";

                  if (roundedAmount !== 0) {
                    text += "<div class='dollar' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.register_payment") + "'/>";
                    text += "<div class='col'/>";
                  } else {
                    text += "<div class='" + dollarPaidClass + "'  data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.paid") + "'/>";
                    unlockit();
                  }
                  break;
                case "end":
                  if (date === minmax.max) {
                    text += getHomeDeliveryLabelPrinterHtml(o);
                    text += "<div class='invoice " + (getStateIndex(occupation.tableMates[0], "wantsToPay") >= 0 ? "wantsToPay" : "") + " " + (!roundedAmount ? "paid" : "") + "' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.print_invoice") + "'/>";

                    if (roundedAmount !== 0) {
                      text += "<div class='dollar' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.register_payment") + "'/>";
                      text += "<div class='col'/>";
                    } else {
                      text += "<div class='" + dollarPaidClass + "' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.paid") + "'/>";
                      unlockit();
                    }
                  } else {
                    text += "<div class='icon-down-open'/>";
                    if (roundedAmount !== 0) {
                      text += "<div class='icon-down-open'/>";
                      text += "<div class='col'/>";
                    } else {
                      text += "<div class='" + dollarPaidClass + "' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.paid") + "'/>";
                      unlockit();
                    }
                  }
                  break;
                default:
                  text += getHomeDeliveryLabelPrinterHtml(o);
                  text += "<div class='invoice " + (getStateIndex(occupation.tableMates[0], "wantsToPay") >= 0 ? "wantsToPay" : "") + " " + (!roundedAmount ? "paid" : "") + "' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.print_invoice") + "'/>";

                  if (roundedAmount !== 0) {
                    text += "<div class='dollar' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.register_payment") + "'/>";
                    text += "<div class='col'/>";
                  } else {
                    if (roundedPaidAmount)
                      text += "<div class='" + dollarPaidClass + "'  data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.paid") + "'/>";
                    else
                      text += "<div class='col'/>";
                    unlockit();
                  }
              }

            } else {
              text += getHomeDeliveryLabelPrinterHtml(o);
              if ((roundedAmount || roundedPaidAmount) && clazz2.indexOf("cancelled") === -1)
                text += "<div class='invoice " + (getStateIndex(occupation.tableMates[0], "wantsToPay") >= 0 ? "wantsToPay" : "") + " " + (!roundedAmount ? "paid" : "") + "' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.print_invoice") + "'/>";
              else
                text += "<div class='invoice'/>";

              if (roundedAmount !== 0) {
                text += "<div class='dollar' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.register_payment") + "'/>";
                text += "<div class='col'/>";
              } else {
                if (roundedPaidAmount)
                  text += "<div class='" + dollarPaidClass + "' data-toggle='tooltip' title='" + I18n.t("admin_local.tooltip.paid") + "'/>";
                else
                  text += "<div class='col'/>";
                unlockit();
              }
            }



            if (occupation?.bookedProperties?.preOrder) {
              clazz += " preorder ";
            }

            var $li = makeElement("li", { class: "selectable nav-item " + clazz, refreshtimestamp: occupation.modificationTimeStamp });

            $li.append($a);
            $($a).html(text);
            $li = $($li);
            setData($li, o);
            $li.data("level", 1);
            $li.attr("date", moment(o.date).startOf("day").valueOf());
            $li.attr("tableOccupation", o.tableOccupation);
            $li.attr("deliveredById", deliveredById);
            $li.attr("deliveredByIndex", o.deliveredByIndex);
            $li.attr("id", o.date + "-" + o.tableOccupation);

            tableSelectorMap[o.date + "-" + o.tableOccupation] = { t: occupation.modificationTimeStamp, d: $($li).clone() };

            if (tablesOverview.selectedDate !== o.date)
              $li.addClass("hidden");
            $(selectorul).append($li);


          }
        });
      });

      //selectorulold.empty();
      replaceContent(selectorulold, selectorul);

      selectorul = $("#tableOccupation-selector > ul");

      selectorul.find("li input").off("change");
      selectorul.find("li div").off("click");
      selectorul.find("li div").off("dblclick");
      selectorul.find("li.group-functions label.courier").off("dblclick");
      selectorul.find("li.group-functions div.unlock").off("dblclick");
      selectorul.find("li:not(.group-functions) .icon-cancel").off("dblclick");
      selectorul.find("li:not(.group-functions) span.icon-qrcode").off("dbclick");

      selectorul.find("li:not(.group-functions) input.custom-control-input").off("change");
      selectorul.find("li.group-functions input.custom-control-input").on("change", event => {
        if ($(event.currentTarget).attr("date") > 0) {
          $("li:not(.group-functions)[date = '" + $(event.currentTarget).attr("date") + "'] input.custom-control-input").prop('checked', event.currentTarget.checked);
        }
      })
      selectorul.find("li:not(.group-functions) input.custom-control-input").on("change", event => {
        console.log($(".leaflet-marker-icon > div#" + $(event.currentTarget).parent().parent().attr("id") + " input"));
        let id = $(event.currentTarget).parent().parent().attr("id");
        bookingMap && bookingMap.selectTableOccupation(id, event.currentTarget.checked);
        if (event.currentTarget.checked) {
          let deliveryId = $(event.currentTarget).attr("deliveryId");
          if (deliveryId > 0) {
            $("li:not(.group-functions) input.custom-control-input").prop('checked', false);
            bookingMap && bookingMap.cleanTableOccupation();
            let items = $("li:not(.group-functions) input.custom-control-input[deliveryId = '" + deliveryId + "']");
            if (bookingMap) {
              bookingMap.selectDelivery(deliveryId, id);
            }
            items.prop('checked', true);
            items.each((ind, e) => {
              id = $(e).parent().parent().attr("id");
              bookingMap && bookingMap.selectTableOccupation(id, event.currentTarget.checked);
            })
          } else if (bookingMap) {
            bookingMap.selectDelivery(0, 0);
          }
        }
      })
      selectorul.find("li:not(.group-functions) div.t-state").off("click");
      selectorul.find("li:not(.group-functions) div.t-state").on("click", event => {
        event.stopPropagation();
      });

      selectorul.find("li:not(.group-functions):not(.cancelled) div.t-state").off("dblclick");
      selectorul.find("li:not(.group-functions):not(.cancelled) div.t-state").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const occupation = getData($(event.currentTarget).parents("li"));
        if (occupation) {
          selectTableOccupationSelected(occupation.tableOccupation);
          const orderids = occupation.orderIds ? occupation.orderIds.filter(o => getOrderById(o).state != "cancelled") : [];
          if (orderids.length) admin.processchangeStateByOrderIds(occupation.tableOccupation, orderids, $(event.currentTarget).attr("state"), data => {
            update(data);
            if ($(event.currentTarget).attr("state") === "accepted") {
              // if delivery date is within next hour, print the order
              const now = moment().add(-10, 'minute');
              const oneHourLater = moment().add(1, 'hour');
              const deliveryDate = moment(occupation.date);
              if (deliveryDate.isBetween(now, oneHourLater)) {
                printNewOrders(occupation.orderIds, undefined, undefined, true);
              }
            }
            if ($("#editTable").hasClass("show-map")) {
              showMap(true);
            }
          })
        }
      })
      selectorul.find("li:not(.group-functions) div.unprinted").off("click");
      selectorul.find("li:not(.group-functions) div.unprinted").on("click", event => {
        event.stopPropagation();
      });
      selectorul.find("li:not(.group-functions) div.unprinted").off("dblclick");
      selectorul.find("li:not(.group-functions) div.unprinted").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const occupation = getData($(event.currentTarget).parents("li"));
        selectTableOccupationSelected(occupation.tableOccupation);
        printNewOrders(occupation.orderIds, undefined, undefined, true);
      })
      selectorul.find("li:not(.group-functions) div.printed,li:not(.group-functions) div.printfailed").off("click");
      selectorul.find("li:not(.group-functions) div.printed,li:not(.group-functions) div.printfailed").on("click", event => {
        event.stopPropagation();
      });
      selectorul.find("li:not(.group-functions) div.printed,li:not(.group-functions) div.printfailed").off("dblclick");
      selectorul.find("li:not(.group-functions) div.printed,li:not(.group-functions) div.printfailed").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const occupation = getData($(event.currentTarget).parents("li"));
        selectTableOccupationSelected(occupation.tableOccupation);
        const ids = occupation.orderIds.map(id => getOrderById(id)).filter(o => o.state !== "cancelled" && o.state !== "selected" && o.state !== "ordered").map(o => o.id);
        printNewOrders(ids, undefined, true, true);
      })
      selectorul.find("li:not(.group-functions) div.invoice").off("click");
      selectorul.find("li:not(.group-functions) div.invoice").on("click", event => {
        event.stopPropagation();
      });
      selectorul.find("li:not(.group-functions) div.invoice").off("dblclick");
      selectorul.find("li:not(.group-functions) div.invoice").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        if (isDuplicateClickEvent(event)) return; avoidMultipleClick(this, event);
        event.stopPropagation();
        if ($(event.currentTarget).data("block"))
          return;
        $(event.currentTarget).data("block", true);
        setTimeout(() => { $(event.currentTarget).data("block", false) }, 10000);
        const o = getData($(event.currentTarget).parents("li"));
        const occupation = getTableOccupation(o.tableOccupation);
        var date = "";
        if (occupation.bookedProperties && occupation.bookedProperties.installments_strategy == "by_each")
          date = o.date;
        if (getAmountToPay(o.forWhomId) == 0) {
          confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.already_paid_reprint_invoice")).done(() => {
            admin.reprintInvoice(occupation.tableMatePayments.filter(tmp => tmp.payable && tmp.payments.find(p => p.done))[0].id, localStorage.language, function (data) {
              if (data === '{"success":"true"}') {
              } else
                printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
            });
          });
        } else
          admin.getInvoiceXML(o.tableOccupation, sessionStorage.tableNumberSelected, o.forWhomId, localStorage.language, 1, date, date, function (data) {
            if (data == '{"success":"true"}') {
              post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", occupation.tableMates.map(m => {
                m.states.push({ state: "wantsToPay", duration: 0 });
                return m;
              })).done(update);
            } else if (data.startsWith("<!DOCTYPE HTML") || data.startsWith("data:image/")) {
              printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
              post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", occupation.tableMates.map(m => {
                m.states.push({ state: "wantsToPay", duration: 0 });
                return m;
              })).done(update);
            }
          });
      })
      selectorul.find("li:not(.group-functions) div.dollar-paid").off("click");
      selectorul.find("li:not(.group-functions) div.dollar-paid").on("click", event => {
        event.stopPropagation();
      });
      selectorul.find("li:not(.group-functions) div.dollar").off("click");
      selectorul.find("li:not(.group-functions) div.dollar").on("click", event => {
        event.stopPropagation();
      });

      selectorul.find("li:not(.group-functions) div.dollar-paid").off("dblclick");
      selectorul.find("li:not(.group-functions) div.dollar-paid").on("dblclick", event => {
        event.stopPropagation();
        const o = getData($(event.currentTarget).parents("li"));
        selectTableOccupationSelected(o.tableOccupation);
        showPayments();
      });

      selectorul.find("li:not(.group-functions) div.dollar").off("dblclick");
      selectorul.find("li:not(.group-functions) div.dollar").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const o = getData($(event.currentTarget).parents("li"));
        const occupation = getTableOccupation(o.tableOccupation);
        var date = "";
        if (occupation.bookedProperties && occupation.bookedProperties.installments_strategy == "by_each")
          date = o.date;
        selectTableOccupationSelected(o.tableOccupation);


        try {
          var res = orderListUtil.orders.tables.filter(o => Number(o.tableNumber) === Number(sessionStorage.tableNumberSelected) && Number(o.tableOccupation) === Number(sessionStorage.tableOccupationSelected));
          if (res)
            res.map(o => {
              o.orders.forEach(o => o.orders.forEach(o => o.childOrders.forEach(o => o.menuItem = getMenuItem(o.menuItem.id))));
              return o;
            })
          updateDataOnCustomerScreen(res);
        } catch (Ex) {
          console.error(Ex);
        }
        tableMatePaid(o.forWhomId, date, true, data => {
          update(data);
        });
      })
      selectorul.find("li:not(.group-functions) div.unlock").off("click");
      selectorul.find("li:not(.group-functions) div.unlock").on("click", event => {
        event.stopPropagation();
      });
      selectorul.find("li:not(.group-functions) div.unlock").off("dblclick");
      selectorul.find("li:not(.group-functions) div.unlock").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const o = getData($(event.currentTarget).parents("li"));
        unlockTable(o.tableOccupation, sessionStorage.tableNumberSelected, false, data => {
          update(data);
        })
      })

      selectorul.find("li:not(.group-functions) .courier").off("click");
      selectorul.find("li:not(.group-functions) .courier").on("click", event => {
        event.stopPropagation();
      });
      selectorul.find("li:not(.group-functions) .icon-cancel").off("dblclick");
      selectorul.find("li:not(.group-functions) .icon-cancel").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const o = getData($(event.currentTarget).parents("li"));
        const occupation = getTableOccupation(o.tableOccupation);
        var date = "";
        if (occupation.bookedProperties && occupation.bookedProperties.installments_strategy == "by_each")
          date = o.date;
        get("adminService/" + auth.myStatus.restaurant_id + "/assignCourier/" + o.deliveredById + "/" + o.tableOccupation + "?orderIds=" + o.orderIds + "&courier=" + 0).done((data) => {
          if (data.error) {
            resultHandler(data);
            return;
          }
          update(data);
          if ($("#editTable").hasClass("show-map")) {
            showMap(true);
          }
        })
      })

      selectorul.find("li.group-functions div.unlock").off("dblclick");
      selectorul.find("li.group-functions div.unlock").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const date = $(event.currentTarget).parents("li").attr("id");
        const occupations = [];
        $('li[date = "' + date + '"] input.custom-control-input:checked').each((ind, li) => {
          occupations.push(getData($(li).parents('li')));
          li.checked = false;
        })
        if (occupations.length === 0)
          $('li:not(.group-functions):not(.separator)[date = "' + date + '"].unlock').each((ind, li) => {
            occupations.push(getData($(li)));
          });

        function assign(occupations) {
          const occupation = occupations.shift();
          unlockTable(occupation.tableOccupation, sessionStorage.tableNumberSelected, false, data => {
            update(data);
            if (occupations.length)
              assign(occupations);
          })
        }
        if (occupations.length)
          assign(occupations);
      });

      selectorul.find("li.group-functions label.courier").off("dblclick");
      selectorul.find("li.group-functions label.courier").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const date = $(event.currentTarget).parents("li").attr("id");
        var courier = $(event.currentTarget).attr("courier");
        const occupations = [];
        $('li[date = "' + date + '"] input.custom-control-input:checked').each((ind, li) => {
          occupations.push(getData($(li).parents('li')));
          li.checked = false;
        })
        var delivery = 0;
        function assign(occupations) {
          const occupation = occupations.shift();
          const orderIds = occupation.orderIds;
          const occ = getTableOccupation(occupation.tableOccupation);
          function postAssignUpdate(data) {
            update(data);
            if (occ.tableMates.filter(m => !m.states.find(s => s.state === "wantsToPay")).length) {
              if (occ.bookedProperties && occ.bookedProperties.installments_strategy == "by_each") {
                return;
              }
              _log("reprintInvoice: " + occupation.tableOccupation + " " + getAmountToPay(occupation.forWhomId));
              if (getAmountToPay(occupation.forWhomId) === 0) {
                admin.reprintInvoice(occ.tableMatePayments[0].id, localStorage.language, function (data) {
                  if (data == '{"success":"true"}') {
                    post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", occ.tableMates.map(m => {
                      m.states.push({ state: "wantsToPay", duration: 0 });
                      return m;
                    })).done(update);
                  } else if (data.startsWith("<!DOCTYPE HTML")) {
                    printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
                    post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", occ.tableMates.map(m => {
                      m.states.push({ state: "wantsToPay", duration: 0 });
                      return m;
                    })).done(update);
                  }
                });
              } else {
                admin.getInvoiceXML(occupation.tableOccupation, sessionStorage.tableNumberSelected, occupation.forWhomId, localStorage.language, 1, "", "", function (data) {
                  if (data == '{"success":"true"}') {
                    post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", occ.tableMates.map(m => {
                      m.states.push({ state: "wantsToPay", duration: 0 });
                      return m;
                    })).done(update);
                  } else if (data.startsWith("<!DOCTYPE HTML")) {
                    printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
                    post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", occ.tableMates.map(m => {
                      m.states.push({ state: "wantsToPay", duration: 0 });
                      return m;
                    })).done(update);
                  }
                });
              }
            }
          }
          if (orderIds) {
            get("adminService/" + auth.myStatus.restaurant_id + "/assignCourier/" + delivery + "/" + occupation.tableOccupation + "?orderIds=" + orderIds + "&courier=" + courier).done((data) => {
              if (data.error) {
                //If we get such response we should ask if the user want to change delivery time
                //Scheduled time (2026-02-15T16:00:44455Z) is too early Earliest possible delivery at 2026-02-15T16:07:49468Z
                if (data.error.startsWith("admin_local.drive.Scheduled time") && data.error.includes("is too early")) {
                  const earliestTime = data.error.substring(data.error.indexOf("Earliest possible delivery at ") + "Earliest possible delivery at ".length, data.error.length);
                  function fixTimestamp(ts) {
                    return ts.replace(
                      /T(\d{2}:\d{2}:\d{2})(\d{3})Z$/,
                      "T$1.$2Z"
                    );
                  }
                  const originaltime = data.error.substring(data.error.indexOf("admin_local.drive.Scheduled time (") + "admin_local.drive.Scheduled time (".length, data.error.indexOf(") is too early"));
                  const earliest = moment(fixTimestamp(earliestTime)).add(2, 'minutes');
                  const original = moment(fixTimestamp(originaltime));
                  confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.drive.earliest_delivery_time", { originaltime: original.locale(localStorage.language).format("LT"), time: earliest.locale(localStorage.language).format("LT"), fromNow: earliest.fromNow() })).done(() => {
                    const bookedProperties = occ.bookedProperties || {};
                    bookedProperties.start = earliest.valueOf();
                    post("adminService/" + localStorage.restaurantSelected + "/updateBooking/" + occupation.tableOccupation, bookedProperties).done(data => {
                      if (data.error) {
                        resultHandler(data);
                        return;
                      }
                      update(data);
                      get("adminService/" + auth.myStatus.restaurant_id + "/assignCourier/" + delivery + "/" + occupation.tableOccupation + "?orderIds=" + orderIds + "&courier=" + courier).done((data) => {
                        if (data.error) {
                          resultHandler(data);
                        }
                        postAssignUpdate(data);
                      });
                    });
                  });
                  return;
                }

                resultHandler(data);
                return;
              }
              postAssignUpdate(data);
              if (occupations.length)
                delivery = data.orders[0].deliveredById;
              if (occupations.length)
                assign(occupations);

            })
          } else if (occupations.length)
            assign(occupations);
        }
        if (occupations.length)
          assign(occupations);
      });

      selectorul.find("li:not(.group-functions) span.icon-qrcode").off("dblclick");
      selectorul.find("li:not(.group-functions) span.icon-qrcode").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const occupations = [];
        const deliveredById = $(event.currentTarget).parents("li").attr("deliveredById");

        $('li[deliveredById = "' + deliveredById + '"]').each((ind, li) => {
          const occupation = getData($(li));
          occupations.push(occupation);
        })

        if (occupations.length) {
          var path = encodeURIComponent(auth.myStatus.restaurant_address + "," + auth.myStatus.restaurant_town + ", " + auth.myStatus.restaurant_postcode);
          var text = occupations.map(o => {
            const occupation = getTableOccupation(o.tableOccupation);
            const address = occupation.bookedProperties.address + ", " + occupation.bookedProperties.town + (occupation.bookedProperties.postcode ? ", " + occupation.bookedProperties.postcode : "");
            path += "/" + encodeURIComponent(address.replace(/\//g, " ").replace(/,/g, " "));
            return getAddresses(o.tableOccupation, o.date);
          }).join();
          const printerSettings = getLocalPrinterSettings();
          var printer = auth.myStatus.restaurant_printer_actions.printInvoice.id;
          if (printerSettings.printerActions.pa_printInvoice)
            printer = printerSettings.printerActions.pa_printInvoice;
          path += "/" + encodeURIComponent(auth.myStatus.restaurant_address + "," + auth.myStatus.restaurant_town + ", " + auth.myStatus.restaurant_postcode);
          const url = 'https://www.google.com/maps/dir/' + path + '/@' + auth.myStatus.restaurant_latitude + ',' + auth.myStatus.restaurant_longitude + ',14z';
          const html = "<html><body><div>!ESCqrcode: " + url + "!LF!LF</div><div>" + text + "</div></body></html>";
          //console.log(html);
          post("printerServerClient/" + localStorage.restaurantSelected + "/printerMessage/" + printer, { text: html });
        }
      });

      selectorul.find("li.group-functions div.invoice").off("dblclick");
      selectorul.find("li.group-functions div.invoice").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const date = $(event.currentTarget).parents("li").attr("id");
        const occupations = [];
        $('li[date="' + date + '"] input.custom-control-input:checked').each((ind, li) => {
          occupations.push(getData($(li).parents('li')));
          li.checked = false;
        })
        if (!occupations.length) {
          $('li:not(.group-functions):not(.separator)[date = "' + date + '"]').each((ind, li) => {
            occupations.push(getData($(li)));
          });
        }
        function print(occupations) {
          const occupation = occupations.shift();
          var d = "";
          if (occupation?.bookedProperties?.installments_strategy == "by_each")
            d = date;

          admin.getInvoiceXML(occupation.tableOccupation, sessionStorage.tableNumberSelected, occupation.forWhomId, localStorage.language, 1, d, date, function (data) {
            if (data == '{"success":"true"}') {
            } else {
              printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
            }
            if (occupations.length)
              print(occupations);
          });
        }
        if (occupations.length)
          print(occupations);
      })
      selectorul.find("li.group-functions div.print").off("dblclick");
      selectorul.find("li.group-functions div.print").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const date = $(event.currentTarget).parents("li").attr("id");
        var occupations = [];
        var selected = $('li[date="' + date + '"] input.custom-control-input:checked');
        selected.each((ind, li) => {
          occupations.push(getData($(li).parents('li')));
          li.checked = false;
        })
        if (selected.length === 0)
          $('li:not(.group-functions):not(.separator)[date = "' + date + '"]').each((ind, li) => {
            occupations.push(getData($(li)));
          });
        function print(occupations, reprint) {
          const occupation = occupations.shift();
          const orderIds = occupation.orderIds ? occupation.orderIds.map(id => getOrderById(id)).filter(o => !o.printed || reprint).map(o => o.id).join(",") : undefined;
          if (orderIds) {
            selectTableOccupationSelected(occupation.tableOccupation);
            printNewOrders(orderIds, undefined, reprint, true).done(() => {
              if (occupations.length)
                print(occupations, reprint);
            });
          } else if (occupations.length)
            print(occupations, reprint);
        }
        occupations = occupations.filter(o => o);
        if (occupations.length) {
          if (!occupations.filter(o => o.unprinted).length) {
            confirmDialog(I18n.t("local.confirmation"), I18n.t("admin_local.do_you_really_want_to_reprint_only_the_selected_orders")).done(() => print(occupations, true));
          } else
            print(occupations);
        }
      })

      const printHomeDeliveryLabelsButtonHandler = event => {
        if (!canPrintHomeDeliveryLabels()) return;
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();

        const parentLi = $(event.currentTarget).parents("li");
        if (parentLi.hasClass("group-functions")) {
          const date = parentLi.attr("id");
          let occupations = [];
          const selected = $('li[date="' + date + '"] input.custom-control-input:checked');
          selected.each((ind, li) => {
            occupations.push(getData($(li).parents('li')));
            li.checked = false;
          });
          if (selected.length === 0)
            $('li:not(.group-functions):not(.separator)[date = "' + date + '"]').each((ind, li) => {
              occupations.push(getData($(li)));
            });
          occupations = occupations.filter(o => o && o.tableOccupation);
          if (occupations.length) {
            printHomeDeliveryLabelsForOccupations(occupations, false);
          }
          return;
        }

        const occupation = getData(parentLi);
        if (occupation) {
          printHomeDeliveryLabelsForOccupations([occupation], false);
        }
      };

      selectorul.find("li.group-functions div.label-printer").off("click dblclick");
      selectorul.find("li.group-functions div.label-printer").on("click dblclick", printHomeDeliveryLabelsButtonHandler);

      selectorul.find("li:not(.group-functions) div.label-printer").off("click dblclick");
      selectorul.find("li:not(.group-functions) div.label-printer").on("click dblclick", printHomeDeliveryLabelsButtonHandler);

      selectorul.find("li.group-functions div.t-state").off("dblclick");
      selectorul.find("li.group-functions div.t-state").on("dblclick", event => {
        if (auth.device.platform === "browser" && event?.originalEvent?.dataTransfer) return;
        event.stopPropagation();
        const date = $(event.currentTarget).parents("li").attr("id");
        const occupations = [];
        $('li:not(.cancelled)[date = "' + date + '"] input.custom-control-input:checked').each((ind, li) => {
          occupations.push(getData($(li).parents('li')));
          li.checked = false;
        })
        if (occupations.length === 0)
          $('li:not(.group-functions):not(.separator)[date="' + date + '"]').each((ind, li) => {
            occupations.push(getData($(li)));
          });
        function changeState(occupations) {
          const occupation = occupations.shift();
          if (occupation) {
            const state = $(event.currentTarget).attr("state");
            const stateIndex = allstates.indexOf(state);
            const orderIds = occupation.orderIds ? occupation.orderIds.map(id => getOrderById(id)).filter(o => allstates.indexOf(o.state) < stateIndex).map(o => o.id).join(",") : undefined;
            if (orderIds)
              admin.processchangeStateByOrderIds(occupation.tableOccupation, orderIds, state, data => {
                update(data);
                if (occupations.length)
                  changeState(occupations);
              })
            else if (occupations.length)
              changeState(occupations);
          }
        }
        console.log(occupations);
        if (occupations.length)
          changeState(occupations);
      })

      var selectedcount = selectorul.find(".nav-item:not(.group-functions):not(.separator)[date = '" + tablesOverview.selectedDate + "']").length;
      if (selectedcount === 0) {
        tablesOverview.selectedDate = moment().startOf("day").valueOf();
        selectedcount = selectorul.find(".nav-item:not(.group-functions):not(.separator)[date = '" + tablesOverview.selectedDate + "']").length;
        if (selectedcount === 0) {
          tablesOverview.selectedDate = selectorul.find(".nav-item:not(.group-functions):not(.separator)").toArray().map(t => $(t).attr("date")).reduce((a, b) => a ? Math.min(a, b) : b, null);
          selectedcount = selectorul.find(".nav-item:not(.group-functions):not(.separator)[date = '" + tablesOverview.selectedDate + "']").length;
          if (selectedcount === 0) {
            tablesOverview.selectedDate = selectorul.find(".nav-item:not(.group-functions):not(.separator)").toArray().map(t => $(t).attr("date")).reduce((a, b) => a ? Math.max(a, b) : b, null);
            selectedcount = selectorul.find(".nav-item:not(.group-functions):not(.separator)[date = '" + tablesOverview.selectedDate + "']").length;
            if (selectedcount === 0) {
              tablesOverview.selectedDate = moment().startOf("day").valueOf();
            }
          }
        }
      }

      selectorul.find(".nav-item:not(.group-functions):not(.separator)[date]").addClass("hidden");
      selectorul.find(".nav-item:not(.group-functions):not(.separator)[date = '" + tablesOverview.selectedDate + "']").removeClass("hidden");
      selectorul.find(".nav-item.separator[date]").removeClass("selected");
      selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "']").addClass("selected");
      //selectorul.find("#" + tablesOverview.selectedDate + ".nav-item.group-function").addClass("selected");
      if (first && selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "']").get(0))
        selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "']").get(0).scrollIntoView();

      selectorul.find(".nav-item.separator").off("click");
      selectorul.find(".nav-item.separator").on("click", (t) => {
        selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "']").removeClass("selected");
        selectorul.find(".nav-item:not(.group-functions):not(.separator)[date = '" + tablesOverview.selectedDate + "']").addClass("hidden");
        tablesOverview.selectedDate = $(t.currentTarget).attr("date");
        selectorul.find(".nav-item:not(.group-functions):not(.separator)[date = '" + tablesOverview.selectedDate + "']").removeClass("hidden");
        selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "']").addClass("selected");
        setTimeout(() => {
          selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "'] + li + li").get(0).scrollIntoView();
          selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "']").get(0).scrollIntoView()
        }, 200);
        setTimeout(() => {
          selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "'] + li + li").get(0).scrollIntoView();
          selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "']").get(0).scrollIntoView()
        }, 500);
        setTimeout(() => {
          selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "'] + li + li").get(0).scrollIntoView();
          selectorul.find(".nav-item.separator[date = '" + tablesOverview.selectedDate + "']").get(0).scrollIntoView()
        }, 700);
      })

    } else {
      selector.find(".created .c").each((ind, c) => {
        $(c).html(moment(Number($(c).attr("date"))).fromNow());
      })
      selector.find("text.pickup-eta").each((ind, c) => {
        $(c).html(moment(Number($(c).attr("eta"))).fromNow());
      })

    }

    if (window.location.href.indexOf("pointOfSale") === -1) {
      if (first) {
        if (sessionStorage.tableNumberSelected == pickupTableNumber || sessionStorage.tableNumberSelected == homeDeliveryTableNumber) {
          selector.removeClass("selectTableOccupationTile");
          $('#editTable').removeClass("selectTableOccupationTile");
          selector.addClass("selectTableOccupation");
          $('#editTable').addClass("selectTableOccupation");
        } else {
          selector.removeClass("selectTableOccupation");
          $('#editTable').removeClass("selectTableOccupation");
          selector.addClass("selectTableOccupationTile");
          $('#editTable').addClass("selectTableOccupationTile");
        }
      } else if (orderListUtil.occupationsSelected.length > 1 || sessionStorage.tableNumberSelected == pickupTableNumber || sessionStorage.tableNumberSelected == homeDeliveryTableNumber) {
      } else {
        selector.removeClass("selectTableOccupationTile");
        $('#editTable').removeClass("selectTableOccupationTile");
        selector.removeClass("selectTableOccupation");
        $('#editTable').removeClass("selectTableOccupation");
      }
    }


    var active = selector.find("a.nav-link.active");
    active.removeClass("active");
    //if (active.length == 0) {
    $(selector.find('a[id = "' + sessionStorage.tableOccupationSelected + '"]')).addClass("active");
    //}

    if (selectorulold.find("li:not(.group-functions):not(.separator)").length > 30) {
      $('#editTable').addClass("too-many-orders");
    } else {
      $('#editTable').removeClass("too-many-orders");
    }

  } else {
    selector.removeClass("selectTableOccupationTile");
    $('#editTable').removeClass("selectTableOccupationTile");
    if (selectorulold.find("li:not(.group-functions):not(.separator)").length > 30) {
      $('#editTable').addClass("too-many-orders");
    } else {
      $('#editTable').removeClass("too-many-orders");
    }

    $(selector).hide();
  }


  if (tablesOverview?.context?.props?.deliveryUsers)
    tablesOverview.context.props.deliveryUsers.map(
      user => {
        $("div.courier[courier = '" + user.id + "']").each((ind, e) => e.className = "courier courier-state-" + user.courierState);
      })


  filterForMapView();

  checked.each((ind, item) => {
    selectorul.find("li input#" + item.id + ".custom-control-input").prop("checked", true);
  })

  const tableSelectorCount = { pickup: 0, homeDelivery: 0 };

  if (orderListUtil?.allOrders?.tables) {
    orderListUtil.allOrders.tables.forEach(to => {
      if (to.stateMap.ordered.length > 0) {
        var number = to.tableNumber;
        const isPickupTable = number == pickupTableNumber;
        const isHomeDeliveryTable = number == homeDeliveryTableNumber;
        if (isPickupTable || isHomeDeliveryTable) {
          if (isPickupTable) {
            tableSelectorCount.pickup++;
          } else if (isHomeDeliveryTable) {
            tableSelectorCount.homeDelivery++;
          }
        }
      }
    })
  }

  if (tableSelectorCount.homeDelivery > 0) {
    $(".modal-header span.homedelivery").addClass("new");
    $(".modal-header span.homedelivery .f").html(I18n.t("admin_local.new") + " : " + tableSelectorCount.homeDelivery);
  } else {
    $(".modal-header span.homedelivery").removeClass("new");
    $(".modal-header span.homedelivery .f").html("");
  }
  if (tableSelectorCount.pickup > 0) {
    $(".modal-header span.pickup").addClass("new");
    $(".modal-header span.pickup .f").html(I18n.t("admin_local.new") + " : " + tableSelectorCount.pickup);
  } else {
    $(".modal-header span.pickup").removeClass("new");
    $(".modal-header span.pickup .f").html("");
  }


  $('#tableOccupation-selector [data-toggle="tooltip"]').tooltip({ trigger: 'hover' });

}

function filterForMapView() {
  $("#tableOccupation-selector li.nav-item:not(.group-functions):not(.separator)").removeClass("shrink");
  if ($("#editTable").hasClass("show-map")) {
    $("#tableOccupation-selector li.nav-item:not(.group-functions):not(.separator)").addClass("shrink");
    allstates.forEach(state => {
      var state2 = state === 'ordered' ? 'new-orders' : state;
      if (localStorage["mapShowState" + state] !== "false") {
        $("#tableOccupation-selector .stateSelectors .t-state." + state2).addClass("active");
        $("#tableOccupation-selector li.nav-item." + state2 + ":not(.group-functions):not(.separator)").removeClass("shrink");
      } else {
        $("#tableOccupation-selector .stateSelectors .t-state." + state).removeClass("active");
      }
      if (localStorage["mapmapShowState" + state] !== "false") {
        $("#tableOccupation-selector .mapStateSelectors .t-state." + state2).addClass("active");
      } else {
        $("#tableOccupation-selector .mapStateSelectors .t-state." + state).removeClass("active");
      }
    })
    if (localStorage["mapmapShowStateassign"] !== "false") {
      $("#tableOccupation-selector .mapStateSelectors .t-state.assign").addClass("active");
    } else {
      $("#tableOccupation-selector .mapStateSelectors .t-state.assign").removeClass("active");
    }
    if (!(localStorage["mapShowStateassigned"] !== "false")) {
      $("#tableOccupation-selector li.nav-item.assigned:not(.group-functions):not(.separator)").addClass("shrink");
    }
  }


}

var tableHeadFloated = false;
export const processOrdersDone = function (tables, showEditTableFlag = true, first = true) {
  const now = new Date().getTime();
  updateTableOccupationSelector(first);

  //updateFooterButtons();

  if (!orderListUtil.kioskMode) {
    $("ul#orderListByCustomer").empty();

    var o = orderListUtil.isFiltered() ? orderListUtil.orders : orderListUtil.allOrders;

    var newContent = $("<div/>");

    o.ordersByPayer.forEach(function (order) {
      if (!order.customer)
        order.customer = order.ordersByCustomer[0].customer;
      if (orderListUtil.show(order)) {
        const t = $("script#ordersByPayerTemplate")
          .tmpl({ ...order, ...tmplparams() });
        t.appendTo(newContent);
      }
    });

    replaceContent($("ul#orderListByCustomer"), newContent);

    $("ul#orderListByTiming").empty();
    var ordersByTiming = {};
    o.ordersByTiming.forEach(function (order) {
      if (orderListUtil.show(order)) {
        ordersByTiming[order.timing] = order;
      }
    });
    $("script#ordersByTimingTemplate")
      .tmpl({ ...ordersByTiming, ...tmplparams() })
      .appendTo("ul#orderListByTiming");
  }

  //setRem();
  //showEditTable();

  orderListUtil.ai.setContext({ tableOccupation: { id: sessionStorage.tableOccupationSelected, tableNumber: sessionStorage.tableNumberSelected } });

  setBigTableNumber();

  if (typeof localStorage.atTheTableSelectedTabLeft === "undefined" || ["orders", "byCustomer", "byTiming"].indexOf(localStorage.atTheTableSelectedTabLeft) === -1)
    localStorage.atTheTableSelectedTabLeft = "orders";

  /* tablesOverview.atTheTableSelectedTab = localStorage.atTheTableSelectedTabLeft;
   var tab = $('span[href="#' + localStorage.atTheTableSelectedTabLeft + '"].nav-link');
   if (tab.length > 0 || isVisible(tab)) {
     tab.tab("show");
   }*/

  if (typeof localStorage.selectNewOrders != "undefined" && localStorage.selectNewOrders == "true") {
    if (first)
      selectNewOrders();
    /*
    var tab = $('span[href="#' + localStorage.atTheTableSelectedTabRight + '"].nav-link');
    if (tab.length > 0 || isVisible(tab)) {
      tab.tab("show");
    }
    tablesOverview.atTheTableSelectedTab = localStorage.atTheTableSelectedTabRight;
    */
  } else {
    var orientation = getOrientation();
    if (orientation == "landscape") $("#left_pane").css("width", "100%");
    else $("#left_pane").css("height", "100%");
    if (typeof sessionStorage._editTable != "undefined") {
      try {
        $("#left_pane").resizable("destroy");
        $("#right_pane").resizable("destroy");
      } catch (e) { }
    }
  }
  /*
  var tab = $('span[href="#' + tablesOverview.atTheTableSelectedTab + '"].nav-link');
  if (tab.length > 0 || isVisible(tab)) {
    tab.tab("show");
  }

  var tab = $("#" + tablesOverview.atTheTableSelectedTab + ".tab-pane");
  select(tab);
  */

  //setTimeout(function () {
  orderListUtil.updateHooks();
  topUpdateHooks();

  updatePrintersStatus();
  updateFooterButtons();
  updateHeadings();


  //});
};

var colGroupClone;

export const selectNewOrders = (force) => {
  if (!force && orderListUtil.occupationsSelected.length == 0) return;
  //localStorage.atTheTableSelectedTabRight = settingEnabled("meals/default") ? "meal_menu_tab" : "drink_menu_tab";
  //var tab = $('span[href="#' + localStorage.atTheTableSelectedTabRight + '"].nav-link');
  //if (tab.length > 0 || isVisible(tab)) {
  //    tab.tab("show");
  //  }
  updateRightPane(true);
  gotoTop();
  $("button#new-order").addClass("hidden");
  $("button#lock").addClass("hidden");
  $("button#unlock").addClass("hidden");
  //$('button#close').addClass('hidden');
  $("button#new-order").addClass("hidden");
  $("#left_pane button#maximize").removeClass("hidden");
  $("button#submit-new-orders").prop("disabled", !userConnected());
  $("button#paying").addClass("hidden");
  $("button#paid").addClass("hidden");
  $("#right_pane").removeClass("hidden");
  localStorage.selectNewOrders = true;
  auth.suppressNetworkError = true;
  auth.networkErrorHandler = {
    buttons: [],
    disconnected: function () {
      //auth.networkErrorHandler.buttons = $("#editTable .modal-footer button:not(:disabled),#editTable .modal-header button:not(:disabled)");
      //auth.networkErrorHandler.buttons.prop && auth.networkErrorHandler.buttons.prop("disabled", true);
    },
    connected: function () {
      //auth.networkErrorHandler.buttons && auth.networkErrorHandler.buttons.prop && auth.networkErrorHandler.buttons.prop("disabled", null);
      //delete auth.networkErrorHandler.buttons;
    }
  };
  orderListUtil.ai.setContext({ selectNewOrders: true });

  orientationchangehandler(true);
  var orientation = getOrientation();
  localStorage.atTheTableSelectedTab = $("#right_pane .tab-pane.active").attr("id");
  select($("#right_pane .tab-pane.active"));
  orderListUtil.statesShown = orderListUtil.kioskMode ? auth.myStatus.restaurant_settings["tables-overview"].newOrdersKioskStatesShown : auth.myStatus.restaurant_settings["tables-overview"].newOrdersStatesShown;

  orderListUtil.hidePaid = true;
  $("div#orders.tab-pane.container").empty();
  $("script#orderListMainTemplate")
    .tmpl(tmplparams())
    .appendTo($("div#orders.tab-pane.container"));
  if (!orderListUtil.kioskMode) orderListUtil.statesDisplayed = ["selected"];

  updateOrders([]).done(() => {
  });
  setBigTableNumber();
  updateFooterButtons();
};

var previousorientation2 = null;
function orientationchangehandler(force) {
  //var orientation = window.innerWidth>window.innerHeight ? "landscape" : "portrait";
  var orientation = getOrientation();
  if ((force == undefined || force == false) && previousorientation2 == orientation /* && $('#left_pane .ui-resizable-handle').length>0*/) {
    return false;
  }


  if (previousorientation2 != orientation) {
    tableLayout.tableOccupationsCache = {};
    tableLayout.tableDecorationCache = {};
  }

  previousorientation2 = orientation;
  if ($("#right_pane").hasClass("hidden")) return false;

  if (orientation == "portrait") {
    $("#editTable #container.left-right").css("flex-flow", "column");
    if ($("#left_pane .ui-resizable-handle").length > 0) {
      $("#left_pane").resizable("destroy");
      $("#right_pane").resizable("destroy");
    }
    // you're in PORTRAIT mode
    $("#left_pane").resizable({
      handles: "s",
      resize: function () {
        localStorage.table_overview_right_pane_height = (($("#container").innerHeight() - $("#left_pane").innerHeight()) * 100) / $("#container").innerHeight();
        $("#left_pane").css("height", 100 - localStorage.table_overview_right_pane_height + "%");
        $("#right_pane").css("height", localStorage.table_overview_right_pane_height + "%");
      }
    });

    $("#right_pane").resizable({
      handles: "n",
      resize: function () {
        localStorage.table_overview_right_pane_height = ($("#right_pane").innerHeight() * 100) / $("#container").innerHeight();
        var h = 100 - localStorage.table_overview_right_pane_height;
        $("#left_pane").css("height", h + "%");
        $("#right_pane").css("top", "0px");
      }
    });
    $("#left_pane").css("width", "100%");
    $("#right_pane").css("width", "100%");
  } else {
    $("#editTable #container.left-right").css("flex-flow", "row");
    if ($("#left_pane .ui-resizable-handle").length > 0) {
      $("#left_pane").resizable("destroy");
      $("#right_pane").resizable("destroy");
    }
    $("#left_pane").resizable({
      handles: "e",
      resize: function () {
        localStorage.table_overview_right_pane = (($("#container").innerWidth() - $("#left_pane").innerWidth()) * 100) / $("#container").innerWidth();
        $("#left_pane").css("width", "calc(100% - " + localStorage.table_overview_right_pane + "%)");
        $("#right_pane").css("width", localStorage.table_overview_right_pane + "%");
      }
    });

    $("#right_pane").resizable({
      handles: "w",
      resize: function () {
        localStorage.table_overview_right_pane = ($("#right_pane").innerWidth() * 100) / $("#container").innerWidth();
        $("#left_pane").css("width", "calc(100% - " + localStorage.table_overview_right_pane + "%)");
        $("#right_pane").css("left", "0px");
      }
    });
    $("#left_pane").css("height", "100%");
    $("#right_pane").css("height", "100%");
  }
  if (orientation == "landscape") {
    if (typeof localStorage.table_overview_right_pane == "undefined") {
      localStorage.table_overview_right_pane = 60;
    }
    $("#left_pane").css("width", "calc(100% - " + localStorage.table_overview_right_pane + "%)");
    $("#right_pane").css("width", localStorage.table_overview_right_pane + "%");
    $("#left_pane").css("height", "100%");
    $("#right_pane").css("height", "100%");
  } else {
    if (typeof localStorage.table_overview_right_pane_height == "undefined") {
      localStorage.table_overview_right_pane_height = 60;
    }
    $("#right_pane").css("height", localStorage.table_overview_right_pane_height + "%");
    $("#left_pane").css("height", "calc(100% - " + localStorage.table_overview_right_pane_height + "%)");
    $("#left_pane").css("width", "100%");
    $("#right_pane").css("width", "100%");
  }
  if (chooseMenuItems.status == "maximized") {
    $("#right_pane").css("height", "100%");
    $("#right_pane").css("width", "100%");
  } else if (chooseMenuItems.status == "minimized") {
    $("#left_pane").css("height", "100%");
    $("#left_pane").css("width", "100%");
  }

  return true;
}

export const hideSelectNewOrders = () => {
  //if (typeof handler == "undefined")
  //	handler = null;
  if (!orderListUtil.kioskMode) $("#timingSelector button.timing.active").removeClass("active");

  orderListUtil?.ai?.setContext && orderListUtil.ai.setContext({ selectNewOrders: false });

  if ($("#userSelector button.sticky").length) {
    $("#userSelector button.sticky").removeClass("sticky");
    updateOrders([]);
  }

  $("button#new-order").removeClass("hidden");
  $("button#lock").removeClass("hidden");
  $("button#unlock").removeClass("hidden");
  //$('button#close').removeClass('hidden');
  $("button#new-order").removeClass("hidden");
  $("button#submit-new-orders").addClass("hidden");
  localStorage.selectNewOrders = false;
  $(".selectable.tablemate.btn.btn-primary.active").removeClass("active");
  $(".selectable.tablemate.btn.btn-primary.sticky").removeClass("sticky");

  $("#right_pane").addClass("hidden");
  $("#left_pane button#maximize").addClass("hidden");
  //var orientation = window.innerWidth>window.innerHeight ? "landscape" : "portrait";
  var orientation = getOrientation();
  auth.previousorientation = orientation;
  if (orientation == "landscape") $("#left_pane").css("width", "100%");
  else $("#left_pane").css("height", "100%");
  localStorage.atTheTableSelectedTab = $("#left_pane .tab-content .tab-content .tab-pane.active").attr("id");
  select($("#left_pane .tab-content .tab-content .tab-pane.active"));

  orderListUtil.statesShown = orderListUtil.statesShownOriginal;
  orderListUtil.statesDisplayed = undefined;
  orderListUtil.hidePaid = undefined;

  $("div#orders.tab-pane.container").empty();
  $("script#orderListMainTemplate").tmpl(tmplparams()).appendTo($("div#orders.tab-pane.container"));
  var res = updateOrders([]);
  if (typeof sessionStorage._editTable != "undefined") {
    try {
      $("#left_pane").resizable("destroy");
      $("#right_pane").resizable("destroy");
    } catch (e) { }
  }
  localStorage.removeItem("selectNewOrders");
  auth.suppressNetworkError = false;
  auth.networkErrorHandler = undefined;
  updateFooterButtons();
  return res;
};

export const submitNewOrders = (accepted, print, type) => {
  var def = $.Deferred();

  //if (getAjaxCallCount() > 0) return def.promise();

  var thereAreOrders = false;
  var thereAreCustomerOrders = false;
  var thereArePrintableOrders = false;
  var printable = 0;
  var orders = [];

  if (typeof orders.tables != "undefined")
    orders.tables.forEach(order => {
      if (sessionStorage.tableOccupationSelected == order.tableOccupation && sessionStorage.tableNumberSelected == order.tableNumber) {
        printable += order.unprinted + order.partprinted;
      }
    });

  orderListUtil.ordersCache.forEach(order => {
    if ((order.state == "selected" || (order.state == "accepted" && orderListUtil.kioskMode)) && sessionStorage.tableOccupationSelected == order.tableOccupationId && sessionStorage.tableNumberSelected == order.tableNumber) {
      thereAreCustomerOrders |= order.orderedByCustomer == true;
      thereAreOrders |= order.orderedById == localStorage.id || auth.myStatus.roles.find(r => r.role === "admin") !== null;
      if (order.orderedById == localStorage.id || auth.myStatus.roles.find(r => r.role === "admin") !== null) {
        if (typeof type == "undefined" || order.menuItem.type == type) {
          orders.push(order);
        }
      }
    }
  });


  if (orders.filter(o => o.id < 0).length && !auth.delayedOrder()) {
    return def.promise();
  }

  ajaxCallStart("processing30", 0);

  function ok() {
    auth.vibrateOk(500);
    admin.orderSelectedMenuItems(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, accepted, orders, print, function (data) {
      if (orderListUtil.kioskMode) {
        update(data, function (data) {
          if (print) {
            printNewOrders(orders, undefined, undefined, true);
          }
          ajaxCallEnd("processing30");
        });
      } else {
        hideSelectNewOrders().done(function () {
          update(data, function (data) {
            if (print) {
              printNewOrders(orders, undefined, undefined, true);
              try {
                const table = getTable(sessionStorage.tableNumberSelected);
                if (table.homeDelivery && featureEnabled("homedelivery/printInvoiceOnOrder")) {
                  const occupation = getTableOccupation(sessionStorage.tableOccupationSelected);
                  admin.getInvoiceXML(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, occupation.tableMates[0].id, localStorage.language, 1, moment().startOf("day"), moment().startOf("day").add(1, "day"), function (data) {
                    if (data == '{"success":"true"}') {
                      post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", occupation.tableMates.map(m => {
                        m.states.push({ state: "wantsToPay", duration: 0 });
                        return m;
                      })).done(update);
                    } else if (data.startsWith("<!DOCTYPE HTML")) {
                      printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
                      post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", occupation.tableMates.map(m => {
                        m.states.push({ state: "wantsToPay", duration: 0 });
                        return m;
                      })).done(update);
                    }
                  });
                }
              } catch (ex) { }
              hideAfterPrinted();
            }
            ajaxCallEnd("processing30");
          });
        });
      }
      def.resolve();
    }, () => {
      def.reject();
    });
  }

  if (thereAreOrders) {
    if (thereAreCustomerOrders) {
      ajaxCallEnd("processing30");
      confirmDialog(local.confirmation, local.do_you_really_want_to_submit_all_new_orders).done(function () {
        if (!print) confirmDialog(local.confirmation, admin_local.confirm_not_printing).done(ok);
        else ok();
      });
    } else {
      if (!print && printable > 0) {
        ajaxCallEnd("processing30");
        confirmDialog(local.confirmation, admin_local.confirm_not_printing).done(ok);
      } else ok();
    }
  } else {
    ajaxCallEnd("processing30");
    if (orderListUtil.kioskMode) {
      def.resolve();
    } else {
      hideSelectNewOrders().done(() => {
        def.resolve();
      });
    }
  }

  return def.promise();
};

function hideAfterPrinted(c) {
  if (typeof c == "undefined") c = 30;
  if (c == 0) return;
  if (typeof sessionStorage._editTable == "undefined") return;
  setTimeout(function () {
    if (isVisible($("#print-new-orders.print-all"))) {
      hideAfterPrinted(c - 1);
    } else {
      window.hideEditTable();
    }
  }, 250);
}

export const updateOrdersDone = function () {
  updateTableOccupationSelector();

  var o = orderListUtil.isFiltered() ? orderListUtil.orders : orderListUtil.allOrders;

  updateOrderListByCustomer(true);
  updateOrderListByTiming(true);

  //setTimeout(function () {
  updateHeadings();
  updateFooterButtons();

  orderListUtil.updateHooks();
  topUpdateHooks();
  //});
};

export const updateHeadings = () => {
  $("#zoomlevel2").html(Math.round(auth.zoom * auth.cssZoom * 100));
  var heading = $("#editTableNumber");
  var tableOccupationHeading = $("#tableOccupationNumber");

  var tableMateName = $("#tableMate-name");
  tableMateName.html(" " + I18n.t("admin_local.name_of_customer"));

  var tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);

  if (!tableOccupation || $('#editTable').hasClass('selectTableOccupation')) {
    tableMateName.addClass("hidden");
  } else {
    if (!(isHomeDelivery() || isPickup())) {
      tableMateName.removeClass("hidden");
    } else {
      tableMateName.addClass("hidden");
    }
    if (tableOccupation.tableMates.length === 1) {
      if (tableOccupation.tableMates[0].name) {
        tableMateName.removeClass("hidden");
        if (tableOccupation.tableMates[0].tableMate) {
          const usedPoints = getOrdersPaidBy(tableOccupation.tableMates[0].id).map(o => o.pointin).reduce((a, b) => a + b, 0);
          if (usedPoints > 0)
            tableMateName.html(" <span>" + tableOccupation.tableMates[0].name + "(" + tableOccupation.tableMates[0].tableMate.id + ")" + "</span>" + (tableOccupation.tableMates[0].tableMate.point > 0 ? " <span class='icon-star-filled'>" + tableOccupation.tableMates[0].tableMate.point + (usedPoints ? "-" + usedPoints + "=" + (tableOccupation.tableMates[0].tableMate.point - usedPoints) : "") + "</span>" : ''));
          else
            tableMateName.html(" <span>" + tableOccupation.tableMates[0].name + "(" + tableOccupation.tableMates[0].tableMate.id + ")" + "</span>" + (tableOccupation.tableMates[0].tableMate.point > 0 ? " <span class='icon-star-filled'>" + tableOccupation.tableMates[0].tableMate.point + (usedPoints ? "-" + usedPoints : "") + "</span>" : ''));
        } else
          tableMateName.html(" " + tableOccupation.tableMates[0].name);
      }
    } else {
      if (tableOccupation.leadCustomerId && getTableMate(tableOccupation.leadCustomerId) && getTableMate(tableOccupation.leadCustomerId).name) {
        tableMateName.html(" " + getTableMate(tableOccupation.leadCustomerId).name);
      }
    }
  }

  const customerDetails = $('#editTable #customerDetails');
  customerDetails.find('span').text('');
  if (tableOccupation && (!tableOccupation.bookedProperties || !tableOccupation.bookedProperties.phone)) {
    customerDetails.find("#phone").parent().addClass("pulse-background-infinite");
  } else {
    customerDetails.find("#phone").parent().removeClass("pulse-background-infinite");
  }
  if (tableOccupation && tableOccupation.bookedProperties) {
    customerDetails.removeClass("hidden");
    Object.keys(tableOccupation.bookedProperties).forEach(key => {
      const t = customerDetails.find('span#' + key);
      if (t.length > 0)
        t.text(tableOccupation.bookedProperties[key]);
    })
    customerDetails.find("#payment_methods button").removeClass("active");
    if (tableOccupation.bookedProperties?.payment_method) {
      customerDetails.find("#payment_methods button#" + tableOccupation.bookedProperties?.payment_method).addClass("active");
    }

    function formatTime(timestamp) {
      const now = moment();
      const date = moment(timestamp);

      if (date.isSame(now, "day")) {
        return `${I18n.t("admin_local.today")} ${date.format("HH:mm")}`;
      } else if (date.isSame(now.clone().add(1, "day"), "day")) {
        return `${I18n.t("admin_local.tomorrow")} ${date.format("HH:mm")}`;
      } else if (date.isSame(now.clone().add(-1, "day"), "day")) {
        return `${I18n.t("admin_local.yesterday")} ${date.format("HH:mm")}`;
      } else {
        return date.format("YYYY-MM-DD HH:mm");
      }
    }

    if (tableOccupation.bookedOccupationEnd) {
      if (moment(tableOccupation.bookedOccupationStart).valueOf() === moment(tableOccupation.bookedOccupationStart).startOf('day').valueOf() && moment(tableOccupation.bookedOccupationEnd).valueOf() === moment(tableOccupation.bookedOccupationEnd).endOf('day').valueOf()) {
        customerDetails.find("#time").html("<div style='padding-left:.5rem'>" + moment(tableOccupation.bookedOccupationStart).format("LL") + " " + local.allDay + "</div>");
      } else {
        customerDetails.find("#time").html("<div style='padding-left:.5rem'>" + formatTime(tableOccupation.bookedOccupationStart) + "</div>");
      }
    } else {
      const start = moment(tableOccupation.bookedOccupationStart ? tableOccupation.bookedOccupationStart : tableOccupation.occupationStart);
      if (start.clone().startOf('day').valueOf() == moment().startOf('day').valueOf()) {
        if (start.clone().valueOf() === start.clone().startOf('day').valueOf())
          customerDetails.find("#time").html(admin_local.today + " " + local.allDay);
        else
          customerDetails.find("#time").html(admin_local.today + " " + start.format("LT"));
      } else {
        if (start.valueOf() === start.startOf('day').valueOf())
          customerDetails.find("#time").html(start.format("LL") + " " + local.allDay);
        else
          customerDetails.find("#time").html(start.format("LLLL"));
      }
    }
  } else {
    customerDetails.addClass("hidden");
  }

  var dropDown = $("#editTableNumber.dropdown-menu");
  var caret = $("button#editTableNumber");
  dropDown.empty();
  if (tableOccupation != null) {
    var price = 0;
    var o = orderListUtil.isFiltered() && typeof orderListUtil.orders.count != "undefined" ? orderListUtil.orders : orderListUtil.allOrders;
    o.tables.forEach(function (order) {
      if (orderListUtil.show(order)) {
        price += order.discountedPrice;
      }
    });

    if (orderListUtil.occupationsSelected.length == 1 && orderListUtil.occupationsSelected[0].leadCustomerId > 0) {
      var t = admin.getTableMate(orderListUtil.occupationsSelected[0].leadCustomerId);
      heading.text(getTableName(sessionStorage.tableNumberSelected));
      tableOccupationHeading.text(String.format(admin_local.table_occupation_number, tableOccupation.seqnr) + " - " + price + " " + auth.myStatus.restaurant_base_currency.name);
    } else {
      heading.text(getTableName(sessionStorage.tableNumberSelected));
      if (orderListUtil.occupationsSelected.length == 0) tableOccupationHeading.text("");
      else tableOccupationHeading.text(String.format(admin_local.table_occupation_number, tableOccupation.seqnr) + " - " + price + " " + auth.myStatus.restaurant_base_currency.name);
    }

    if (tableOccupation.restaurantTables.length < 2) caret.removeClass("dropdown-toggle");
    else {
      caret.addClass("dropdown-toggle");
      tableOccupation.restaurantTables.forEach(function (table) {
        dropDown.append(
          $(
            '<button onclick="sessionStorage.tableNumberSelected=' +
            table.restaurantTable.number +
            ';updateOrders([])" class="dropdown-item">' +
            getTableName(table.restaurantTable.number) +
            "</button>"
          )
        );
      });
    }
  } else {
    caret.removeClass("dropdown-toggle");
  }
}

export const updateFooterButtons = () => {
  //const now = new Date().getTime();
  if (orderListUtil.kioskMode) {
    $("#editTable").removeClass("homedelivery");
    $("#editTable").removeClass("pickup");
    kioskModeUpdateFooterButtons();
    return;
  }

  $("#editTable button#closeOrder").addClass("hidden");

  $("#_byCustomer.nav-item").show();
  $("#_byTiming.nav-item").show();
  var thereAreOrders = false;
  var thereAreCustomerOrders = false;
  var printable = 0;

  const showCustomerScreenState = store.getState().rootReducer.customerScreen;
  if (showCustomerScreenState.showCustomerScreen) {
    if (orderListUtil.orders && orderListUtil.orders.tables) {
      var res = orderListUtil.orders.tables.filter(o => Number(o.tableNumber) === Number(sessionStorage.tableNumberSelected) && Number(o.tableOccupation) === Number(sessionStorage.tableOccupationSelected));
      if (res)
        res.map(o => {
          o.orders.forEach(o => o.orders.forEach(o => o.childOrders.forEach(o => o.menuItem = getMenuItem(o.menuItem.id))));
          return o;
        })
      updateDataOnCustomerScreen(res).fail(() => {
      });
    } else {
      updateDataOnCustomerScreen();
    }
  }

  if (typeof orderListUtil.ordersCache != "undefined")
    orderListUtil.ordersCache.forEach(order => {
      if (sessionStorage.tableOccupationSelected == order.tableOccupationId && sessionStorage.tableNumberSelected == order.tableNumber) {
        if (order.state == "selected") {
          thereAreCustomerOrders |= order.orderedByCustomer == true;
          thereAreOrders |= order.orderedById == localStorage.id || auth.myStatus.roles.find(r => r.role === "admin") !== null;
        }
      }
    });

  if (typeof orderListUtil.orders.tables != "undefined")
    orderListUtil.orders.tables.forEach(order => {
      if (sessionStorage.tableOccupationSelected == order.tableOccupation && sessionStorage.tableNumberSelected == order.tableNumber) {
        printable += order.unprinted + order.partprinted;
      }
    });

  var booked = false;
  if (sessionStorage.tableOccupationSelected != null && sessionStorage.tableOccupationSelected != "null") {
    var tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);
    if (tableOccupation && tableOccupation.occupationStart == null) booked = true;
  }

  const isPickup = Number(sessionStorage.tableNumberSelected) === auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"];
  const isHomeDelivery = Number(sessionStorage.tableNumberSelected) === auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"];
  if (isPickup) {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#lock text").html(I18n.t("admin_local.lock_pickup"));
  } else if (isHomeDelivery) {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#lock text").html(I18n.t("admin_local.lock_homedelivery"));
  } else {
    if (orderListUtil.occupationsSelected.length > 0) {
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#lock text").html(admin_local.new_lock);
    } else {
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#lock text").html(admin_local.lock);
    }
  }

  const delays = $("#delays");
  delays.empty();

  if (isHomeDelivery && auth.myStatus.restaurant_settings["enabled-features"].homedelivery.delays) {

    const defaultDelay = auth.myStatus.restaurant_settings["enabled-features"].homedelivery.timeahead;
    auth.myStatus.restaurant_settings["enabled-features"].homedelivery.delays.forEach(delay => {
      const isdefault = defaultDelay == (Math.round(delay / 60 * 100) / 100);
      $('<label id="delay-' + delay + '" level="2" onMouseUp="updateTimeahead(\'homedelivery\', ' + delay + ')" class="selectable btn btn-positive ' + (isdefault ? 'active' : '') + '" style=""><input type="radio" name="options" id="delay-' + delay + '" autocomplete="off" checked=' + isdefault + '>' + delay + '</label>').appendTo(delays);
    });
    $("<span style='color: burlywood;padding-left:10px'>" + admin_local.minute + "</span>").appendTo(delays);
    //$("#editTable #tableMate-name").hide();
  } else {
    //$("#editTable #tableMate-name").show();
  }

  $("#editTable #bookingDetails").addClass("hidden");

  if (auth.myStatus.restaurant_settings["tables-overview"].timeout && !isPickup && !isHomeDelivery) {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#freezelock").removeClass("hidden");
  } else {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#freezelock").addClass("hidden");
  }

  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#close").attr("disabled", null);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").attr("disabled", null);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paid").attr("disabled", null);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-new-orders").attr("disabled", null);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-new-orders").attr("disabled", null);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders").attr("disabled", null);

  if (isThereReceiptsToPrint()) {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#payments").removeClass("hidden");
  } else {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#payments").addClass("hidden");
  }

  if (tableOccupation) {

    $("text#personCount").html(tableOccupation.personCount);

    const payingMates = tableOccupation.tableMates.filter(t => (t.active || t.isActive) && (t.payingMateId === null || t.payingMateId === t.id));
    if (payingMates.length === 1 && getStateIndex(payingMates[0], "wantsToPay") >= 0) {
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying text").html(I18n.t("admin_local.cancel_paying"));
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").removeClass("btn-primary");
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").addClass("btn-danger");
    } else {
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying text").html(I18n.t("admin_local.invoice"));
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").addClass("btn-primary");
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").removeClass("btn-danger");
    }
  } else {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying text").html(I18n.t("admin_local.invoice"));
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").addClass("btn-primary");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").removeClass("btn-danger");
  }

  if (isHomeDelivery) {
    $("#editTable").addClass("homedelivery");
    $("#editTable").removeClass("pickup");
  } else if (isPickup) {
    $("#editTable").addClass("pickup");
    $("#editTable").removeClass("homedelivery");
  } else {
    $("#editTable").removeClass("homedelivery");
    $("#editTable").removeClass("pickup");
  }


  var bookingDetails = $("#editTable >.modal-dialog > .modal-content > .modal-footer #bookingDetails");
  if (booked) {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-new-orders").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#close").removeClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders-choice").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders-choice2").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders-drinks").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders-meals").addClass("hidden");
    var bookedProperties = tableOccupation.bookedProperties;
    bookingDetails.removeClass("hidden");
    bookingDetails.find("#time").html(moment(tableOccupation.bookedOccupationStart).format("HH:mm"));
    bookingDetails.find("#endtime").html(moment(tableOccupation.bookedOccupationEnd).format("HH:mm"));
    if (bookedProperties) {
      bookingDetails.find("#name").html(bookedProperties.email);
      bookingDetails.find("#phone").html(bookedProperties.phone);
      var tables = "";
      if (bookedProperties.seats)
        Object.keys(bookedProperties.seats).forEach(table => {
          if (tables != "") tables += "  ";
          tables += '<span class="i_table_51">' + table + '-</span><span class="i_chair_49"></span><span>' + bookedProperties.seats[table] + "</span>";
        });
      bookingDetails.find("#comment").html(bookedProperties.comment);
    }
    bookingDetails.find("#tables").html(tables);
  } else if (thereAreOrders && localStorage.selectNewOrders == "true") {
    bookingDetails.addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-new-orders").removeClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders").removeClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders-choice").removeClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders-choice2").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders-drinks").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-new-orders-meals").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#close").addClass("hidden");
  } else {
    bookingDetails.addClass("hidden");
    $("#editTable button#submit-and-accept-new-orders").addClass("hidden");
    $("#editTable button#submit-and-accept-and-print-new-orders").addClass("hidden");
    $("#editTable button#close").removeClass("hidden");
    $("#editTable button#submit-and-accept-and-print-new-orders-choice").addClass("hidden");
    $("#editTable button#submit-and-accept-and-print-new-orders-choice2").addClass("hidden");
    $("#editTable button#submit-and-accept-and-print-new-orders-drinks").addClass("hidden");
    $("#editTable button#submit-and-accept-and-print-new-orders-meals").addClass("hidden");
  }

  const orderRole = hasRole("sales.tablesoverview.view");

  if (orderRole)
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#qrcode").removeClass("hidden");
  else
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#qrcode").addClass("hidden");
  //$("#editTable >.modal-dialog > .modal-content > .modal-footer button#close").removeClass("hidden");
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#cancel").addClass("hidden");
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#submit-and-accept-and-print-and-pay-new-orders").addClass("hidden");

  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#unlock").attr("disabled", null);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#lock").attr("disabled", null);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#qrcode").attr("disabled", null);
  if (typeof sessionStorage.tableOccupationSelected !== "undefined" && sessionStorage.tableOccupationSelected != null && sessionStorage.tableOccupationSelected != "null" && getTableOccupation(sessionStorage.tableOccupationSelected))
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#takeaway").toggleClass("active", getTableOccupation(sessionStorage.tableOccupationSelected).takeaway);
  else $("#editTable >.modal-dialog > .modal-content > .modal-footer button#takeaway").toggleClass("active", false);

  $("#editTable .nav.nav-tabs.nav-justified").removeClass("hidden");
  if (booked) {
    $("div#editTable .modal-body > div#container").removeClass("hidden");
    $("#editTable .nav.nav-tabs.nav-justified").addClass("hidden");
    if (hasRole("sales.tablesoverview.view")) {
      $("button#lock").removeClass("hidden");
    }
    $("button#unlock").addClass("hidden");
    $("button#new-order").addClass("hidden");
    $("button#paying").addClass("hidden");
    $("button#paid").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#takeaway").attr("disabled", true);
  } else if (orderListUtil.occupationsSelected.length == 0) {
    $("div#editTable .modal-body > div#container").addClass("hidden");
    $("button#unlock").addClass("hidden");
    $("button#new-order").addClass("hidden");
    $("button#paying").addClass("hidden");
    $("button#paid").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#takeaway").attr("disabled", true);
  } else {
    $("div#editTable .modal-body > div#container").removeClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#takeaway").attr("disabled", false);
    if (localStorage.selectNewOrders != "true") {
      if (orderRole)
        $("#editTable >.modal-dialog > .modal-content > .modal-footer button#new-order").removeClass("hidden");
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").removeClass("hidden");
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paid").removeClass("hidden");
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#unlock").removeClass("hidden");
    } else {
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").addClass("hidden");
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paid").addClass("hidden");
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#new-order").addClass("hidden");
      $("#editTable >.modal-dialog > .modal-content > .modal-footer button#unlock").addClass("hidden");
    }
  }
  if (orderRole)
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#edit-discount").removeClass("hidden");
  else
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#edit-discount").addClass("hidden");

  if (booked && orderRole) {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#edit-discount").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#takeaway").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#unbook").removeClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#activatebooking").removeClass("hidden");
  } else {
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#unbook").addClass("hidden");
    $("#editTable >.modal-dialog > .modal-content > .modal-footer button#activatebooking").addClass("hidden");
  }

  var table = getTable(sessionStorage.tableNumberSelected);
  var lockNotPossible = !orderRole || ((orderListUtil.occupationsSelected.length > 0 && table.shareable != true && !booked) || localStorage.selectNewOrders == "true");
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#lock").toggleClass("hidden", lockNotPossible);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#unlock").prop("disabled", orderListUtil.occupationsSelected.length == 0 || localStorage.selectNewOrders == "true");
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#new-order").prop("disabled", !orderRole || orderListUtil.occupationsSelected.length == 0);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#qrcode").prop("disabled", orderListUtil.occupationsSelected.length == 0);

  if (!hasRole("sales.printinvoice"))
    $("button#paying").addClass("hidden");
  if (!hasRole("sales.registerpayment"))
    $("button#paid").addClass("hidden");

  var tableMateChoicesSet = new SortedSet({ comparator: customerComparator });
  var payingTableMatesSet = new SortedSet({ comparator: customerComparator });
  var thereAreNonPayers = false;
  admin.tableMates.forEach(function (tableMateId) {
    var tableMate = getTableMate(tableMateId);
    if (tableMate.tableOccupationId == Number(sessionStorage.tableOccupationSelected) && tableMate.tableNumber == Number(sessionStorage.tableNumberSelected)) {
      var t;
      if (tableMate.payingMateId == 0) t = tableMate;
      else t = getTableMate(tableMate.payingMateId);
      if (t == undefined) return;
      if (SortedSet.find(payingTableMatesSet, t) == null) {
        payingTableMatesSet.insert(t);
      }
      if (getStateIndex(t, "wantsToPay") >= 0) {
        if (SortedSet.find(tableMateChoicesSet, t) == null) tableMateChoicesSet.insert(t);
      } else {
        thereAreNonPayers = true;
      }
    }
  });
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#new-order").attr("disabled", !orderRole || !thereAreNonPayers);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#edit-discount").attr("disabled", !orderRole || !thereAreNonPayers);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#takeaway").attr("disabled", !orderRole || !thereAreNonPayers);

  var count = getOpenOrdersCount(payingTableMatesSet);
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paying").prop("disabled", orderListUtil.occupationsSelected.length == 0 || count == 0 || localStorage.selectNewOrders == "true");
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#paid").prop("disabled", orderListUtil.occupationsSelected.length == 0 || count == 0 || (localStorage.selectNewOrders == "true" && !orderListUtil.kioskMode));
  $("#editTable >.modal-dialog > .modal-content > .modal-footer button#unlock").prop("disabled", count > 0);


};

export const show = function (order) {
  if (typeof order.tableNumber !== "undefined") {
    return order.tableNumber == sessionStorage.tableNumberSelected && order.tableOccupation == sessionStorage.tableOccupationSelected;
  } else {
    return order.customer.tableNumber == sessionStorage.tableNumberSelected && order.customer.tableOccupationId == sessionStorage.tableOccupationSelected;
  }
};


export const filter = function (order) {
  if (!orderListUtil.isFiltered())
    return !order.orderedByCustomer || !(order.orderedByCustomer && order.state === "selected");
  const stickyMates = [];
  $("#userSelector button.active.sticky").each((ind, m) => stickyMates.push(Number(m.id)));
  return (order.tableOccupationId == sessionStorage.tableOccupationSelected && (!stickyMates.length || stickyMates.indexOf(order.forWhomId) >= 0));
  /*
  if (isSelectedFiltered()) {
    if (localStorage.selectNewOrders == "true") return orderListUtil.statesShown.indexOf(order.state) != -1;
    return order.state == "selected";
  } else {
    return true;
  }
  */
};

export const getCrc2 = () => {

  var count = orderListUtil.ordersCache.filter(o => o.recordState == "ACTIVE").length + orderListUtil.ordersCache.filter(o => o.recordState == "ACTIVE" && o.id >= 0).map(o => {
    const t = allstates2.indexOf(o.originalState || o.state);
    return t >= 0 ? t : 0;
  }
  ).reduce((a, b) => a + b, 0);
  return count;
};
export const getCrc = () => {
  var count = orderListUtil.ordersCache.filter(o => o.recordState == "ACTIVE" && o.id >= 0).length;
  return count;
};

var crcTimeout = null;

var prevCrc2 = null;

var crcErrorCount = 0;



const channel = new BroadcastChannel('customerScreen');

export const serverSideMessageHandler = message => {
  if (message.type == "timeout" && message.message == "true") {
    const crcs = orderListUtil.ordersCache.filter(o => o.recordState == "ACTIVE" && o.id > 0).sort((a, b) => a.id - b.id).map(o => {
      const t = allstates2.indexOf(o.originalState || o.state);
      return t >= 0 ? [o.id, t] : null;
    });
    if (message.crc2) {
      const crc = getCrc();
      const crc2 = getCrc2();
      if (message.crc2 !== crc2) {
        //console.log(crcs);

        // console.log("crc " + message.crc + "/" + message.crc2);
        if (crcErrorCount && prevCrc2 != message.crc2) {
          //post("restaurantService/" + localStorage.restaurantSelected + "/logOrderDifference", crcs, undefined, false, 0, true).fail(() => auth.ajaxError = false);
          console.error("crc error localOrderCount=" + crc + "/" + crc2 + " serverOrderCount=" + message.crc + "/" + message.crc2 + " new Orders:" + orderListUtil.newOrders.length);
          prevCrc2 = message.crc2;
        }
        if (crcErrorCount++ > 5) {
          if (crc > message.crc)
            console.error("crc error (" + crcErrorCount + ") ahead localOrderCount=" + crc + "/" + crc2 + " serverOrderCount=" + message.crc + "/" + message.crc2);
          else
            console.error("crc error (" + crcErrorCount + ") behind localOrderCount=" + crc + "/" + crc2 + " serverOrderCount=" + message.crc + "/" + message.crc2);
          crcErrorCount = 0;
          recoverFromEventSourceError(true, true);
          return;
        }
      } else {
        if (prevCrc2 != message.crc2) {
          //console.log("crc ok localOrderCount=" + crc2 + "/" + crc + " serverOrderCount=" + message.crc + "/" + message.crc2);
          prevCrc2 = message.crc2;
        }
        if (crcErrorCount) { //crc is ok 
          if (crcErrorCount++ > 1) {
            console.error("crc ok (" + crcErrorCount + ") localOrderCount=" + crc + "/" + crc2 + " serverOrderCount=" + message.crc + "/" + message.crc2);
          }
          crcErrorCount = 0;
        }
      }
    } else if (message.crc) {
      const crc = getCrc();
      if (message.crc !== crc) {
        if (crcErrorCount++ > 1) {
          //post("restaurantService/" + localStorage.restaurantSelected + "/logOrderDifference", crcs, undefined, false, 0, true).fail(() => auth.ajaxError = false);
          console.error("crc error (" + crcErrorCount + ") localOrderCount=" + crc + " serverOrderCount=" + message.crc);
        }
        if (crcErrorCount++ > 5) {
          crcErrorCount = 0;
          crcTimeout = null;
          if (crc > message.crc) {
            console.error("crc error ahead localOrderCount=" + crc + " serverOrderCount=" + message.crc);
          } else {
            console.error("crc error behind localOrderCount=" + crc + " serverOrderCount=" + message.crc);
          }
          recoverFromEventSourceError(true, true);
          return;
        } else {
          if (crcErrorCount) { //crc is ok 
            if (crcErrorCount > 1) {
              console.error("crc ok (" + crcErrorCount + ") localOrderCount=" + crc + " serverOrderCount=" + message.crc);
            }
            crcErrorCount = 0;
          }

        }
      }
    }
    return;
  }
  if (message.CustomerScreen) {
    console.log(message);
    channel.postMessage(message);
  } else if (message.type == "message") {
    const value = typeof message.value !== "undefined" ? message.value : message.message;
    auth.showServerSideMessageBubble(value);
  } else if (message.type == "show") {
    const key = message.Printer;
    if (!message.message) {
      $("div.messages span[key = '" + key + "'").remove();
    } else {
      const msg = eval(message.message);
      if ($('div.messages span').filter((ind, span) => $(span).attr("msg") == msg).length === 0)
        $("<span key='" + key + "' msg='" + msg + "'>" + msg + "</span>").appendTo($("div.messages"));
    }
    //messageDialog(local.warning,message );
  } else if (message.type == "phoneringing" && (!message.fromId || message.fromId == auth.myStatus.id)) {
    if (featureEnabled("voipphone") && (!featureEnabled("voipphone/hideOnTablesOverview") || isHomeDelivery() || isPickup()))
      store.dispatch(EatWithMeActions.phoneringing(message.message));
  } else if (message.type == "phoneend" && (!message.fromId || message.fromId == auth.myStatus.id)) {
    store.dispatch(EatWithMeActions.phoneend(message.message));
  } else if (message.type == "reload") {
    _log("LOGIN: reload requested from server");
    setTimeout(() => {
      //eslint-disable-next-line
      location.reload();
    }, 1000);
  } else if (message.type == "refresh") {
    if (message.message === "rbac changed") {
      store.dispatch(EatWithMeActions.rbac(message.data));
      _log("LOGIN: rbac changed, reload requested from server");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (message.message === "full refresh needed") {
      recoverFromEventSourceError();
    } else if (message.message === "courier update" || message.message === "courier position update") {
      store.dispatch(EatWithMeActions.updateDeliveryUsers(message.data));
    } else if (message.message == "true") {
      admin.getMyStatus();
    } else if (message.message == "table changed" || message.message == "table added") {
      if (message.data) {
        update(message.data);
      } else admin.getTableOccupation(message.TableOccupation, updateTableOccupations);
    } else if (message.message == "table occupied" || message.message == "table changed") {
      if (message.data) update(message.data);
      else admin.getTableOccupation(message.TableOccupation, updateTableOccupations);
    } else if (message.message == "restart-printer-server") {
      get('http://localhost:8080/printerService/restart').fail(() => auth.ajaxError = false);
    } else if (message.message == "reboot-printer-server") {
      get('http://localhost:8080/printerService/reboot').fail(() => auth.ajaxError = false);
    } else if (message.message == "table unlocked") {
      //if (message.data) update(message.data);
      deleteTableOccupations(message.TableOccupation);
    } else if (
      message.message == "table mate joined" ||
      message.message == "table mate unjoined" ||
      message.message == "table mate state changed" ||
      message.message == "table mate entered state" ||
      message.message == "table edit" ||
      message.message == "table mate cancelled state"
    ) {
      if (message.data) update(message.data);
      else admin.getTableOccupation(message.TableOccupation, updateTableOccupations);
    } else if (message.message == "order changed" || message.message == "new order" || message.message == "new order selected" || message.message == "order state changed") {
      if (message.message == "new order") playNewAcceptedOrderSound();
      if (message.data) {
        if (message.message === "order state changed" && message.TableOccupation) {
          if (getTableOccupation(message.TableOccupation))
            update(message.data);
        } else {
          update(message.data);
        }
      } else {
        admin.getTableOccupation(message.TableOccupation, data => {
          admin.getOrder(message.TableOccupation, message.Order, function (orders) {
            update({ tableOccupations: data, orders: orders });
            if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
          });
        });
      }
    } else if (message.message == "order cancelled") {
      if (message.data) {
        deleteOrders(message.Order, true);
        update(message.data);
      } else {
        deleteOrders(message.Order);
        if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
      }
    } else if (message.message == "layout switched") {
      auth.myStatus.restaurant_active_floorplan = message.floorplan;
      if (orderListUtil.tablesOverview) {
        tableLayout.reset();
        tableLayout.initialize();
      }
      $(".floorplan-picker").removeClass("checked");
      $("#" + message.floorplan + ".floorplan-picker").addClass("checked");
    } else if (message.message == "settings changed") {
      Object.keys(message.data).forEach(function (key) {
        auth.myStatus[key] = message.data[key];
      });
      auth.setMyStatus(auth.myStatus);
    } else if (message.message == "layout changed") {
      getMyStatus(function (data) {
        if (orderListUtil.tablesOverview) {
          tableLayout.reset();
          tableLayout.initialize();
          tableLayout.updateTableOccupations();
        }
      });
    } else if (message.message == "menu changed") {
      admin.getActiveMenuItems(function (cats) {
        admin.categories = cats;
        //admin.getMyStatus(function (data) {
        updatePrices(admin.categories);
        updateOrders([]);
        updateRightPane();
        //});
      }, localStorage.language);
    } else if (message.message == "printer status changed") {
      admin.getPrintersStatus(updatePrintersStatus);
    } else if (message.message == "delivery update" && bookingMap) {
      bookingMap.updateDelivery(message.data);
    } else {
      auth.serverSideMessageHandler(message);
    }
  } else {
    auth.serverSideMessageHandler(message);
  }
};

function reload() {
  ajaxCallStart("processing3");
  processRestaurant();
}

export const processRestaurant = (recovery = false, first = true, clearCache = false) => {
  if (orderListUtil.tablesOverview) tableLayout.initialize();

  var tableNumbers = $("#c .eatwithme-tableNumber");
  try {
    tableNumbers.each(function (ind, t) {
      try {
        var tableNumber = $(t).attr("id");
        if (tableNumber.indexOf("-") > 0) tableNumber = tableNumber.split("-")[0];
        var t = getTable(tableNumber);
        var table = $("#" + tableNumber + ".eatwithme-table");
        if (table != null) {
          var table2 = getTable(tableNumber);

          if (table2 == null) {
            return;
          } else {
            var tn = $("tspan#" + tableNumber + ".eatwithme-tableNumber");
            tn.html(t.name != "" ? t.name : "a" + tableNumber);
          }

          if (!table2.isActive == true) {
            $(table).addClass("inactive");
          }
          if (table2.shareable == true) {
            $(table).addClass("shareable");
          }
        }
      } catch (ex) {
        alert(ex);
      }
    });
    ajaxCallStart("processing5");
    try {
      admin.resync([], (data) => {
        //getTableOccupations(data => {

        try {
          compressToBase64(JSON.stringify(data.orders));
        } catch (ex) {
          console.error(ex);
        }


        processTableOccupations({ ...data, first });
      }, recovery, clearCache);
      orderListUtil.updateHooks();
      topUpdateHooks();
    } catch (ex) {
      alert(ex);
    } finally {
      ajaxCallEnd("processing5");
    }
  } catch (ex) {
    alert(ex);
  } finally {
    ajaxCallEnd("processing3");
  }
}

export const resize = r => {
  //if (typeof chooseMenuItems == "undefined") return;
  if (r) {
    $(".movableBox").each(function (ind, trigger) {
      var key = $(trigger).attr("id") + "-" + localStorage.restaurantSelected + "_box_position-" + Math.round(window.innerWidth / 10) + "x" + Math.round(window.innerHeight / 10);
      var left = localStorage[key + "-left"];
      var top = localStorage[key + "-top"];
      if (left) {
        $("#" + $(trigger).attr("id") + ".movableBox").css("left", (left ? left : 50) + "%");
        $("#" + $(trigger).attr("id") + ".movableBox").css("top", (top ? top : 50) + "%");
      }
    });
  }

  orientationchangehandler();
  tableLayout.resize();
};

export const renderCategories = (categories, element, reset = false) => {
  if (!element) return;
  // Calculate tmplparams once before rendering
  const params = tmplparams();

  const e = $(element);

  ReactDOM.hydrate(
    <CategoryList reset={false} categories={categories.filter(item => item.isActive && item.isTop && item.defaultPos)} {...params} />,
    element
  );

  if (reset) {
    // Render the categories using React
    ReactDOM.hydrate(
      <CategoryList reset={reset} categories={categories.filter(item => item.isActive && item.isTop && item.defaultPos)} {...params} />,
      element
    );
  }
}


export const updateRightPane = (reset = false) => {
  //$("#drink_menu .selectable").remove();
  //$("#meal_menu .selectable").remove();
  $("#timingSelector").replaceWith($("#timingSelectorTemplate").tmpl(tmplparams()));


  //const days = admin_local.days.map((day, ind) => '<div d=' + (ind + 1) + ' class="day hidden" style="grid-column-start:' + (ind + 1) + '">' + day + '</div>').join("");
  const days = admin_local.days.map((day, ind) => (
    <div
      key={ind}
      d={ind + 1}
      className="day hidden"
      style={{ gridColumnStart: ind + 1 }}
    >
      {day}
    </div>
  ));
  if (admin?.categories?.activeMenuCategories)
    renderCategories(admin.categories.activeMenuCategories, $("#right_pane_content").get(0), reset);


  $(".menuItemHead").each((ind, e) => e.addEventListener("touchstart", touchStart, {
    capture: true,
    passive: false
  }));
  $(".list-group-item.defaultQuantity").each((ind, e) => e.addEventListener("touchstart", touchStart, {
    capture: true,
    passive: false
  }));

  if (isAdmin(auth.myStatus.roles)) {
    chooseMenuItems.attacheContextMenus();
  }
}

export const processTableOccupations = ({ activeMenuCategories, orders, tableOccupations, first = true }) => {
  const def = $.Deferred();
  orderListUtil.tableOccupations = tableOccupations;
  ajaxCallStart("processing6");
  //admin.resync([], ({ activeMenuCategories, orders }) => {
  try {
    admin.categories = { activeMenuCategories: activeMenuCategories };
    updatePrices(admin.categories);
    if (first)
      updateRightPane();
    ajaxCallStart("processing7");
    try {
      //admin.getUnprocessedOrders([], function (orders) {
      orderListUtil.ordersCache = orders;
      buildOrderIndex();

      orderListUtil.newOrders.forEach(o => addOrder(o));

      orderListUtil.ordersCache.sort((a, b) => { return a.id - b.id });

      ajaxCallStart("processing8");
      try {
        updateTableMates()
          .done(function () {
            try {
              updatePayingMates();
              orderListUtil.processAllOrders(orders);
              if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
              if ($("#editTable").length > 0 && $("#editTable").css("display") != "none") {
                orderListUtil.processOrders(orderListUtil.ordersCache, undefined, first);
                if (typeof localStorage.selectNewOrders != "undefined" && localStorage.selectNewOrders == "true") {
                  if (first)
                    selectNewOrders();
                  /*
                  var tab = $('span[href="#' + localStorage.atTheTableSelectedTabRight + '"].nav-link');
                  if (tab.length > 0 || isVisible(tab)) {
                    tab.tab("show");
                  }
                  tablesOverview.atTheTableSelectedTab = localStorage.atTheTableSelectedTabRight;*/
                }
                updateOrders([]);
              } else {
                if (sessionStorage.tableNumberSelected != undefined && sessionStorage.tableNumberSelected != 0 && typeof sessionStorage._editTable != "undefined") {
                  updateTableMates().done(function () {
                    showEditTable();
                    orderListUtil.processOrders(orderListUtil.ordersCache);
                    if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
                  });
                }
              }
              orderListUtil.startThisPoll();
              def.resolve();
            } finally {
              ajaxCallEnd("processing8");
            }
          })
          .fail(function (data) {
            console.log(data);
          });
      } finally {
        ajaxCallEnd("processing7");
      }
      //});
    } finally {
    }
  } finally {
    ajaxCallEnd("processing6");
  }
  //}, localStorage.language);
  return def.promise();
};

export const updateTableOccupationsAndSelect = (data, continueToNewOrders) => {
  selectTableOccupation(data.tableOccupation ? data.tableOccupation.id : data.tableOccupations ? data.tableOccupations[0].id : data[0].id);
  updateTableOccupations(data.tableOccupation ? [data.tableOccupation] : data.tableOccupations ? data.tableOccupations : data).done(function () {
    selectTableOccupation(data.tableOccupation ? data.tableOccupation.id : data.tableOccupations ? data.tableOccupations[0].id : data[0].id);
    if (continueToNewOrders == true || (typeof pre_selected_action != "undefined" && tableLayout.pre_selected_action == "pre-lock-order")) selectNewOrders();
  });
  selectTableOccupation(data.tableOccupation ? data.tableOccupation.id : data.tableOccupations ? data.tableOccupations[0].id : data[0].id);
};

export const stopIntervals = () => {
  clearInterval(updateCycle);
  clearInterval(lockCycle);
  document.removeEventListener("resume", recoverFromEventSourceError);

};

function makeElement(tag, attrs) {
  var el = document.createElementNS("http://www.w3.org/1999/xhtml", tag);
  for (var k in attrs) el.setAttribute(k, attrs[k]);
  return el;
}

var dummyf = function () { };

export const resetPreSelection = () => {
  var tables = $(".eatwithme-table.selected").removeClass("selected");
  var tables = $("g.eatwithme-table")
    .parent()
    .parent();
  var deselectedClass = "faded";
  tables.removeClass(deselectedClass);
  $("line.table-connections").removeClass(deselectedClass);
};

var timeoutCount = 0;
var topUpdateHooksExecuted = false;

export const topUpdateHooks = () => {
  var $editTable = $("#editTable > .modal-dialog > .modal-content > .modal-body");

  if (admin.tableMates) {
    var mates = [];
    admin.tableMates.forEach(tableMateId => {
      var tableMate = getTableMate(tableMateId);
      if (tableMate.active == true && tableMate.tableOccupationId == sessionStorage.tableOccupationSelected && tableMate.tableNumber == sessionStorage.tableNumberSelected) {
        mates.push(tableMate);
      }
    });
    const stickyMates = $('#userSelector button.active.sticky');
    const stickyIds = [];
    stickyMates.each((ind, m) => stickyIds.push(m.id));
    if (mates.length > 1) {
      $("#userSelector").replaceWith($("#userSelectorTemplate").tmpl({ tableMates: mates, getTableMate: getTableMate, local_name: I18n.t("local.name") }));
    }
    else $("#userSelector").empty();
    stickyIds.forEach(id => {
      const b = $("#userSelector button#" + id);
      b.addClass("active");
      b.addClass("sticky");
      b.find('input').prop('checked', true);
    })
  }
  const now = new Date().getTime();
  topUpdateHooks1();
  topUpdateHooks2();
  topUpdateHooks4();
  topUpdateHooks5();
  topUpdateHooks6($editTable);
  topUpdateHooks7($editTable);
  topUpdateHooks8($editTable);
  topUpdateHooks9();
  topUpdateHooks10();
  topUpdateHooks11();
  topUpdateHooks12();
  topUpdateHooks13();
  //topUpdateHooks14();
  topUpdateHooks15();
  topUpdateHooks16();
  topUpdateHooks17();
  //console.log("topUpdateHooks2", new Date().getTime() - now);
};

function topUpdateHooks1() {
  // orderListUtil.updateHooks();

  $(".scrollable-y").scroll(function () {
    auth.scrollEventTimestamp = new Date().getTime();
  });
}
function topUpdateHooks2() {
  if ($("button.pre-selected-action").data("hookok") == true) return;

  $("button.pre-selected-action").bind("change", function (event) {
    timeoutCount++;
    var timeoutCount2 = timeoutCount;
    setTimeout(function () {
      if (timeoutCount != timeoutCount2) return;
      $(event.currentTarget).removeClass("active");
      var tables = $(".eatwithme-table.selected").removeClass("selected");
      resetPreSelection();
    }, 3000);
    var tables = $(".eatwithme-table.selected").removeClass("selected");
    if ($(event.currentTarget).hasClass("active")) {
      resetPreSelection();
      return;
    }
    var id = $(event.currentTarget).attr("id");
    var tables = $("g.eatwithme-table")
      .parent()
      .parent();
    var deselectedClass = "faded";
    tables.addClass(deselectedClass);
    switch (id) {
      case "pre-lock":
        var tables = $('g.eatwithme-table:not(.inactive):not(".occupied")');
        tables.parent().parent();
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $("g.eatwithme-table.shareable:not(.inactive)");
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        break;
      case "pre-lock-order":
        var tables = $('g.eatwithme-table:not(.inactive):not(".occupied")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $('g.eatwithme-table.occupied:not(.inactive):not(".shareable"):not(".wantsToPay")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $('g.eatwithme-table.occupied.shareable:not(.inactive):not(".multiple-occupation"):not(".wantsToPay")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        break;
      case "pre-paying":
        var tables = $('g.eatwithme-table.occupied.unpaid:not(.inactive):not(".shareable"):not(".wantsToPay")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $('g.eatwithme-table.occupied.unpaid.shareable:not(.inactive):not(".wantsToPay"):not(".multiple-occupation")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        break;
      case "pre-no-paying":
        var tables = $('g.eatwithme-table.occupied.unpaid.wantsToPay:not(.inactive):not(".shareable")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $('g.eatwithme-table.occupied.unpaid.wantsToPay.shareable:not(.inactive):not(".multiple-occupation")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        break;
      case "pre-paid":
        var tables = $('g.eatwithme-table.occupied.unpaid:not(.inactive):not(".shareable")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $('g.eatwithme-table.occupied.unpaid.shareable:not(.inactive):not(".multiple-occupation")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        break;
      case "pre-unlock":
        var tables = $('g.eatwithme-table.occupied.paid:not(.inactive):not(".shareable")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $('g.eatwithme-table.occupied.paid.shareble:not(.inactive):not(".multiple-occupation")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $('g.eatwithme-table.occupied:not(.inactive):not(".shareable"):not(".paid"):not(".unpaid")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        var tables = $('g.eatwithme-table.occupied.shareable:not(.inactive):not(".multiple-occupation"):not(".paid"):not(".unpaid")');
        tables
          .parent()
          .parent()
          .removeClass(deselectedClass);
        tables.addClass("selected");
        break;
      default:
        break;
    }
  });
  $("button.pre-selected-action").data("hookok", true);
}

function topUpdateHooks4() {
  $(".movableBox.draggable").draggable({
    scroll: false,
    delay: 300,
    start: function (trigger, ui) {
      return trigger.target == trigger.toElement;
    },
    stop: function (trigger) {
      var y =
        (100 *
          $(trigger.target)
            .css("top")
            .split("px")[0]) /
        window.innerHeight;
      var x =
        (100 *
          $(trigger.target)
            .css("left")
            .split("px")[0]) /
        window.innerWidth;
      var key = $(trigger.target).attr("id") + "-" + localStorage.restaurantSelected + "_box_position-" + Math.round(window.innerWidth / 10) + "x" + Math.round(window.innerHeight / 10);
      localStorage[key + "-left"] = x;
      localStorage[key + "-top"] = y;
      $(trigger.target).css("left", x + "%");
      $(trigger.target).css("top", y + "%");
    }
  });
}
function topUpdateHooks5() {
  $("#editTable .menuItem.draggable").draggable({
    scroll: true,
    delay: 300,
    revert: function () {
      return tablesOverview.dropFailed;
    },
    zIndex: 1000,
    stack: ".customer-droppable",
    start: function (trigger) {
      $(this).data("startingScrollTop", $($(this).parents(".scrollable-y")[0]).scrollTop());
      $(".bs-tooltip-top").hide();
      var order = getMenuItem($(this).attr("id"));

      var hiddenElements = $("li.customer-droppable.main").find("li.customer-droppable.ui-droppable.hidden3");
      hiddenElements.addClass("toBeHidden");
      var hiddenElements = $("li.customer-droppable.main").find("li.customer-droppable.ui-droppable");
      hiddenElements.addClass("toBeShown");
      hiddenElements.addClass("hidden3");

      var hiddenElements = $("ul#customersByTiming");
      hiddenElements.addClass("toBeShown");
      hiddenElements.addClass("hidden");

      orderListUtil.drag = true;
      tablesOverview.dropFailed = true;
    },
    drag: function (trigger, ui) {
      var st = parseInt($(this).data("startingScrollTop"));
      ui.position.top -= $($(this).parents(".scrollable-y")[0]).scrollTop() - st;
    },
    stop: function () {
      $(".ui-droppable").css("z-index", "unset");
      var hiddenElements = $("li.customer-droppable.main").find("li.customer-droppable.ui-droppable.toBeShown");
      hiddenElements.removeClass("hidden3");
      hiddenElements.removeClass("shown");
      hiddenElements.removeClass("toBeShown");
      var hiddenElements = $("li.customer-droppable.main").find("li.customer-droppable.ui-droppable.toBeHidden");
      hiddenElements.addClass("hidden3");
      hiddenElements.removeClass("shown");
      hiddenElements.removeClass("toBeShown");

      var hiddenElements = $("ul#customersByTiming.toBeShown");
      hiddenElements.removeClass("toBeShown");
      hiddenElements.removeClass("hidden");

      tablesOverview.drCustomerId = undefined;
      orderListUtil.drag = false;
    }
  });
}

function topUpdateHooks6Start(trigger) {
  $(".tooltip.show.bs-tooltip-bottom").remove();
  var scrollingParent = $($(this).parents(".scrollable-y")[0]);
  $(this).data("startingScrollTop", scrollingParent.scrollTop());
  orderListUtil.drag = true;
  tablesOverview.dropFailed = true;
  select($(trigger.currentTarget));
  this.customerDroppables = [];
  var d = this.customerDroppables;
  var ind = 0;
  var mateId = $(trigger.target).attr("customerId");

  var rect = scrollingParent.get(0).getBoundingClientRect();
  var t = $("#" + mateId + ".selectable.customer.customer-droppable.list-group-item.ui-droppable.main");
  var rectt = trigger.target.getBoundingClientRect();

  var quickDrop = $(
    '<div class="quick-drop" style="display:flex;flex-wrapwrap;position:absolute;z-index:200;left:' +
    (rectt.left - rect.left) +
    "px" +
    ";top:calc(" +
    (rectt.top + rectt.height - rect.top + scrollingParent.scrollTop()) +
    'px - 6rem);"/>'
  );
  quickDrop.appendTo(scrollingParent);
  this.quickDrop = quickDrop;

  getTableOccupation(sessionStorage.tableOccupationSelected).tableMates.forEach(function (mate) {
    if (mate.id == mateId || mate.active === false) return;

    var paying = mate.payingMateId == mate.id;

    var person = $('<button id="' + mate.id + '" class="customer quick-drop btn badge badge-person"+>' + String.format(local.unknown_person, mate.seqNr) + "</button>");
    person.appendTo(quickDrop);
    d.push(person);
    ind++;
  });
  $(d).droppable({
    scroll: true,
    accept: function (dropElem) {
      if (!isVisible($(this))) return false;
      if ($(dropElem).hasClass("customer")) return false;
      var orderCustomer = $(dropElem).attr("customerId");
      var dropCustomer = $(this).attr("id");
      return orderCustomer != dropCustomer;
    },
    classes: {
      "ui-droppable-hover": "ui-state-hover2",
      "ui-droppable-active": "ui-state-active2"
    },
    greedy: true,
    over: function (dropElem) {
      if (typeof tablesOverview.drCustomerId != "undefined" && tablesOverview.drCustomerId == $(this).attr("id")) return;
      overCustomerDroppable = true;
    },
    out: function (dropElem) {
      overCustomerDroppable = false;
    },
    tolerance: "pointer",
    drop: function (event, ui) {
      overCustomerDroppable = false;
      var orderIds = $(ui.draggable).attr("orderIds");
      var customer = $(this).attr("id");
      var dropCustomerTiming = $(ui.draggable).attr("timing");
      moveOrdersToCustomer(orderIds, customer, orderListUtil.statesShown, dropCustomerTiming, function (data) {
        updateTableOccupations([data.tableOccupation]);
        if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
        updateOrders(data.orders);
      });
      tablesOverview.dropFailed = false;
    }
  });
}
function topUpdateHooks6Drag(trigger, ui) {
  trigger.stopPropagation();
  var scrollTop = $($(this).parents(".scrollable-y")[0]).scrollTop();
  var st = parseInt($(this).data("startingScrollTop"));
  ui.position.top -= scrollTop - st;
  var startX = this.startX;
  var startY = this.startY;
  if (Math.abs(trigger.clientX - startX) > 30 && !this.quickDrop) {
    this.customerDroppables.forEach(function (person) {
      $(person).css("visibility", "visible");
    });
  }
  $(".bs-tooltip-top").hide();
}
function topUpdateHooks6Stop(trigger, ui) {
  $(".ui-droppable").css("z-index", "");
  $(".ui-draggable").css("z-index", "");
  if (this.quickDrop) this.quickDrop.remove();
  this.h = false;
  $("#byCustomer.tab-pane .customer[level=2] ul").removeClass("hidden");
  orderListUtil.drag = false;
}

function topUpdateHooks6(o) {
  if (o.find("#byCustomer.tab-pane.active").length === 0)
    return;
  o.find("#byCustomer.tab-pane .byCustomer.draggable").draggable({
    scroll: true,
    delay: 30,
    revert: function () {
      return true;
    },
    stack: ".ui-droppable",
    start: topUpdateHooks6Start,
    drag: topUpdateHooks6Drag,
    stop: topUpdateHooks6Stop
  });
}
function topUpdateHooks7(o) {
  if (o.find("#byCustomer.tab-pane.active").length === 0)
    return;
  o.find("#byCustomer.tab-pane .customer.draggable").draggable({
    scroll: true,
    delay: 300,
    revert: function () {
      return tablesOverview.dropFailed;
    },
    accept: function (dropElement) {
      if (!isVisible($(this))) return false;

      return $(dropElement).hasClass("customer") && $(dropElement).attr("level") == 2;
    },
    stack: ".customer,.quick-drop",
    startX: 0,
    startY: 0,
    h: false,
    top: 0,
    start: function (trigger) {
      var scrollingParent = $($(this).parents(".scrollable-y")[0]);
      $(this).data("startingScrollTop", scrollingParent.scrollTop());
      // $(this).data("startingScrollTop",$(this).parent().scrollTop());
      this.startX = trigger.clientX;
      this.startY = trigger.clientY;
      select($(trigger.currentTarget));
      orderListUtil.drag = true;
      tablesOverview.dropFailed = true;

      this.customerDroppables = [];
      var d = this.customerDroppables;
      var ind = 0;
      var mateId = $(trigger.target).attr("id");
      if (mateId.startsWith("payer")) mateId = mateId.substring(5);
      if (mateId.startsWith("tableMate")) mateId = mateId.substring(9);
      var self = getTableMate(mateId);
      var payingMateId = self.payingMateId;
      var rect = scrollingParent.get(0).getBoundingClientRect();
      var t = $("#" + mateId + ".selectable.customer.customer-droppable.list-group-item.ui-droppable.main");
      var rectt = trigger.target.getBoundingClientRect();
      var quickDrop = $(
        '<div class="quick-drop" style="display:flex;flex-wrap:wrap;position:absolute;z-index:200;left:' +
        (rectt.left + rectt.width - rect.left) +
        "px" +
        ";top:" +
        (rectt.top + rectt.height - rect.top + scrollingParent.scrollTop()) + 'px;"/>'
      );
      quickDrop.appendTo(scrollingParent);
      this.quickDrop = quickDrop;

      if (payingMateId != mateId) {
        var person = $('<button id="' + mateId + '" class="customer quick-drop btn badge badge-person"+>' + admin_local.pay_himself + "</button>");
        person.appendTo(quickDrop);
        d.push(person);
        ind++;
      }

      const mates = [];

      getTableOccupation(sessionStorage.tableOccupationSelected).tableMates.forEach(function (mate) {
        if (mate.id == mateId || mate.active === false) return;
        if (mates.indexOf(mate.id) !== -1) return;
        mates.push(mate.id);

        var paying = mate.payingMateId == mate.id;

        if (!paying) return;
        if (payingMateId == mate.payingMateId) return;
        if (mate.tableMate != null)
          var person = $(
            '<button style="" id="' + mate.id + '" class="customer quick-drop btn badge badge-person"+>' + String.format(admin_local.unknown_person_pays, mate.seqNr) + " (" + mate.tableMate.name + ")</button>"
          );
        else if (mate.name)
          var person = $(
            '<button style="" id="' + mate.id + '" class="customer quick-drop btn badge badge-person"+>' + String.format(admin_local.unknown_person_pays, mate.seqNr) + " (" + mate.name + ")</button>"
          );
        else var person = $('<button style="" id="' + mate.id + '" class="customer quick-drop btn badge badge-person"+>' + String.format(admin_local.unknown_person_pays, mate.seqNr) + "</button>");
        person.appendTo(quickDrop);
        d.push(person);
        ind++;
      });
      var person = $('<div style="width:100%;flex-grow:1"/>');
      person.appendTo(quickDrop);
      d.push(person);
      var person = $('<button style="margin-top:1rem;" id="change-table" class="customer quick-drop btn badge badge-person"+>' + admin_local.change_table + "</button>");
      person.appendTo(quickDrop);
      d.push(person);
      ind++;
      $(d).droppable({
        scroll: true,
        accept: function (dropElem) {
          if (!isVisible($(this))) return false;
          if (!$(dropElem).hasClass("customer")) return false;
          return true;
        },
        classes: {
          "ui-droppable-hover": "ui-state-hover2",
          "ui-droppable-active": "ui-state-active2"
        },
        greedy: true,
        over: function (dropElem) {
          overCustomerDroppable = true;
          if (typeof tablesOverview.drCustomerId != "undefined" && tablesOverview.drCustomerId == $(this).attr("id")) return;
        },
        out: function (dropElem) {
          overCustomerDroppable = false;
        },
        tolerance: "pointer",
        drop: function (event, ui) {
          overCustomerDroppable = false;
          var id = $(ui.draggable).attr("id");
          var payer = false;
          if (id.startsWith("payer")) {
            id = id.substring(5);
            payer = true;
          }
          if (id.startsWith("tableMate")) id = id.substring(9);
          var payerMateId = $(this).attr("id");
          if (payerMateId == "change-table") {
            tablePicker(function (event) {
              var mate = getTableMate(id);
              var tableId = $(event.currentTarget).attr("id");
              if (tableId == sessionStorage.tableNumberSelected) {
                messageDialog(local.message, admin_local.target_table_same_and_source);
                return;
              }
              var tableMatesPaid = admin.getTableMatesPaidBy(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id);
              var tableOccupationTables = getTableOccupationTablesForTable(tableId);
              if (tableOccupationTables.length == 0) {
                // this is an empty table
                choiceDialog(local.confirmation, String.format(admin_local.confirm_person_change_to_empty_table, mate.seqNr, tableId), admin_local.new_occupation, admin_local.extend_occupation).done(function (data) {
                  if (data == 0) {
                    // new occupation
                    admin.createNewTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableId, payer, function (data) {
                      update(data);
                    });
                  } else {
                    // add to existing occupation
                    admin.changeTableForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableId, payer, update);
                  }
                });
              } else if (tableOccupationTables.length == 1) {
                // this is an table with existing occupation
                if (getTable(tableOccupationTables[0].restaurantTable.number).shareable) {
                  choiceDialog2(local.confirmation, String.format(admin_local.confirm_person_change_to_shared_table, mate.seqNr, tableId), [
                    admin_local.new_independent_occupation,
                    admin_local.joins,
                    admin_local.extend_occupation
                  ]).done(function (data) {
                    switch (data) {
                      case 0:
                        // new occupation
                        admin.createNewTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableId, payer, update);
                        break;
                      case 1:
                        // joins occupation
                        admin.changeTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableOccupationTables[0].tableOccupationId, tableId, payer, update);
                        break;
                      case 2:
                        // add to existing occupation
                        admin.changeTableForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableId, payer, update);
                        break;
                    }
                  });
                } else {
                  choiceDialog2(local.confirmation, String.format(admin_local.confirm_person_change_to_table, mate.seqNr, tableId), [admin_local.yes]).done(function (data) {
                    // joins occupation
                    admin.changeTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableOccupationTables[0].tableOccupationId, tableId, payer, update);
                  });
                }
              } else {
                var choices = [];
                choices.push(admin_local.new_independent_occupation);
                choices.push(admin_local.extend_occupation);
                tableOccupationTables.forEach(function (table, ind) {
                  var tableOccupation = getTableOccupation(table.tableOccupationId);
                  if (ind == 0) choices.push(String.format(admin_local.joins_table1, tableOccupation.personCount));
                  else choices.push(String.format(admin_local.joins_table, ind + 1, tableOccupation.personCount));
                });
                choiceDialog2(local.confirmation, String.format(admin_local.confirm_person_change_to_shared_table, mate.seqNr, tableId), choices).done(function (data) {
                  switch (data) {
                    case 0:
                      // new occupation
                      admin.createNewTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableId, payer, update);
                      break;
                    case 1:
                      // add to existing occupation
                      admin.changeTableForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableId, null, payer, update);
                      break;
                    default:
                      // joins occupation
                      admin.changeTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, id, tableOccupationTables[data - 2].tableOccupationId, tableId, payer, update);
                      break;
                  }
                });
              }
            });
            return;
          } else {
            admin.payForTableMate(id, payerMateId, function (data) {
              /*
              getTableMate(id).payingMateId = payerMateId;
              var tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);
              tableOccupation.tableMates.forEach(function (mate) {
                if (mate.id == id) mate.payingMateId = payerMateId;
              });
              */
              update(data);
              /*
              if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
              updateOrders([]);
              */
            });
          }
          tablesOverview.dropFailed = false;
        }
      });
    },
    drag: function (trigger, ui) {
      var scrollTop = $($(this).parents(".scrollable-y")[0]).scrollTop();
      var st = parseInt($(this).data("startingScrollTop"));
      ui.position.top -= scrollTop - st;

      var startX = this.startX;
      var startY = this.startY;
      if (Math.abs(trigger.clientX - startX) > 30 && !this.quickDrop) {
        this.customerDroppables.forEach(function (person) {
          $(person).css("visibility", "visible");
        });
      }
      $(".bs-tooltip-top").hide();
    },
    stop: function () {
      $(".ui-droppable").css("z-index", "unset");
      if (this.quickDrop) this.quickDrop.remove();
      $("#byCustomer.tab-pane .customer[level=2] ul").removeClass("hidden");
      this.h = false;
      $("#byCustomer.tab-pane .customer[level=2] ul").removeClass("hidden");
      $(this).css("transform", "");
      orderListUtil.drag = false;
    }
  });
}
function topUpdateHooks8(o) {
  if (o.find("#byTiming.tab-pane.active").length === 0)
    return;
  o.find("#byTiming.tab-pane .byTiming.draggable").draggable({
    scroll: true,
    delay: 300,
    revert: function () {
      return tablesOverview.dropFailed;
    },
    stack: ".timing-droppable",
    start: function (trigger) {
      $(this).data("startingScrollTop", $($(this).parents(".scrollable-y")[0]).scrollTop());
      this.startX = trigger.clientX;
      this.startY = trigger.clientY;
      select($(trigger.currentTarget));

      $(".bs-tooltip-top").hide();

      orderListUtil.drag = true;
      tablesOverview.dropFailed = true;
    },
    top: 0,
    h: false,
    hiddenItems: null,
    drag: function (trigger, ui) {
      $(".bs-tooltip-top").hide();
    },
    stop: function () {
      this.h = false;
      $(this).css("transform", "");
      if (this.hiddenItems != null) this.hiddenItems.removeClass("hidden");
      orderListUtil.drag = false;
    }
  });
}
function topUpdateHooks9() {
  $("#editTable .byMenuItem.draggable").draggable({
    scroll: true,
    delay: 300,
    revert: "invalid",
    zIndex: 10000,
    stack: ".orderTrash,.menuitem-droppable"
  });
}
function topUpdateHooks10() {
  var droppableHandler;
  $("#editTable .customer-droppable.timing").droppable(
    (droppableHandler = {
      accept: function (dropElem) {
        if (!isVisible($(this))) return false;

        if ($(dropElem).hasClass("menuItem")) return true;

        if ($(dropElem).hasClass("customer")) return false;
        var orderIds = $(dropElem).attr("orderIds");
        var r = true;
        var t = this;
        if (!orderIds)
          return false;
        orderIds.split(",").forEach(function (orderId) {
          var order = getOrderElement(orderId);
          if (!order)
            return;
          var customerId = $(dropElem).attr("customerId");
          var orderTiming = order.timing;
          var dropCustomerId = $(t).attr("customerId");
          var dropCustomerTiming = $(t).attr("timing");
          var r2 = Number(customerId) == Number(dropCustomerId);
          if (r2) {
            if (typeof orderTiming != "undefined") {
              r2 = orderTiming != dropCustomerTiming;
            }
          }
          r = r && r2;
        });
        return r;
      },
      greedy: true,
      tolerance: "pointer",
      classes: {
        "ui-droppable-hover": "ui-state-hover2",
        "ui-droppable-active": "ui-state-active2"
      },
      drop: function (event, ui) {
        if ($(ui.draggable).hasClass("menuItem")) {
          orderMenuItem($(ui.draggable).attr("entityType"), $(ui.draggable).attr("menuItem"), $(ui.draggable).attr("quantity"), true, $(this).attr("id"), $(this).attr("timing"));
          return;
        }
        var orderIds = $(ui.draggable).attr("orderIds");
        var customer = $(this).attr("customerId");
        var dropCustomerTiming = $(this).attr("timing");
        moveOrdersToCustomer(orderIds, customer, orderListUtil.statesShown, dropCustomerTiming, function (data) {
          updateTableOccupations([data.tableOccupation]);
          if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
          updateOrders(data.orders);
        });
        tablesOverview.dropFailed = false;
      }
    })
  );
}
function topUpdateHooks11() {
  $("#editTable #orderListByCustomer .byCustomer.droppable").droppable({
    greedy: true,
    over: function (dropElem) { }
  });
}

var overCustomerDroppable = false;
function topUpdateHooks12() {
  var droppableHandler;
  const customers = $("#editTable #orderListByCustomer .customer-droppable.main");
  customers.each((ind, customer) => $(customer).droppable(
    (droppableHandler = {
      scroll: true,
      accept: function (dropElem) {
        if (overCustomerDroppable) return false;
        if (!isVisible($(this))) return false;
        if ($(dropElem).hasClass("customer")) return false;
        var orderCustomer = $(dropElem).attr("customerId");
        var dropCustomer = $(this).attr("id");
        return orderCustomer != dropCustomer;
      },
      classes: {
        "ui-droppable-hover": "ui-state-hover2",
        "ui-droppable-active": "ui-state-active2"
      },
      greedy: true,
      over: function (dropElem) {
        if (typeof tablesOverview.drCustomerId != "undefined" && tablesOverview.drCustomerId == $(this).attr("id")) return;
      },
      out: function (dropElem) { },
      tolerance: "pointer",
      drop: function (event, ui) {
        if (!isVisible($(this))) return false;
        var orderIds = $(ui.draggable).attr("orderIds");
        var customer = $(this).attr("id");
        var dropCustomerTiming = $(ui.draggable).attr("timing");
        moveOrdersToCustomer(orderIds, customer, orderListUtil.statesShown, dropCustomerTiming, function (data) {
          updateTableOccupations([data.tableOccupation], data.orders);
          // tableLayout.updateTableOccupations();
          // updateOrders(data.orders);
        });
        tablesOverview.dropFailed = false;
      }
    })
  ));
}
function topUpdateHooks13() {
  $("#editTable .timing-droppable").droppable({
    accept: function (dropElem) {
      if (!isVisible($(this))) return false;
      var orderTiming = $(dropElem).attr("timing");
      var dropTiming = $(this).attr("id");
      var state = $(dropElem).attr("state");
      if (state == "ordered" || state == "selected" || state == "accepted") return orderTiming != dropTiming;
      return false;
    },
    tolerance: "pointer",
    classes: {
      "ui-droppable-hover": "ui-state-hover2",
      "ui-droppable-active": "ui-state-active2"
    },
    drop: function (event, ui) {
      if ($(ui.draggable).hasClass("menuItem")) {
        orderMenuItem($(ui.draggable).attr("entityType"), $(ui.draggable).attr("menuItem"), $(ui.draggable).attr("quantity"), true, "", $(this).attr("id"));
        return;
      }
      var orderIds = $(ui.draggable).attr("orderIds");
      var customer = $(ui.draggable).attr("customerId");
      var dropCustomerTiming = $(this).attr("id");
      moveOrdersToCustomer(orderIds, customer, orderListUtil.statesShown, dropCustomerTiming, function (data) {
        updateTableOccupations([data.tableOccupation], data.orders);
        // tableLayout.updateTableOccupations();
        // updateOrders(data.orders);
      });
      tablesOverview.dropFailed = false;
    }
  });
}
/*
function topUpdateHooks14() {
  $("#editTable .menuItem-droppable").droppable({
    accept: function(dropElem) {
      if (!isVisible($(this))) return false;
      var customerId =
        $(dropElem)
          .parent()
          .attr("menuItemId") +
        ":" +
        $(dropElem)
          .parent()
          .attr("quantity");
      var dropCustomerId = $(this).attr("menuItemId") + ":" + $(this).attr("quantity");
      return customerId != dropCustomerId;
    },
    tolerance: "pointer",
    classes: {
      "ui-droppable-hover": "ui-state-hover2",
      "ui-droppable-active": "ui-state-active2"
    },
    drop: function(event, ui) {
      var orderId = $(ui.draggable).attr("order");
      var order = getOrderElement(orderId);
      var menuItem = $(this).attr("menuItemId");
      var quantity = $(this).attr("quantity");
      moveOrderToMenuItemAndQuantity(order, menuItem, quantity, orderListUtil.statesShown);
      tablesOverview.dropFailed = false;
    }
  });
}
*/
function topUpdateHooks15() {
  if (!topUpdateHooksExecuted)
    $("#editTable #orderTrash").droppable({
      tolerance: "pointer",
      greedy: true,
      classes: {
        "ui-droppable-hover": "ui-state-hover2",
        "ui-droppable-active": "ui-state-active2"
      },
      accept: function (dropElem, event) {
        if (!isVisible($(this))) return false;
        if (dropElem.hasClass("not-deletable")) return false;
        var r = dropElem.hasClass("customer") || dropElem.hasClass("byCustomer") || dropElem.hasClass("byTiming");
        if (r) {
          var orderIds = dropElem.attr("orderIds");
          if (orderIds != undefined) {
            var ok = true;
            orderIds.split(",").forEach(function (orderId) {
              var order = orderListUtil.getOrderById(orderId);
              if (order.paid) {
                ok = false;
                return;
              }
              var mate = getTableMate(getTableMate(order.forWhomId).payingMateId);
              if (mateInState(mate, "wantsToPay")) ok = false;
            });
            return ok;
          }
        }
        return r;
      },
      drop: function (event, ui) {
        event.stopPropagation();
        event.preventDefault();
        if ($(ui.draggable).hasClass("customer")) {
          var tableMateId = $(ui.draggable).attr("id");
          if (tableMateId.startsWith("payer")) tableMateId = tableMateId.substring(5);
          if (tableMateId.startsWith("tableMate")) tableMateId = tableMateId.substring(9);
          admin.unjoinTableMate(tableMateId, function (data) {
            update(data);
          });
          tablesOverview.dropFailed = true;
        } else {
          var order = $(ui.draggable).attr("orderIds") ? $(ui.draggable).attr("orderIds") : $(ui.draggable).attr("orders");
          cancelOrder(order, orderListUtil.statesShown, function (data) {
            if (data == null) {
              console.log("Failed to cancel orders");
            } else {
              deleteOrders(data.deletedOrders, true);
              updateTableOccupations([data.tableOccupation], data.orders);
              // tableLayout.updateTableOccupations();
              // updateOrders(data.orders);
            }
          });
          tablesOverview.dropFailed = true;
        }
      }
    });
}
function topUpdateHooks16() {
  //if (typeof scrollPosision != "undefined") $(".scrollable").scrollTop(scrollPosision);
}
function topUpdateHooks17() {
  // updateToolTips();
  // $('[data-toggle="tooltip"]').tooltip();

  topUpdateHooksExecuted = true;
}

function getOrderData(id) {
  var o = null;
  orderListUtil.ordersCache.forEach(function (order) {
    if (order.id == id) {
      o = order;
    }
  });
  return o;
}

export const hideEditTable = force => {
  const pickupTableNumber = getPickupTableNumber();
  const homeDeliveryTableNumber = getHomeDeliveryTableNumber();

  if (!$("#tableOccupation-selector-map").hasClass('hidden')) {
    //showMap(false);
    //return;
  }


  if (!orderListUtil.occupationsSelected || (orderListUtil.occupationsSelected.filter(o => o.occupationStart).length < 2 && sessionStorage.tableNumberSelected != pickupTableNumber && sessionStorage.tableNumberSelected != homeDeliveryTableNumber) || $('#tableOccupation-selector').hasClass('selectTableOccupationTile') || $('#tableOccupation-selector').hasClass('selectTableOccupation') || !$("#right_pane").hasClass("hidden")) {
    hideEditTable2(force)
  } else {
    orderListUtil.ai.setContext({ tableOccupation: null });
    $("#orderList").empty();
    $("ul#orderListByCustomer").empty();
    $("ul#orderListByTiming").empty();
    $('#left_pane .tab-content').removeClass('hidden');
    if (sessionStorage.tableNumberSelected == pickupTableNumber || sessionStorage.tableNumberSelected == homeDeliveryTableNumber) {
      $('#tableOccupation-selector').addClass('selectTableOccupation');
      $('#left_pane .tab-content').addClass('hidden');
      $('#tableOccupation-selector').show();
      $('#editTable').addClass('selectTableOccupation');
    } else {
      $('#tableOccupation-selector').addClass('selectTableOccupationTile');
      $('#editTable').addClass('selectTableOccupationTile');
    }
    updateHeadings();
  }
}

export const hideEditTable2 = force => {
  //showMap(false);
  auth.identityJustChecked = false;
  if (typeof force == "undefined") force = false;
  if (typeof sessionStorage._editTable == "undefined") return;
  if (!isTop($("#editTable"))) return;
  //showMap(false);
  if (!$("#right_pane").hasClass("hidden")) {
    if (force) {
      hideSelectNewOrders();
    } else {
      var thereAreOrders = false;
      if (typeof orderListUtil.orders != "undefined" && typeof orderListUtil.orders.tables != "undefined")
        orderListUtil.ordersCache.forEach(function (order) {
          if (sessionStorage.tableOccupationSelected == order.tableOccupationId && sessionStorage.tableNumberSelected == order.tableNumber && order.state === "selected") {
            thereAreOrders = true;
          }
        });

      if (thereAreOrders) {
        choiceDialog2(local.confirmation, local.do_you_really_want_to_quit_pending_orders, [admin_local.suspend_ordering]).done(function () {
          hideSelectNewOrders();
        });
      } else {
        hideSelectNewOrders();
      }
      if (!orderListUtil.kioskMode) {
        return;
      }
    }
  }

  //processAllOrders(orderListUtil.ordersCache);
  $("#editTable").addClass("hidden");
  updateDataOnCustomerScreen([]);
  $("#main-floorplan").removeClass("hidden");
  $("#editTable").removeClass("selectTableOccupation");
  $("#editTable").removeClass("selectTableOccupationTime");
  orderListUtil.ai.setContext({ tableOccupation: null });
  if (!orderListUtil.kioskMode) $("#timingSelector button.timing.active").removeClass("active");
  $("#orderList").empty();
  $("ul#orderListByCustomer").empty();
  $("ul#orderListByTiming").empty();
  if (sessionStorage._editTable == "true" && sessionStorage.tableOccupationSelected) {
    get("adminService/" + localStorage.restaurantSelected + "/tableEditEnd/" + sessionStorage.tableOccupationSelected + "/" + sessionStorage.tableNumberSelected, undefined, undefined, undefined, false).done(data => update(data)).fail(() => { auth.ajaxError = false });
  }
  sessionStorage.tableOccupationSelected = "";
  sessionStorage.tableNumberSelected = "";
  delete sessionStorage._editTable;
  if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
};

const centerTableOccupationOnMap = (id) => {
  if (bookingMap) {
    if (getTableOccupation(id))
      bookingMap.selectDelivery(getTableOccupation(id).toDeliveredById, id);
    else
      bookingMap.selectDelivery(0, 0);
  }
}

export const selectTableOccupation = (id, event) => {
  if ($("#tableOccupation-selector").hasClass('selectTableOccupation') && event && !$(event.currentTarget).parents("li").hasClass("selected")) {
    if (bookingMap) {
      if (getTableOccupation(id)) {
        centerTableOccupationOnMap(" + occupation.id + ", event);
        bookingMap.selectDelivery(getTableOccupation(id).toDeliveredById, id);
      } else
        bookingMap.selectDelivery(0, 0);
    }
    return;
  }
  if (!id) {
    console.error("This is not good", "selectTableOccupation");
  }
  selectTableOccupationSelected(id);
  var selector = $("#tableOccupation-selector");
  selector.removeClass("selectTableOccupation");
  $('#editTable').removeClass("selectTableOccupation");
  selector.removeClass("selectTableOccupationTile");
  $('#editTable').removeClass("selectTableOccupationTile");
  $('#left_pane .tab-content').removeClass('hidden');

  var id = localStorage.drinkbar_id;
  var details = "true" == localStorage.drinkbar_details;
  var detailWasSelected = localStorage.drinkbar_detailWasSelected;
  var orderId = localStorage.drinkbar_orderId;

  if (orderListUtil.isFiltered()) preProcessOrders(orderListUtil.ordersCache);

  orderListUtil.detailsMode = false;
  var o = orderListUtil.isFiltered() ? orderListUtil.orders : orderListUtil.allOrders;
  updateOrderList(true);

  updateOrders([]);

  setSelected(id, detailWasSelected, orderId);
  if (details) {
    showDetails(true);
    if (detailWasSelected == "detailrow") {
      var r = $("tr#" + id + ".detailrow.nothidden");
      r.each(function (ind, row) {
        if ($(row).attr("orderId") == orderId) {
          _show($(row));
        }
      });
    }
  }
  orderListUtil.updateOrdersDone();

  if (sessionStorage.tableNumberSelected == getPickupTableNumber() || sessionStorage.tableNumberSelected == getHomeDeliveryTableNumber()) {
    $('#tableOccupation-selector').hide();
  }

  //updateHeadings();
  //updateFooterButtons();
};

export const clickHandler222 = trigger => {
  resetLockTimeout();
  if (trigger.isDefaultPrevented()) return;
  if ((trigger.type = "focusin")) return;
  if (select(trigger.currentTarget)) trigger.preventDefault();
};

export const markTableMateForPayment = (pay, nomodal, print, paymentMethod) => {

  var modal = $("#markTableMateForPaymentDialog");


  pay = typeof pay == "undefined" ? true : pay;
  nomodal = typeof nomodal == "undefined" ? false : nomodal;
  print = typeof print == "undefined" ? false : print;

  if (orderListUtil.drag) return;

  modal.empty();
  var tableMateChoicesSet = new SortedSet({ comparator: customerComparator });
  var allTableMatesSet = new SortedSet({ comparator: customerComparator });
  var wasPaymentRequest = false;
  admin.tableMates.forEach(function (tableMateId) {
    let tableMate = getTableMate(tableMateId);
    if ((sessionStorage.tableOccupationSelected == "null" || tableMate.tableOccupationId == sessionStorage.tableOccupationSelected) && tableMate.tableNumber == sessionStorage.tableNumberSelected) {
      if (SortedSet.find(allTableMatesSet, tableMate) == null) allTableMatesSet.insert(tableMate);
      var t;
      if (tableMate.payingMateId == null) t = tableMate;
      else t = getTableMate(tableMate.payingMateId);
      if (!t) t = tableMate;
      const isPayingOnline = mateInState(tableMate, "payingOnline");
      if (!!isPayingOnline) return;
      const isWantToPay = mateInState(tableMate, "wantsToPay");
      t.preselected = !!isWantToPay;
      t.selected = !!mateInState(tableMate, "paymentRequest");
      wasPaymentRequest = wasPaymentRequest || !!mateInState(tableMate, "paymentRequest");
      if (SortedSet.find(tableMateChoicesSet, t) == null) tableMateChoicesSet.insert($.extend({}, t));
    }
  });
  var tableMateChoices = [];
  if (tableMateChoices.length > 1) {
    nomodal = false;
  }
  tableMateChoicesSet.forEach(function (v) {
    if (nomodal && !wasPaymentRequest) v.preselected = pay;
    var count = getOrdersToPay(v.id).length;
    var amount = Math.round(getAmountToPay(v.id));
    if (count > 0) {
      v.amountToPay = amount;
      v.preselected = v.preselected || false;
      tableMateChoices.push(v);
    }
  });

  const tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);

  const payingMates = tableOccupation.tableMates.filter(t => (t.active || t.isActive) && (t.payingMateId === null || t.payingMateId === t.id));
  if (payingMates.length === 1 && getStateIndex(payingMates[0], "wantsToPay") >= 0) {
    tableMateChoices[0].selected = false;
    _markTableMateForPayment(modal, tableMateChoices, paymentMethod, (data) => {
      messageDialog(I18n.t("local.information"), I18n.t("admin_local.ordering_allowed"));
      updateAndCloseModal(data);
    });
    return;
  }

  if (orderListUtil.kioskMode && tableMateChoices.length > 0) {
    admin.getInvoiceXML(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, tableMateChoices[0].id, localStorage.language, 1, "", "", function (data) {
      if (data == '{"success":"true"}') {
        tableMatePaid();
        return;
      } else {
        printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
        tableMatePaid();
        return;
      }
    });
    return;
  }

  var allTableMates = [];
  allTableMatesSet.forEach(function (v) {
    allTableMates.push(v);
  });

  if (tableMateChoices.length == 1 && !nomodal) if (!tableMateChoices[0].preselected) tableMateChoices[0].selected = true;

  $("#markTableMateForPaymentTemplate")
    .tmpl({
      tableMates: tableMateChoices,
      ...tmplparams()
    })
    .appendTo(modal);
  var modal = $("#markTableMateForPayment");

  function clickHandler12321(trigger) {
    if (trigger.isDefaultPrevented()) return;
    if (select(trigger.currentTarget)) trigger.preventDefault();
  }

  modal.on("hidden.bs.modal", function () { });

  $("#markTableMateForPayment .selectable").off("click", clickHandler12321);
  $("#markTableMateForPayment .selectable").on("click", clickHandler12321);

  select($("#markTableMateForPayment .selectable[level=2]").get(0));

  $(modal.find("input#service")).focusin(function () {
    if ($(this).val() == 0) $(this).val("");
    $(this).select();
  });
  $(modal.find("input#service")).focusout(function () {
    if ($(this).val() == "") $(this).val("0");
  });

  $("#markTableMateForPayment li.mate.list-group-item").on("click", e => {
    $(e.currentTarget).removeClass("preselected");
  });

  updateCheckBoxesById(modal.find(".mate.list-group-item"));
  if (!nomodal) {
    // updateToolTips();
    modal.modal("show", {
      keyboard: false
    });

    modal.data("tableMates", tableMateChoices);

    checkPrint();
    modal.find(".mate.list-group-item").change(checkPrint);

    $("button#select").click(function (event) {
      avoidMultipleClick(this, event);
      _markTableMateForPayment(modal, tableMateChoices, paymentMethod, updateAndCloseModal);
    });
    $("button#print").click(function (event) {
      avoidMultipleClick(this, event);
      if (event.isDefaultPrevented()) return;
      var language = $(this)
        .find("div#language.btn")
        .text();
      _markTableMateForPayment(modal, tableMateChoices, paymentMethod, function (data) {
        if (data.error) {
          messageDialog(I18n.t("local.error_message"), I18n.t(data.error)).done(r => recoverFromEventSourceError(false));
          return;
        }
        updateAndCloseModal(data);
        tableMateChoices.forEach(function (payingMate) {
          if (getStateIndex(payingMate, "wantsToPay") == -1 || payingMate.preselected) return;
          //for (let i = 0; i < modal.find('#copy').html(); i++) {
          admin.getInvoiceXML(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, payingMate.id, language, modal.find('#copy').html(), "", "", function (data) {
            if (data == '{"success":"true"}') { return }
            for (let i = 0; i < modal.find('#copy').html(); i++)
              printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id)
            return;
          });
          //}
        });
      });
    });
    $("button#splitInvoice").click(function (event) {
      if (tableMateChoices.length == 1) {
        var t = modal.find(".mate.list-group-item.active");
        t.removeClass("active");
        t.removeClass("list-group-item-primary");
      }

      var clickHandler;

      _markTableMateForPayment(modal, tableMateChoices, paymentMethod, data => {
        update(data);
        avoidMultipleClick(this, event);
        modal.modal("hide");
        $("#editTable").addClass("hidden");
        $("#main-floorplan").removeClass("hidden");
        //delete sessionStorage._editTable;
        $("div.splitInvoice.modal").remove();
        if (event.isDefaultPrevented()) return;
        var language = $(this)
          .find("button#language")
          .text();

        var o = _preProcessOrders(orderListUtil.ordersCache, orderListUtil.statesShown, function (order) {
          return order.tableOccupationId == sessionStorage.tableOccupationSelected;
        });

        var splitInvoiceModal = $("script#splitInvoice").tmpl({ ...o, ...tmplparams() }).appendTo("body");
        var s = splitInvoiceModal.find(".selectable");
        s.off("click", clickHandler123);
        s.on("click", clickHandler123);

        var draggableHandler;
        $(".modal.splitInvoice .byCustomer.draggable").draggable(
          (draggableHandler = {
            scroll: false,
            delay: 30,
            revert: function () {
              return tablesOverview.dropFailed;
            },
            stack: ".modal.splitInvoice .customer-droppable.main",
            start: function (trigger) {
              tablesOverview.dropFailed = true;
            },
            drag: function (trigger, ui) { },
            stop: function () { }
          })
        );
        $(".modal.splitInvoice .byCustomer.draggable").on("dblclick", (clickHandler = (e) => {
          if (auth.device.platform === "browser" && e?.originalEvent?.dataTransfer) return;
          var customer = $("#rightSide .tab-pane.container.active li.customer").attr("id");
          var sourceCustomer = $(e.currentTarget).parents("li.customer").attr("id");
          if (customer === sourceCustomer) {
            customer = $("#leftSide .tab-pane.container.active li.customer").attr("id");
          }
          var orderIds = $(e.currentTarget).attr("orderIds");
          var dropCustomerTiming = $(e.currentTarget).attr("timing");

          e.stopPropagation();

          if (customer)

            moveOrdersToCustomer(
              orderIds,
              customer,
              orderListUtil.statesShown,
              dropCustomerTiming,
              function (data) {
                update(data);

                updateModal(null, sourcePayingCustomer, targetPayingCustomer)
              }, () => updateModal(null, sourcePayingCustomer, targetPayingCustomer));
        }));
        var droppableHandler;
        $(".modal.splitInvoice .customer-droppable.main").droppable(
          (droppableHandler = {
            scroll: false,
            accept: function (dropElem) {
              if ($(dropElem).hasClass("customer")) return false;
              if (!$(dropElem).hasClass("byCustomer")) return false;
              var orderCustomer = $(dropElem).attr("customerId");
              var dropCustomer = $(this).attr("id");
              return orderCustomer != dropCustomer;
            },
            classes: {
              "ui-droppable-hover": "ui-state-hover2",
              "ui-droppable-active": "ui-state-active2"
            },
            greedy: true,
            over: function (dropElem) {
              if (typeof tablesOverview.drCustomerId != "undefined" && tablesOverview.drCustomerId == $(this).attr("id")) return;
            },
            out: function (dropElem) { },
            tolerance: "pointer",
            drop: function (event, ui) {
              var orderIds = $(ui.draggable).attr("orderIds");
              var customer = $(this).attr("id");
              var dropCustomerTiming = $(ui.draggable).attr("timing");
              tablesOverview.dropFailed = false;

              var sourceLi = $(ui.draggable)
                .parents("li[level = '2']")
                .parent()
                .parent();
              sourcePayingCustomer = sourceLi.attr("id").substring(1);

              var targetLi = $(this);
              targetPayingCustomer = targetLi
                .parent()
                .parent()
                .attr("id")
                .substring(1);

              moveOrdersToCustomer(
                orderIds,
                customer,
                orderListUtil.statesShown,
                dropCustomerTiming,
                function (data) {
                  update(data);

                  updateModal(ui, sourcePayingCustomer, targetPayingCustomer)
                }, () => updateModal(ui, sourcePayingCustomer, targetPayingCustomer));
            }
          })
        );

        var sourcePayingCustomer, targetPayingCustomer;

        function updateModal(ui) {
          var sourcePayingCustomer = $("#leftSide .tab-pane.container.active li.customer").attr("id");
          var targetPayingCustomer = $("#rightSide .tab-pane.container.active li.customer").attr("id");
          var o = _preProcessOrders(orderListUtil.ordersCache, orderListUtil.statesShown, function (order) {
            return order.tableOccupationId == sessionStorage.tableOccupationSelected && order.paid == false;
          });
          o.ordersByPayer.forEach(ordersByCustomer => {
            if (((!sourcePayingCustomer && !targetPayingCustomer) || ordersByCustomer.customer.id == sourcePayingCustomer || ordersByCustomer.customer.id == targetPayingCustomer) && ordersByCustomer.tableOccupation == sessionStorage.tableOccupationSelected) {
              orderListUtil.customerCountByPayer = ordersByCustomer.ordersByCustomer.length;
              orderListUtil.payingCustomer = ordersByCustomer.customer.id;
              var r = splitInvoiceModal.find("div#leftSide.tab-content .tab-pane.container#l" + ordersByCustomer.customer.id + " > div");
              if (r.length) {
                r.find("> li").remove();
                ordersByCustomer.ordersByCustomer.forEach(data => {
                  var newli = $("script#ordersByCustomerNoEditTemplate")
                    .tmpl({ ...data, ...tmplparams() })
                    .appendTo(r);
                });
              }
              var r = splitInvoiceModal.find("div#rightSide.tab-content .tab-pane.container#r" + ordersByCustomer.customer.id + " > div");
              if (r.length) {
                r.find("> li").remove();
                ordersByCustomer.ordersByCustomer.forEach(data => {
                  var newli = $("script#ordersByCustomerNoEditTemplate")
                    .tmpl({ ...data, ...tmplparams() })
                    .appendTo(r);
                });
              }
            }
          });
          if (ui)
            $(ui.draggable).remove();
          $(".modal.splitInvoice .byCustomer.draggable").draggable(draggableHandler);
          $(".modal.splitInvoice .byCustomer.draggable").on("dblclick", clickHandler);
          $(".modal.splitInvoice .customer-droppable.main").droppable(droppableHandler);
          var s = splitInvoiceModal.find(".selectable");
          s.unbind("click", clickHandler123);
          s.click(clickHandler123);
        }


        splitInvoiceModal.on("hidden.bs.modal", function () {
          showEditTable();
          setBigTableNumber();
          sessionStorage._editTable = true;
          markTableMateForPayment();
          $("div.splitInvoice.modal").remove();
        });
        splitInvoiceModal.on("shown.bs.modal", function () {
          $(splitInvoiceModal.find("div#leftSide.tab-pane .nav-item:not(.disabled) .nav-link").get(0)).click();

          splitInvoiceModal.find("button#print").click(event => {
            avoidMultipleClick(this, event);
            var language = $(this)
              .find("div#language.btn.dropdown-toggle")
              .text();
            var payingMate_id = splitInvoiceModal.find("div#rightSide.tab-pane .nav-link.active").attr("id");
            if (typeof payingMate_id != "undefined")
              admin.getInvoiceXML(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, payingMate_id, language, 1, "", "", function (data) {
                if (data == '{"success":"true"}') { }
                else printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
              });
          });
          splitInvoiceModal.find("button#edit-discount").click(event => {
            if (isDuplicateClickEvent(event)) return;
            avoidMultipleClick(this, event);
            var payingMate_id = splitInvoiceModal.find("div#rightSide.tab-pane .nav-link.active").attr("id");
            editDiscounts(Number(payingMate_id), updateModal);
          })
          splitInvoiceModal.find("button#paid").click(event => {
            avoidMultipleClick(this, event);
            var payingMate_id = splitInvoiceModal.find("div#rightSide.tab-pane .nav-link.active").attr("id");
            if (typeof payingMate_id !== "undefined")
              tableMatePaid(payingMate_id, undefined, false, function (data) {
                update(data);
                var o = _preProcessOrders(orderListUtil.ordersCache, orderListUtil.statesShown, function (order) {
                  return order.tableOccupationId == sessionStorage.tableOccupationSelected && order.paid == false;
                });
                o.ordersByPayer.forEach(ordersByCustomer => {
                  if (ordersByCustomer.customer.id == payingMate_id && ordersByCustomer.tableOccupation == sessionStorage.tableOccupationSelected) {
                    orderListUtil.customerCountByPayer = ordersByCustomer.ordersByCustomer.length;
                    orderListUtil.payingCustomer = ordersByCustomer.customer.id;
                    var r = splitInvoiceModal.find("div#leftSide.tab-content .tab-pane.container#l" + payingMate_id + " > div");
                    r.find("> li").remove();
                    ordersByCustomer.ordersByCustomer.forEach(data => {
                      var newli = $("script#ordersByCustomerTemplate")
                        .tmpl({ ...data, ...tmplparams() })
                        .appendTo(r);
                    });
                    var r = splitInvoiceModal.find("div#rightSide.tab-content .tab-pane.container#r" + payingMate_id).remove();
                    var r = splitInvoiceModal
                      .find("div#rightSide.tab-pane > ul > li > span#" + payingMate_id)
                      .parent()
                      .remove();
                  }
                });
                $(".modal.splitInvoice .byCustomer.draggable").draggable(draggableHandler);
                $(".modal.splitInvoice .customer-droppable.main").droppable(droppableHandler);
                var s = splitInvoiceModal.find(".selectable");
                s.off("click", clickHandler123);
                s.on("click", clickHandler123);
                admin.activateTableMate(payingMate_id, false, updateTableOccupations);
              });
          });
          splitInvoiceModal.find("button#incrementPayer").click(event => {
            admin.incrementTableMates(0, function (data) {
              update(data);
              var ids = [];
              var existingOnes = $("#rightSide.tab-pane > ul > li > span");
              if (existingOnes.length > 0)
                existingOnes.each((ind, item) => {
                  ids.push($(item).attr("id"));
                });
              data.tableOccupation.tableMates.forEach(mate => {
                if (ids.indexOf("" + mate.id) == -1) {
                  var o = _preProcessOrders(orderListUtil.ordersCache, orderListUtil.statesShown, function (order) {
                    return order.tableOccupationId == sessionStorage.tableOccupationSelected;
                  });
                  o.ordersByPayer.forEach(ordersByCustomer => {

                    if (
                      ordersByCustomer.customer.id == mate.id &&
                      ordersByCustomer.tableOccupation == sessionStorage.tableOccupationSelected &&
                      (ordersByCustomer.count == 0 || ordersByCustomer.stateMap.unpaid > 0) &&
                      !mateInState(ordersByCustomer.customer, "wantsToPay")
                    ) {
                      splitInvoiceModal.find("#rightSide.tab-content").append($("script#splitInvoiceRightTabContent").tmpl({ ...ordersByCustomer, ...tmplparams() }));
                    }
                  });
                  o.ordersByPayer.forEach(ordersByCustomer => {
                    if (
                      ordersByCustomer.customer.id == mate.id &&
                      ordersByCustomer.tableOccupation == sessionStorage.tableOccupationSelected &&
                      (ordersByCustomer.count == 0 || ordersByCustomer.stateMap.unpaid > 0) &&
                      !mateInState(ordersByCustomer.customer, "wantsToPay")
                    ) {
                      var n;
                      splitInvoiceModal.find("#rightSide.tab-pane > ul").append((n = $("script#splitInvoiceRightNav").tmpl({ customer: mate, ...tmplparams() })));
                      $(n)
                        .find(".nav-link")
                        .click();
                    }
                  });
                  $(".modal.splitInvoice .byCustomer.draggable").draggable(draggableHandler);
                  $(".modal.splitInvoice .customer-droppable.main").droppable(droppableHandler);
                }
              });
            });
          });


        });
        splitInvoiceModal.modal("show");
      });
    });
  } else {
    if (!print) {
      _markTableMateForPayment(modal, tableMateChoices, paymentMethod, orderListUtil.edit);
    } else {
      _markTableMateForPayment(modal, tableMateChoices, paymentMethod, function (data) {
        updateAndCloseModal(data);
        tableMateChoices.forEach(function (payingMate) {
          if (getStateIndex(payingMate, "wantsToPay") == -1) return;
          admin.getInvoiceXML(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, payingMate.id, localStorage.language, 1, "", "", function (data) {
            if (data == '{"success":"true"}') { }
            else printHtml(data, admin.getPrinterForPrinterAction("printInvoice").id);
          });
        });
      });
    }
  }
};

export const checkPrint = () => {
  var p = $("#markTableMateForPaymentDialog #print");
  var ok = false;
  $("#markTableMateForPaymentDialog .list-group-item").each((ind, t) => {
    //var t = modal.find("#" + mate.id + ".list-group-item.active");
    if ($(t).hasClass("active")) {
      if ($(t).hasClass("preselected")) {
        return;
      }
      ok |= true;
    }
  });
  p.prop("disabled", !ok);
};

export const printQRCode = (embedded = false) => {
  var qrcode = $("<div/>");
  var url = "";
  var text = [];
  if (auth.myStatus.restaurant_settings["tables-overview"]["table-qrcode"] === "join") {
    // eslint-disable-next-line no-restricted-globals
    url = "https://restaurant.eatwithme.online" + (location.port == 3000 ? ":8444" : "") + "/map.html?r=" +
      auth.myStatus.restaurant_global_id +
      "&t=" +
      sessionStorage.tableNumberSelected +
      "&m=" +
      getTableOccupation(sessionStorage.tableOccupationSelected).tableMates[0].id +
      "&q=" +
      getTableOccupation(sessionStorage.tableOccupationSelected).qrToken +
      "&a=m";
    _qrcode(qrcode, url, String.format(admin_local.scan_to_join_table, sessionStorage.tableNumberSelected), 200);
    auth.myStatus.restaurant_languages.forEach(function (lang) {
      var l = admin_locals[lang];
      if (l.scan_to_pay_table)
        String.format(l.scan_to_join_table, getTableName(sessionStorage.tableNumberSelected))
          .split("\r\n")
          .forEach(function (t) {
            text.push(t);
          });
    });
  } else if (auth.myStatus.restaurant_settings["tables-overview"]["table-qrcode"] === "pay-only") {
    var tableMateChoicesSet = new SortedSet({ comparator: customerComparator });
    var allTableMatesSet = new SortedSet({ comparator: customerComparator });
    admin.tableMates.forEach(function (tableMate) {
      if (tableMate.tableOccupationId == sessionStorage.tableOccupationSelected && tableMate.tableNumber == sessionStorage.tableNumberSelected) {
        if (SortedSet.find(allTableMatesSet, tableMate) == null) allTableMatesSet.insert(tableMate);
        var t;
        if (tableMate.payingMateId == null) t = tableMate;
        else t = getTableMate(tableMate.payingMateId);
        if (SortedSet.find(tableMateChoicesSet, t) == null) tableMateChoicesSet.insert($.extend({}, t));
      }
    });
    const tableMateChoices = [];
    tableMateChoicesSet.forEach(function (v) {
      tableMateChoices.push(v);
    });
    if (tableMateChoices.length == 1) {
      // eslint-disable-next-line no-restricted-globals
      url = "https://restaurant.eatwithme.online" + (location.port == 3000 ? ":8444" : "") + "/tableMatePaying.html?t=" + getTableOccupation(sessionStorage.tableOccupationSelected).qrToken + "&m=" + tableMateChoices[0].id;
      _qrcode(qrcode, url, "Scan to pay table " + getTableName(sessionStorage.tableNumberSelected), 200);
    }
    auth.myStatus.restaurant_languages.split(",").forEach(function (lang) {
      var l = admin_locals[lang];
      if (l.scan_to_pay_table)
        String.format(l.scan_to_pay_table, sessionStorage.tableNumberSelected)
          .split("\r\n")
          .forEach(function (t) {
            text.push(t);
          });
    });
  }
  var qrcode = $(qrcode).get(0).innerHTML;
  qrcode = qrcode.replace(/"><\/div>/g, 'color:transparent">.</div>');
  var data = { top: { text: text, qrcode: qrcode } };
  var x2js = new X2JS();
  var xmlAsStr = '<?xml version="1.0" encoding="utf-8"?>' + x2js.js2xml(data);
  var encodedUrl = encodeURIComponent(url);

  var printer = getLocalPrinterSettings().printerActions.pa_printTableSlip ? getPrinter(getLocalPrinterSettings().printerActions.pa_printTableSlip).name : auth.myStatus.restaurant_printer_actions.printTableSlip.name;
  var format = getLocalPrinterSettings().printerActions.pa_printTableSlip ? getPrinter(getLocalPrinterSettings().printerActions.pa_printTableSlip).format : auth.myStatus.restaurant_printer_actions.printTableSlip.format;

  if (embedded)
    return {
      reportName: "jointable",
      format: "html",
      lang: localStorage.language,
      query: "__parameterPage=false&url=" + encodedUrl + "&target=" + format,
      message: "join-table-" + sessionStorage.tableOccupationSelected + "-" + new Date().getTime(),
      xml: xmlAsStr,
      printer: printer
    }

  printPdf(
    "jointable",
    "html",
    localStorage.language,
    "__parameterPage=false&url=" + encodedUrl + "&target=" + format,
    "join-table-" + sessionStorage.tableOccupationSelected + "-" + new Date().getTime(),
    xmlAsStr,
    printer
  );
};

function updatePaymentMethodsForPayment(modal) {
  modal.find("div[paymentMethod]").removeClass("hidden").removeClass("cashregister-method");
  const cashregister = $("#cashregisters input:checked").prop("id");
  if (typeof cashregister !== "undefined" && Number(cashregister)) {
    const c = auth.myStatus.restaurant_cash_registers.find(c => c.id === Number(cashregister));
    if (c && c.paymentMethods && c.paymentMethods.length) {
      const preselectedCount = modal.find("div[paymentMethod][preselected = 'true']").length;
      if (c.ntak)
        modal.find("div[paymentMethod]:not([preselected = 'true'])").addClass("hidden");
      else
        modal.find("div[paymentMethod]").addClass("hidden");
      if (preselectedCount === 0 || !c.ntak) {
        c.paymentMethods.forEach(p => {
          modal.find("div[paymentMethod = '" + p.id + "']").removeClass("hidden");
        });
      }
      // If a preselected payment method exists, re-hide non-preselected cashregister methods
      // and mark them with cashregister-method so the toggle button can reveal them
      if (preselectedCount > 0) {
        c.paymentMethods.forEach(p => {
          modal.find("div[paymentMethod = '" + p.id + "']:not([preselected = 'true'])").addClass("hidden cashregister-method");
        });
        // Re-show the toggle button in case it was hidden after a previous click
        modal.find("li.mate.list-group-item button.icon-down-open").show();
      }
      modal.find("div[paymentMethod].hidden input").val(null);
      // Reorder divs to match the cash register's payment method order, per li
      modal.find("li.mate.list-group-item").each((_, li) => {
        const $li = $(li);
        const container = $li.find("div[paymentMethod]").first().parent();
        if (!container.length) return;
        c.paymentMethods.forEach(p => {
          $li.find("div[paymentMethod = '" + p.id + "']").each((_, el) => container.append(el));
        });
        $li.find("div[paymentMethod].hidden").each((_, el) => container.append(el));
      });
    }
  }
  checkPayments();
}

export const tableMatePaid = (mateId, date, donthide = false, handler) => {

  if (featureEnabled("ntak") && !tablesOverview.context.state.open) {
    tablesOverview.pendingPaymentAfterOpen = { mateId, date, donthide, handler };
    choiceDialog2(
      I18n.t("local.confirmation"),
      I18n.t("admin_local.day_must_be_open"),
      [I18n.t("admin_local.cashier_dayopen")]
    ).done(choice => {
      if (choice === 0 && tablesOverview.context) {
        tablesOverview.context.setState({ open: false, continue: false });
      } else {
        delete tablesOverview.pendingPaymentAfterOpen;
      }
    }).fail(() => {
      delete tablesOverview.pendingPaymentAfterOpen;
    });
    return;
  }

  if (auth.myStatus && auth.myStatus.customers && auth.myStatus.customers.length > 1)
    unlock().done(() => __tableMatePaid(mateId, date, donthide, handler));
  else __tableMatePaid(mateId, date, donthide, handler)
}

export const __tableMatePaid = (mateId, date, donthide = false, handler) => {
  if (orderListUtil.drag === true) return;



  var modal = $("#tableMatePaidDialog");
  modal.empty();
  var tableMateChoicesSet = new SortedSet({ comparator: customerComparator });
  var allTableMatesSet = new SortedSet({ comparator: customerComparator });
  var atLeastOneMateWasSelected = false;
  if (typeof mateId == "undefined") {
    admin.tableMates.forEach(function (tableMateId) {
      var tableMate = getTableMate(tableMateId);
      if (tableMate.tableOccupationId == sessionStorage.tableOccupationSelected && tableMate.tableNumber == sessionStorage.tableNumberSelected) {
        if (SortedSet.find(allTableMatesSet, tableMate) == null) allTableMatesSet.insert(tableMate);
        var t;
        if (tableMate.payingMateId == null) t = tableMate;
        else t = getTableMate(tableMate.payingMateId);
        if (t && /* getStateIndex(t, 'wantsToPay')!=-1 && */ SortedSet.find(tableMateChoicesSet, t) == null) {
          t.selected = false;
          t.selected = getStateIndex(t, "wantsToPay") != -1;
          tableMateChoicesSet.insert(t);
          atLeastOneMateWasSelected = atLeastOneMateWasSelected || t.selected;
        }
      }
    });
  } else {
    var tableMate = getTableMate(mateId);
    tableMateChoicesSet.insert(tableMate);
  }
  const tableMateChoices = [];
  var allTableMates = [];
  tableMateChoicesSet.forEach(function (v) {
    var amount = getAmountToPay(v.id, date);
    var count = getOrdersToPay(v.id, date).length;
    var exemptOfServiceFee = getAmountToPayExemptOfServiceFee(v.id, date);
    if (count > 0) {
      v.amountToPay = auth.round(v.service.indexOf("%") != -1 ? (amount + ((amount - exemptOfServiceFee) * (Number(v.service.split("%")[0]))) / 100) : amount + Number(v.service));
      if (tableMateChoicesSet.length === 1)
        v.selected = !atLeastOneMateWasSelected || v.selected;
      tableMateChoices.push(v);
    }
  });
  if (!tableMateChoices[0]?.tableOccupationId) {
    return;
  }
  const tableOccupation = getTableOccupation(tableMateChoices[0]?.tableOccupationId);
  allTableMatesSet.forEach(function (v) {
    allTableMates[allTableMates.length] = v;
  });
  var restaurant_payment_methods = getRestaurantPaymentMethodsOrderedByCashRegister(
    auth.myStatus.restaurant_payment_methods.filter(paymentMethod => !paymentMethod.method.isOnline)
  );
  window.setAmount = setAmount;
  window.amountChanged = amountChanged;
  window.addCashReceivedNote = addCashReceivedNote;
  window.clearCashReceivedAmount = clearCashReceivedAmount;
  window.toggleCashReturnCalculation = toggleCashReturnCalculation;
  window.refreshCashReturnFocusState = refreshCashReturnFocusState;
  sessionStorage.tableNumberSelected = tableOccupation.restaurantTables[0].restaurantTable.number;
  if ((localStorage.getItem("cashregister") === null || !auth.myStatus.restaurant_cash_registers.find(r => r.id == localStorage.getItem("cashregister"))) && auth.myStatus.restaurant_cash_registers.length) {
    localStorage.setItem("cashregister", auth.myStatus.restaurant_cash_registers[0].id);
  }
  const cashregisters = auth.myStatus.restaurant_cash_registers.filter(c => c.isActive);
  const selectedCashRegister = auth.myStatus.restaurant_cash_registers.find(c => c.id == localStorage.getItem("cashregister"));
  const cashRegisterMethodIds = selectedCashRegister?.paymentMethods
    ? new Set(selectedCashRegister.paymentMethods.map(pm => String(pm?.id != null ? pm.id : pm?.method?.id)))
    : null;
  updateFooterButtons();
  $("#tableMatePaidTemplate")
    .tmpl({
      tableMates: tableMateChoices,
      restaurant_payment_methods: restaurant_payment_methods,
      cashregisters: cashregisters,
      repay: false,
      preselectedPaymentMethod: tableOccupation?.bookedProperties?.payment_method,
      preselectedPaymentAmount: Number(tableOccupation?.bookedProperties?.amountToPay) || "",
      cashRegisterMethodIds: cashRegisterMethodIds,
      ...tmplparams()
    })
    .appendTo(modal);
  var modal = $("#tableMatePaid.modal");
  loadMyImage();

  if (tableOccupation?.bookedProperties?.name || tableOccupation?.bookedProperties?.surname) {
    modal.find("input#personname").val(tableOccupation.bookedProperties.name + " " + tableOccupation.bookedProperties.surname);
    modal.find("input#address").val(tableOccupation.bookedProperties.address);
    modal.find("input#postcode").val(tableOccupation.bookedProperties.postcode);
    modal.find("input#city").val(tableOccupation.bookedProperties.town);
    modal.find("input#email").val(tableOccupation.bookedProperties.email);
    modal.find("input#address").removeClass("is-invalid");
    modal.find("input#postcode").removeClass("is-invalid");
    modal.find("input#city").removeClass("is-invalid");
    modal.find(".company").addClass("hidden");
    modal.find(".name").removeClass("hidden");
    modal.find("#person").addClass("active");
    modal.find("#company").removeClass("active");
  }

  if (!orderListUtil.quickActions)
    if (typeof mateId == "undefined") {
      modal.find("button#save-and-unlock").removeClass("hidden");
    } else {
      //modal.find("button#save-and-unlock").addClass("hidden");
    }

  if (donthide)
    modal.find("button#save-and-unlock").addClass("hidden");

  modal.find("button#close").on("click", (item, event) => {
    //if (item.currentTarget.id === "close") {
    modal.hide();
    $(document.body).removeClass("modal-open");
    $(".modal-backdrop").remove();
    return;
    //}
    /*
    confirmDialog(local.confirmation, admin_local.are_you_sure_you_cancel_the_payment).done(() => {
      modal.hide();
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    });
    */
  });

  var clickHandler123321 = function (trigger) {
    if (trigger.isDefaultPrevented()) return;
    if (select(trigger.currentTarget)) trigger.preventDefault();
  };

  $("#tableMatePaid.modal .selectable").unbind("click", clickHandler123321);
  $("#tableMatePaid.modal .selectable").click(clickHandler123321);
  $("#tableMatePaid.modal .selectable li").change(function (trigger) {
    if ($(this).hasClass("active")) {
      $($(this).find("input")[1]).focus();
      $($(this).find("input")[0]).select();
    }
    checkPayments();
  });

  var payments = $("#tableMatePaid.modal div.amountPaid input");
  payments.keyup(function (trigger) {
    checkPayments();
  });
  payments.change(function (trigger) {
    checkPayments();
  });

  $("#tableMatePaid.modal input[pattern != '']").on('keyup', event => {
    var regexp = new RegExp(event.currentTarget.pattern, "i");
    if (event.currentTarget.value.match(regexp) == null) {
      $(event.currentTarget).addClass("is-invalid");
    } else {
      $(event.currentTarget).removeClass("is-invalid");
    }
    checkPayments();
  });

  modal.on("shown.bs.modal", function () {
    modal.find('[data-toggle="dropdown"]').dropdown();
    var v = $($("#tableMatePaid.modal input")[0]);
    v.focus();
    v.select();
  });
  modal.on("hidden.bs.modal", function () {
    const showCustomerScreenState = store.getState().rootReducer.customerScreen;
    if (showCustomerScreenState.showCustomerScreen) {
      updateDataOnCustomerScreen({ source: sessionStorage.tableNumberSelected, type: "cancelAskForTip" }, window.location.href);
    }
  });

  select($("#tableMatePaid.modal .selectable[level=2]").get(0));

  updateCheckBoxesById(".mate.list-group-item");
  // updateToolTips();

  $("#tableMatePaid.modal .selectable li > input").on('change', trigger => {
    checkPayments();
  });


  modal.modal("show", {
    keyboard: false
  });
  $("#tableMatePaid.modal .vat-details input#name").on('blur', () => {
    setTimeout(() => {
      $("#tableMatePaid.modal form div.typeahead__container.result").removeClass('result')
    }, 100);
  });

  $("#tableMatePaid.modal .vat-details #name").typeahead({
    order: "desc",
    dynamic: true,
    backdrop: true,
    minLength: 3,
    searchOnFocus: true,
    template: (query, item) => {
      return "<div onmousedown='event.preventDefault();event.stopPropagation()' onmouseup='event.preventDefault();event.stopPropagation()' style='background:yellow;z-index:1000000' onclick='$(this).parent().parent().click();event.preventDefault();event.stopPropagation();'>" + item.display + "(" + item.address.postCode + " " + item.address.city + ", " + item.address.address + ")</div>";
    },
    callback: {
      onSubmit: (node, a, item, event) => {
        const p = $(node).parents('.vat-details');
        p.find('#partner_id').val(item.id);
        p.find('#tax_number').val(item.taxcode);
        p.find('#postcode').val(item.address.postCode);
        p.find('#city').val(item.address.city);
        p.find('#address').val(item.address.address);
        p.find('#email').val(item.emails.length ? item.emails[0] : "");
        p.find('#tax_number').prop('disabled', true);
        p.find('#postcode').prop('disabled', true);
        p.find('#city').prop('disabled', true);
        p.find('#address').prop('disabled', true);
        p.find('#email').prop('disabled', false);
        p.find("input[pattern != '']").removeClass("is-invalid");
        if (item.id)
          p.parent().find("#create-vat-partner").addClass("hidden");
        else
          p.parent().find("#create-vat-partner").removeClass("hidden");
        checkPayments();
      },
      onClickAfter: (node, a, item, event) => {
        const p = $(node).parents('.vat-details');
        p.find('#partner_id').val(item.id);
        p.find('#tax_number').val(item.taxcode);
        p.find('#postcode').val(item.address.postCode);
        p.find('#city').val(item.address.city);
        p.find('#address').val(item.address.address);
        p.find('#email').val(item.emails.length ? item.emails[0] : "");
        p.find('#tax_number').prop('disabled', true);
        p.find('#postcode').prop('disabled', true);
        p.find('#city').prop('disabled', true);
        p.find('#address').prop('disabled', true);
        p.find('#email').prop('disabled', false);
        p.find("input[pattern != '']").removeClass("is-invalid");
        if (item.id)
          p.parent().find("#create-vat-partner").addClass("hidden");
        else
          p.parent().find("#create-vat-partner").removeClass("hidden");
        checkPayments();
      },
      onCancel: (node, item, event) => {
        const p = $(node).parents('.vat-details');
        p.find('#partner_id').val("");
        p.find('#tax_number').val("");
        p.find('#postcode').val("");
        p.find('#city').val("");
        p.find('#address').val("");
        p.find('#email').val("");
        p.find('#tax_number').prop('disabled', false);
        p.find('#postcode').prop('disabled', false);
        p.find('#city').prop('disabled', false);
        p.find('#address').prop('disabled', false);
        p.find('#email').prop('disabled', false);
        checkPayments();
      }
    },
    source: {
      ajax: (query) => {
        return {
          type: "GET",
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          url: auth.server + "/eatwithme.server/billingo/" + localStorage.restaurantSelected + "/partners/find/" + query,
          //url: "https://app.billingo.hu/ceginfo/search?find=" + query,
          callback: {
            done: function (data) {
              if (data.error) {
                messageDialog(local.errorMessage, I18n.t("admin_local." + data.error));
              }
              if (data.data)
                return data.data.map(d => { return { ...d, display: d.name } });
              return [];
            }
          }
        }
      }
    }
  });

  var cashRegister = $("#cashregisters input:checked").prop("id");
  cashRegister = cashRegister ? cashRegister : 0;

  modal.find('.i_cash_register input').on('change', event => {
    if (typeof localStorage.cashregister == "undefined")
      localStorage.cashregister = event.currentTarget.id;
    updatePaymentMethodsForPayment(modal);
  });

  modal.find('.i_cash_register label').off('dblclick');
  modal.find('.i_cash_register label').on('dblclick', event => {

    const cashregister = auth.myStatus.restaurant_cash_registers.find(c => c.id == $(event.currentTarget).find("input").prop("id"));

    if (cashregister) {
      _log("Changing default cash register from " + localStorage.cashregister + " to " + cashregister.name + "(" + cashregister.id + ")?");
      confirmDialog(local.confirmation, String.format(admin_local.default_cashregister_change, cashregister.name)).done(() => {
        _log("Changing default cash register to " + cashregister.name + "(" + cashregister.id + ")");
        localStorage.cashregister = cashregister.id;
        updatePaymentMethodsForPayment(modal);
      })
    }

  });

  updatePaymentMethodsForPayment(modal);


  $("#tableMatePaid.modal #partner-id").on('change', event => {

  })


  $("#tableMatePaid.modal button#save").click(function (event) {
    //avoidMultipleClick(this, event);
    //avoidMultipleClick($("#tableMatePaid.modal button#save-and-unlock"), event);
    const disabled = $("#tableMatePaid.modal button#save").prop("disabled");
    if (disabled) return;

    $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", true);
    $("#tableMatePaid.modal button#save").prop("disabled", true);


    function ff() {
      _tableMatePaid({

        modal, tableMateChoices, tableOccupation: sessionStorage.tableOccupationSelected, date, handler: function (data) {
          $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", false);
          $("#tableMatePaid.modal button#save").prop("disabled", false);

          if (data.error || data.status === 400) {
            return;
          }
          $("#tableMatePaid.modal").modal("hide");
          $("#tableMatePaid.modal").hide();

          const tableOccupation = sessionStorage.tableOccupationSelected;
          typeof handler != "undefined" ? handler(data) : updateAndCloseModal(data);

          if (!data.orders) {
            return;
          }

          var allDelivered = true;
          data.orders.forEach(order => {
            if (order.state != "delivered") allDelivered = false;
          });

          const tableNumber = Number(sessionStorage.tableNumberSelected);
          const isTakeaway = tableNumber === auth.myStatus.restaurant_settings["enabled-features"].pickup["table-number"] || tableNumber === auth.myStatus.restaurant_settings["enabled-features"].homedelivery["table-number"];

          if (orderListUtil.kioskMode && !isTakeaway) {
            if (allDelivered && tableOccupation === sessionStorage.tableOccupationSelected)
              update(
                data,
                unlockTable(tableOccupation, sessionStorage.tableNumberSelected, false, function (data) {
                  update(data);
                  if (!donthide)
                    window.hideEditTable(false);
                  if (orderListUtil.occupationsSelected.length === 0) {
                    lockTable(sessionStorage.tableNumberSelected, 1, afterLockTable);
                  }
                })
              );
            else {
              if (orderListUtil.occupationsSelected.length === 0) {
                lockTable(sessionStorage.tableNumberSelected, 1, afterLockTable);
              }
            }
          } else {
          }
        }
        , errorHandler: error => {
          $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", false);
          $("#tableMatePaid.modal button#save").prop("disabled", false);

        }
      });
    }

    if ($(event.target).hasClass("btn-danger")) confirmDialog(local.confirmation, admin_local.tip_amount_seems_excesive).done(ff);
    else ff();
  });
  $("#tableMatePaid.modal button#save-and-unlock").click(function (event) {
    $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", true);
    $("#tableMatePaid.modal button#save").prop("disabled", true);

    //avoidMultipleClick(this, event);
    //avoidMultipleClick($("#tableMatePaid.modal button#save"), event);
    function ff() {
      _tableMatePaid({
        modal, tableMateChoices, tableOccupation: sessionStorage.tableOccupationSelected, date, handler: function (data) {
          $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", false);
          $("#tableMatePaid.modal button#save").prop("disabled", false);

          $("#tableMatePaid.modal").modal("hide");
          $("#tableMatePaid.modal").hide();
          if (!data.error)
            orderListUtil.occupationsSelected = [];

          typeof handler != "undefined" ? handler(data) : updateAndCloseModal(data);

          update(
            data,
            () => {
              unlockTable(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, false, function (data) {
                if (!data.error && $('.modal.splitInvoice.show').length) {
                  delete sessionStorage._editTable;
                  $('.modal.splitInvoice').addClass("hidden");
                  $('.modal.splitInvoice').removeClass("show");
                }
                update(data);
                const pickupTableNumber = getPickupTableNumber();
                const homeDeliveryTableNumber = getHomeDeliveryTableNumber();
                const isScheduled = sessionStorage.tableNumberSelected == pickupTableNumber || sessionStorage.tableNumberSelected == homeDeliveryTableNumber;
                if (orderListUtil.kioskMode && orderListUtil.occupationsSelected.length == 0) {
                  lockTable(sessionStorage.tableNumberSelected, 1, afterLockTable);
                } else {
                  if (!donthide)
                    window.hideEditTable(false);
                }
              })
            });
        }, errorHandler: error => {
          $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", false);
          $("#tableMatePaid.modal button#save").prop("disabled", false);
        }
      });
    }
    if ($(event.target).hasClass("btn-danger")) confirmDialog(local.confirmation, admin_local.tip_amount_seems_excesive).done(ff);
    else ff();
  });
};

export const _markTableMateForPayment = (modal, tableMateChoices, paymentMethod, handler) => {
  var tableMateChoices2 = [];
  tableMateChoices.forEach(function (mate) {
    var t = modal.find("#" + mate.id + ".list-group-item");
    if (t.hasClass('active')) {
      if (!$(t).hasClass("preselected")) mate.preselected = false;
      mate.service = t.find("input#service").val();
      var stateIndex = getStateIndex(mate, "wantsToPay");
      if (stateIndex == -1) {
        mate.states.push({ state: "wantsToPay", reference: paymentMethod, duration: 0 });
      }
      var stateIndex = getStateIndex(mate, "paymentRequest");
      if (stateIndex != -1) {
        mate.states.splice(stateIndex, 1);
      }
    } else {
      var stateIndex = getStateIndex(mate, "wantsToPay");
      if (stateIndex != -1) {
        mate.states.splice(stateIndex, 1);
      }
    }
    mate = Object.assign({}, mate);
    delete mate.selected;
    delete mate.amountToPay;
    delete mate.tableMate;
    delete mate.state;
    delete mate.count;
    delete mate.preselected;
    delete mate.payable;
    delete mate.paid;
    tableMateChoices2.push(mate);
  });
  post("adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment", tableMateChoices2).done(handler);
}

var dev = 3;
var devPrefix = "/dev/ttyS";
var devs = [
  "/dev/ttyS3",
  "/dev/ttyS7"
]

export const _tableMatePaid = ({ modal, tableMateChoices, tableOccupation, date, orders, handler, errorHandler }) => {

  ////eslint-disable-next-line no-undef
  //if (SerialUSB) {
  //eslint-disable-next-line no-undef
  const serial = window.serial;
  //}

  tableOccupation = tableOccupation ? tableOccupation : sessionStorage.tableOccupationSelected;
  if (!tableOccupation) {
    console.error("Strange, tableOccupation is null on tableMatePaid", "");
    errorHandler && errorHandler({ error: "no_table_occupation" });
    return;
  }
  var tableMatePayments = tableMateChoices.length == 0 ? [auth.myStatus.tableMate.id] : [];
  var count = 0;

  if (!modal[0].querySelectorAll(".list-group-item.active").length) {
    console.error("Strange, pay pushed but no active customer selected", "");
    console.error("Modal length:" + modal.length, "");
    console.error("Modal list-group-item length:" + modal[0].querySelectorAll(".list-group-item").length, "");
  }

  var cardPayment = false;
  var hasTip = false;

  modal[0].querySelectorAll(".list-group-item.active").forEach(function (t, ind) {
    const invoice = $(t).find('.vat-details-block.show').length === 1;
    const oldPaymentId = tableMateChoices[ind].paymentId;
    const partnerType = $(t).find("#partner_type button.active").attr("id");
    var name = (partnerType === "company" ? $(t).find('input#name').val() : $(t).find('input#personname').val());
    if (name) name = name.replace("??", "");
    var tableMatePayment = {
      tableMate: Number($(t).attr("id")),
      tableOccupation: tableOccupation,
      orders: orders || getOrdersToPay(Number($(t).attr("id")), date),
      payments: [],
      qrcode: invoice ? "" : $(t).attr('qrcode'),
      id: oldPaymentId,
      invoice: invoice,
      print_invoice: $(t).find('.icon-print.active').length >= 1 || !$(t).find('input#email').val(),
      partner: {
        textType: "EMPTY",
        tax_type: partnerType === "company" ? "HAS_TAX_NUMBER" : "NO_TAX_NUMBER",
        id: $(t).find('.vat-details input#partner_id').val(),
        taxcode: partnerType === "company" ? $(t).find('input#tax_number').val() : "",
        name: name,
        address: {
          address: $(t).find('input#address').val(),
          postCode: $(t).find('input#postcode').val(),
          city: $(t).find('input#city').val(),
          countryCode: "HU"
        },
        emails: [$(t).find('input#email').val()],
      },
    };
    var payments = $(t).find('div.amountPaid:not(".hidden") input');
    var amount = 0;
    var cashRegister = modal.find("#cashregisters label.active input").prop("id");
    cashRegister = cashRegister ? cashRegister : null;

    //console.log(JSON.stringify(tableMatePayment));

    /*    if (invoice) {
          tableMatePayment.payments.push({
            paymentMethod: 3,
            amount: Number($(t).find(".vat-details-block").attr("amountToPay")),
            currency: auth.myStatus.restaurant_base_currency.id,
            exchangeRate: 1,
            cashRegister: cashRegister,
            terminal: null
          });
        } else*/
    payments.each(function (ind, payment) {
      var paymentMethodButton = $(payment)
        .prevAll("div.input-group-prepend")
        .find("button");
      var paymentCurrencyButton = $(payment)
        .nextAll("div.input-group-append")
        .find("button");
      amount += Number($(payment).val()) * getCurrencyEchangeRate($(paymentCurrencyButton).attr("value"));
      const paymentMethod = getPaymentMethod(Number($(paymentMethodButton).attr("value")));
      if (Number($(payment).val()) > 0 && ["card", "teya", "paynance", "bizpay", "hellopay"].includes(paymentMethod?.method?.type)) {
        cardPayment = true;
      }
      const parent = paymentMethodButton.parent().parent();
      const type = parent.attr("paymentMethodType");

      const terminal = type ? localStorage[`${type}_terminal`] ?? null : null;
      tableMatePayment.payments.push({
        paymentMethod: Number($(paymentMethodButton).attr("value")),
        amount: Number($(payment).val()),
        currency: $(paymentCurrencyButton).attr("value"),
        exchangeRate: $(paymentCurrencyButton).parent().parent().find("input").attr("exchangeRate"),
        cashRegister: invoice ? null : cashRegister,
        terminal: type ? localStorage[`${type}_terminal`] ?? null : null
      });
    });
    const a = amount;
    const payableAmount = Number(tableMateChoices[ind].payable || 0);
    if (!isNaN(payableAmount) && (a > payableAmount + 0.0001 || $("#tableMatePaid").data("tipSelected"))) {
      hasTip = true;
    }
    if (!(typeof auth.myStatus.restaurant_settings['register-tip'] === "undefined" || auth.myStatus.restaurant_settings['register-tip'])) {
      var done = false;
      tableMatePayment.payments.forEach(payment => {
        const currency = auth.myStatus.restaurant_currencies.find(c => c.currency.id == payment.currency);
        const exchangeRate = currency ? currency.exchangeRate : 1;
        if (done) return;
        const paymentMethod = getPaymentMethod(payment.paymentMethod);
        if ("cash" === paymentMethod.method.type) {
          done = true;
          payment.amount = Math.round(payment.amount - (a - tableMateChoices[ind].payable) / exchangeRate);

          var amount = payment.amount;
          // eslint-disable-next-line no-eval
        } else if ("card" === paymentMethod.method.type) {
          cardPayment = true;
        }
      })
      //if (tableMatePayment.qrcode)
      //tableMatePayment.qrcode += "|" + a;
    }

    tableMatePayments.push(tableMatePayment);
  });
  var cashRegister = modal.find("#cashregisters label.active input").prop("id");
  cashRegister = cashRegister ? cashRegister : 0;

  const askForTipOnCardPayment = featureEnabled("pos/askForTipOnCardPayment");
  const askForTipOnCashPayment = featureEnabled("pos/askForTipOnCashPayment");
  const askForTipOnAnyCardPayment = featureEnabled("pos/askForTipOnAnyCardPayment");
  const askForTipOnAllPayment = featureEnabled("pos/askForTipOnAllPayment");
  const customerScreenButton = featureEnabled("pos/customerScreenButton");
  const mandatoryAskForTipOnCardPayment = featureEnabled("pos/mandatoryAskForTipOnCardPayment");
  const allowedTipPaymentModeNames = ["card", "kártya", "szépkártya", "cash", "készpénz"];
  const normalizeTipPaymentModeName = value => (value == null ? "" : String(value)).trim().toLowerCase();

  if (tableMatePayments.length == 1) {
    var terminalCardPaymentType = tableMatePayments[0].payments
      .filter(payment => Number(payment.amount) > 0 && payment.terminal)
      .map(payment => getPaymentMethod(payment.paymentMethod)?.method?.type)
      .find(type => type !== "card") ? "card" : "";
    const paymentMethodTypes = tableMatePayments[0].payments
      .filter(payment => Number(payment.amount) > 0)
      .map(payment => getPaymentMethod(payment.paymentMethod)?.method?.type)
      .filter(Boolean);
    const cashPaymentByType = paymentMethodTypes.includes("cash");
    const cardPaymentByType = paymentMethodTypes.some(type => ["card", "teya", "paynance", "bizpay", "hellopay"].includes(type));
    const hasAllowedTipPaymentMode = tableMatePayments[0].payments
      .filter(payment => Number(payment.amount) > 0)
      .some(payment => {
        const method = getPaymentMethod(payment.paymentMethod)?.method;
        const names = [
          normalizeTipPaymentModeName(method?.name),
          normalizeTipPaymentModeName(getLocale(method?.name))
        ].filter(Boolean);
        return names.some(name => allowedTipPaymentModeNames.some(allowedName => name.includes(allowedName)));
      });
    const skipTip = $("#tableMatePaid #save").hasClass("askForTip") || hasTip;
    const shouldAskTipOnCustomerScreen = hasAllowedTipPaymentMode && !skipTip && customerScreenButton && (
      askForTipOnAllPayment
      || (terminalCardPaymentType === "card" && askForTipOnCardPayment)
      || (cardPaymentByType && askForTipOnAnyCardPayment)
      || (cashPaymentByType && askForTipOnCashPayment)
    );
    if (shouldAskTipOnCustomerScreen) {
      const showCustomerScreenState = store.getState().rootReducer.customerScreen;
      if (showCustomerScreenState.showCustomerScreen) {
        updateDataOnCustomerScreen("check").done(() => {
          if (!mandatoryAskForTipOnCardPayment)
            $("#tableMatePaid #save").addClass("askForTip");
          $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", false);
          $("#tableMatePaid.modal button#save").prop("disabled", false);
          updateDataOnCustomerScreen({ type: "askForTip" }, window.location.href).done(() => {
          }).fail(() => {
            _log("askForTip sent to customer screen failed");
          });
          //errorHandler && errorHandler({ error: "ask_for_tip_on_customer_display" });
        }).fail(() => {
          $("#tableMatePaid #save").addClass("askForTip");
          //$("#tableMatePaid #save").removeClass("askForTip");
          _tableMatePaid({ modal, tableMateChoices, tableOccupation, date, orders, handler, errorHandler });
          //messageDialog(I18n.t("local.error_message"), I18n.t("admin_local.No connection with the guest display"));
        });
        return;
      }
    }
  }
  $("#tableMatePaid #save").removeClass("askForTip");
  const force = Number($("#tableMatePaid #save").html());

  const opts = {
    baudRate: 9600,
    //dtr: true,
    //rts: true,
    sleepOnPause: false
  }

  var c = auth.myStatus.restaurant_cash_registers.find(c => c.id === Number(cashRegister));

  if (auth?.myStatus?.restaurant_cash_registers?.length && (!c || !cashRegister)) {
    try {
      console.error("Strange that there is no cash register selected! c=" + !!c + " cashRegister=" + !!cashRegister + " c=" + $("#cashregisters label.active input").prop("id"));
      if (auth?.myStatus?.restaurant_cash_registers?.length === 1) {
        cashRegister = auth.myStatus.restaurant_cash_registers[0].id;
        c = auth.myStatus.restaurant_cash_registers[0];
        console.error("Selecting the only cash register available: " + c.name);
      }
    } catch (ex) { }
  }
  if (cashRegister && !auth?.myStatus?.restaurant_cash_registers?.length) {
    console.error("Strange that there is a cash register selected but not found in the settings!");
  }

  const promises = tableMatePayments.map(tmp => {
    const tableMate = getTableMate(tmp.tableMate);
    const state = mateInState(tableMate, "wantsToPay");

    if (!state && tableMate) {
      const mate = { ...tableMate };
      delete mate.selected;
      delete mate.amountToPay;
      delete mate.tableMate;
      delete mate.state;
      delete mate.count;
      delete mate.preselected;
      delete mate.payable;
      delete mate.paid;

      const tableMateChoices = [mate];
      mate.states = [{ state: "wantsToPay", duration: 0 }];

      return new Promise(resolve => {
        post(
          "adminService/" + localStorage.restaurantSelected + "/markTableMateForPayment",
          tableMateChoices
        ).done(data => {
          update(data);
          resolve(true); // csak az update után resolve
        });
      });
    } else
      // Return a resolved promise for already handled mates
      return Promise.resolve(true);
  });
  Promise.all(promises).then(() => {

    payByCardSoftPos(tableMatePayments, () => {
      if (c && c.type === "jota_m")
        opts.parity = 1;

      if (c && (c.format === "android_http" || c.format === "android" || c.format === "android_bluetooth" || c.format === "android_rs232") && (auth.device.platform === "android" || auth.device.platform === "Android")) {
        console.log("Serial request permission");
        if (c.format === "android_bluetooth") {

          //eslint-disable-next-line no-undef
          if (typeof bluetoothSerial === "undefined") {
            errorHandler && errorHandler({ error: "serial_cashier_error" });
            console.error("Bluetooth serial is not available");
            messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_bluetooth_adapter"));
            return;
          }


          //eslint-disable-next-line no-undef
          bluetoothSerial.list(success => {
            const serial = success.filter(c => c.name.startsWith("ECR-") || c.name.startsWith("VVLPTG"));
            if (serial.length === 1) {
              //eslint-disable-next-line no-undef
              bluetoothSerial.connect(serial[0].address, connectSuccess => {
                //eslint-disable-next-line no-undef
                bluetoothSerial.disconnect(function success() {
                  postPayment(c, tableOccupation, tableMatePayments, false, handler, errorHandler);
                }, function error(error) {
                  errorHandler && errorHandler({ error: "serial_cashier_error" });
                  messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_bluetooth_cashiers"));
                  console.error("Bluetooth Serial failed to close", error);
                })
              }, connectFailure => {
                errorHandler && errorHandler({ error: "serial_cashier_error" });
                console.error("Bluetooth serial not", connectFailure)
              });
            } else {
              errorHandler && errorHandler({ error: "serial_cashier_error" });
              if (serial.length > 1)
                messageDialog(I18n.t("local.warning"), I18n.t("admin_local.too_many_bluetooth_cashiers"));
              else
                messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_bluetooth_cashiers"));
            }
          }, failure => {
            errorHandler && errorHandler({ error: "serial_cashier_error" });
            console.error("Bluetooth serial error", JSON.stringify(failure));
            messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_bluetooth_cashiers"));
          });
        } else if (c.format === "android") {
          console.error("Check serial permission");
          //eslint-disable-next-line no-undef
          serial.requestPermission(function success(s) {
            setTimeout(
              //eslint-disable-next-line no-undef
              serial.open(opts, function success(f) {
                //eslint-disable-next-line no-undef
                //serial.close(function success(f) {
                //console.error("Serial closed: " + f);
                postPayment(c, tableOccupation, tableMatePayments, false, handler, errorHandler);
                //}, function error() {
                //  console.error("Serial failed to close");
                //messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_serial_cashiers"));
                //})
              }, function error(error) {
                errorHandler && errorHandler({ error: "serial_cashier_error" });
                console.error("Serial failed to open(2): " + JSON.stringify(error));
                messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_serial_cashiers"));
              }), 1000);
          }, function error(error) {
            errorHandler && errorHandler({ error: "serial_cashier_error" });
            console.error("Serial denied: " + JSON.stringify(error));
            messageDialog(I18n.t("local.warning"), I18n.t("admin_local.no_serial_cashiers"));
          });
        } else if (c.format === "android_rs232") {
          try {
            //eslint-disable-next-line no-undef
            uart.list(result => {
              dev = result;
              postPayment(c, tableOccupation, tableMatePayments, false, handler, errorHandler, dev);
            }, error => {
              console.error("UART list error " + JSON.stringify(error));
              dev = "/dev/ttyS3";
              postPayment(c, tableOccupation, tableMatePayments, false, handler, errorHandler, dev);
            })
          } catch (ex) {
            errorHandler && errorHandler({ error: "serial_cashier_error" });
            console.error("Problem with uart", ex)
          }
        } else if (c.format === "android_http") {
          tableMatePayments.forEach(payment => {
            if (payment.qrcode) {
              var commands = payment.qrcode.split("\r\n").filter(c => c).map(command => "command=" + encodeURIComponent(command.substring(8)));
              //commands.push("command=cfr");
              function send() {
                const command = decodeURIComponent(commands.shift());
                _log(command)
                post("http://127.0.0.1:15000/Request", command, {
                  Accept: "gip, deflate",
                  "Content-Type": "application/x-www-form-urlencoded",
                  UrlEncoded: "1"
                }).done(data => {
                  if (commands.length > 0)
                    send();
                  else {
                    const receiptNoMatch = data.match(/<ReceiptNo>(\d\d\d\d\/\d\d\d\d\d).*?<\/ReceiptNo>/);
                    if (receiptNoMatch) {
                      const receiptNo = receiptNoMatch[1]; // Extract the first capturing group
                      console.log("Receipt No:", receiptNo);
                      payment.receiptNo = receiptNo;
                    } else {
                      console.log("Receipt No not found");
                    }
                    //<Response><Echo>P</Echo><Status>80-80-c0-80-80-ee</Status><Data><RequestLine1><ReceiptNo>0138/00003</ReceiptNo></RequestLine1></Data><ErrorCode>F000</ErrorCode></Response>

                    postPayment(c, tableOccupation, tableMatePayments, false, handler, errorHandler, dev);
                  }

                }).fail(data => {
                  _log("failed: " + command)
                  errorHandler && errorHandler({ error: "serial_cashier_error" });
                  console.log("failed:" + command);
                  console.log(JSON.stringify(data));
                })
              }
              send();

            }
          })
        }
      } else {
        postPayment(c, tableOccupation, tableMatePayments, false, handler, errorHandler);
      }
    });
  });
}

async function generateSessionId(tableMateId, orderIds, timestamp) {
  const sortedOrderIds = [...orderIds].sort();
  const input = `${tableMateId}:${sortedOrderIds.join(',')}:${timestamp}`;

  // Encode string to Uint8Array
  const encoder = new TextEncoder();
  const data = encoder.encode(input);

  // Hash the input using SHA-1 (you could also use SHA-256)
  const hashBuffer = await crypto.subtle.digest('SHA-1', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  // Convert to hex string
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  // Format as UUID v5-like (version and variant bits set manually)
  const sessionId = [
    hashHex.substring(0, 8),
    hashHex.substring(8, 12),
    '5' + hashHex.substring(13, 16), // version 5
    (parseInt(hashHex.substring(16, 18), 16) & 0x3f | 0x80).toString(16).padStart(2, '0') + hashHex.substring(18, 20), // variant
    hashHex.substring(20, 32)
  ].join('-');

  return sessionId;
}

var universalLinksTimeout;

export const showNapiAjanlatDialog = () => {
  const LABEL = 'Napi ajánlat';

  // Flatten all leaf menu items from the category tree (active and inactive)
  function flatAllItems(categories) {
    const result = [];
    if (!categories) return result;
    categories.forEach(cat => {
      if (cat.entityType && cat.entityType.indexOf('Category') === -1) {
        result.push(cat);
      } else {
        const items = cat.activeMenuItems || cat.menuItems || [];
        result.push(...items);
        const subCats = cat.activeMenuCategories || cat.menuCategories || cat.children || [];
        result.push(...flatAllItems(subCats));
      }
    });
    return result;
  }

  const allItems = flatAllItems(
    admin.categories?.activeMenuCategories || admin.categories?.menuCategories || admin.categories?.children || []
  );

  const itemName = item => getLocale(item.name) || item.shortName || String(item.id);

  // Add or remove the label via the focused label endpoints
  function setItemLabel(id, hasLabel, afterHandler) {
    const item = admin.getMenuItem(id);
    if (!item) return;

    // Find the label object by name from the global labels list
    const labelObj = (admin.labels || []).find(l => l.name === LABEL);
    if (!labelObj) {
      // Label doesn't exist yet — fall back to fetching labels first
      admin.getLabels(data => {
        admin.labels = data;
        setItemLabel(id, hasLabel, afterHandler);
      });
      return;
    }

    const url = 'restaurantService/' + localStorage.restaurantSelected + '/menuItem/' + id + '/label/' + labelObj.id;
    const req = hasLabel ? post(url, {}) : del(url);
    req.done(data => {
      // Update the local cache
      const cached = admin.getMenuItem(id, true);
      if (cached) {
        const existingLabels = cached.labels || [];
        cached.labels = hasLabel
          ? (existingLabels.some(l => l.name === LABEL) ? existingLabels : [...existingLabels, labelObj])
          : existingLabels.filter(l => l.name !== LABEL);
      }
      afterHandler && afterHandler(data);
    });
  }

  // Build dialog HTML
  const dialogId = 'napiAjanlatDialog';
  $('#' + dialogId).remove();

  const $dialog = $([
    '<div id="' + dialogId + '" class="modal" tabindex="-1" style="display:block;background:rgba(0,0,0,.5);z-index:2000">',
    '  <div class="modal-dialog modal-lg">',
    '    <div class="modal-content">',
    '      <div class="modal-header">',
    '        <h5 class="modal-title">' + LABEL + '</h5>',
    '        <button type="button" class="close" id="napiAjanlatClose"><span>&times;</span></button>',
    '      </div>',
    '      <div class="modal-body" style="overflow-y:auto;max-height:calc(90vh - 120px)">',
    '        <div id="napiAjanlatList" style="display:flex;flex-wrap:wrap;gap:.5rem;min-height:2rem;margin-bottom:1rem;align-items:flex-start"></div>',
    '        <hr style="margin:.5rem 0"/>',
    '        <div style="display:flex;gap:.5rem;align-items:stretch">',
    '          <input id="napiAjanlatSearch" type="text" class="form-control" placeholder="Keresés hozzáadáshoz..." autocomplete="off"/>',
    '        </div>',
    '        <div id="napiAjanlatSearchResults" style="margin-top:.25rem;max-height:200px;overflow-y:auto;border:1px solid #ccc;border-radius:4px;display:none"></div>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join(''));
  $dialog.appendTo(document.body);

  let currentItems = allItems.filter(item =>
    Array.isArray(item.labels) && item.labels.some(l => l.name === LABEL)
  );

  function renderList() {
    const $list = $dialog.find('#napiAjanlatList');
    $list.empty();
    if (!currentItems.length) {
      $list.append('<span class="text-muted" style="line-height:2">Nincs ilyen termék</span>');
      return;
    }
    currentItems.forEach(item => {
      const name = itemName(item);
      const $badge = $('<span class="badge badge-secondary" style="font-size:.9rem;padding:.35rem .55rem;display:inline-flex;align-items:center;gap:.3rem">' +
        '<span>' + $('<div>').text(name).html() + '</span>' +
        '<button class="close" data-id="' + item.id + '" style="font-size:1rem;line-height:1;margin-left:.2rem">&times;</button>' +
        '</span>');
      $list.append($badge);
    });
    $list.find('button.close').on('click', function () {
      const id = Number($(this).data('id'));
      setItemLabel(id, false, () => {
        currentItems = currentItems.filter(i => i.id !== id);
        renderList();
      });
    });
  }

  renderList();

  // Search / add
  $dialog.find('#napiAjanlatSearch').on('input', function () {
    const term = $(this).val().trim().toLowerCase();
    const $results = $dialog.find('#napiAjanlatSearchResults');
    if (!term) { $results.hide().empty(); return; }

    const matches = allItems
      .filter(item => !currentItems.some(c => c.id === item.id))
      .filter(item => itemName(item).toLowerCase().includes(term))
      .slice(0, 20);

    $results.empty();
    if (!matches.length) { $results.hide(); return; }
    matches.forEach(item => {
      const displayName = itemName(item);
      const $row = $('<div style="padding:.3rem .6rem;cursor:pointer;border-bottom:1px solid #eee" class="hover-highlight">' +
        $('<div>').text(displayName).html() + '</div>');
      $row.on('mouseenter', function () { $(this).css('background', '#f0f0f0'); });
      $row.on('mouseleave', function () { $(this).css('background', ''); });
      $row.on('click', function () {
        $dialog.find('#napiAjanlatSearch').val('');
        $results.hide().empty();
        setItemLabel(item.id, true, () => {
          if (!currentItems.some(i => i.id === item.id)) currentItems.push(item);
          renderList();
        });
      });
      $results.append($row);
    });
    $results.show();
  });

  $dialog.find('#napiAjanlatClose').on('click', () => { get('epdService/refreshAllTableLabels'); $dialog.remove(); });
  $dialog.on('click', function (e) {
    if ($(e.target).is($dialog)) { get('epdService/refreshAllTableLabels'); $dialog.remove(); }
  });
};

export const showMenuItemAvailabilityDialog = () => {
  _log("showMenuItemAvailabilityDialog");
  // Flatten all leaf menu items from the category tree, attaching their category path
  function flatAllItems(categories, path) {
    const result = [];
    if (!categories) return result;
    categories.forEach(cat => {
      if (cat.entityType && cat.entityType.indexOf('Category') === -1) {
        cat._path = path;
        result.push(cat);
      } else {
        const catName = getLocale(cat.name) || cat.shortName || String(cat.id);
        const catPath = path ? path + ' › ' + catName : catName;
        const items = cat.activeMenuItems || cat.menuItems || [];
        items.forEach(item => { item._path = catPath; });
        result.push(...items);
        const subCats = cat.activeMenuCategories || cat.menuCategories || cat.children || [];
        result.push(...flatAllItems(subCats, catPath));
      }
    });
    return result;
  }

  const allItems = flatAllItems(
    admin.categories?.activeMenuCategories || admin.categories?.menuCategories || admin.categories?.children || [],
    ''
  );

  const itemName = item => getLocale(item.name) || item.shortName || String(item.id);
  const itemDisplayName = item => item._path ? item._path + ' › ' + itemName(item) : itemName(item);

  const dialogId = 'menuItemAvailabilityDialog';
  $('#' + dialogId).remove();

  const $dialog = $([
    '<div id="' + dialogId + '" class="modal" tabindex="-1" style="display:block;background:rgba(0,0,0,.5);z-index:2000">',
    '  <div class="modal-dialog modal-lg">',
    '    <div class="modal-content">',
    '      <div class="modal-header">',
    '        <h5 class="modal-title">' + admin_local.menu_item_availability + '</h5>',
    '        <button type="button" class="close" id="menuItemAvailabilityClose"><span>&times;</span></button>',
    '      </div>',
    '      <div class="modal-body" style="overflow-y:auto;max-height:calc(90vh - 160px)">',
    '        <div class="alert alert-info" style="padding:.4rem .75rem;margin-bottom:.75rem;font-size:.875rem">' + admin_local.availability_explanation + '</div>',
    '        <div style="margin-bottom:.5rem;font-weight:bold">' + admin_local.unavailable_items + '</div>',
    '        <div id="menuItemAvailabilityList" style="display:flex;flex-wrap:wrap;gap:.5rem;min-height:2rem;margin-bottom:1rem;align-items:flex-start"></div>',
    '        <hr style="margin:.5rem 0"/>',
    '        <div style="display:flex;gap:.5rem;align-items:stretch;flex-wrap:wrap">',
    '          <input id="menuItemAvailabilitySearch" type="text" class="form-control" placeholder="' + admin_local.search_to_add_remove + '" autocomplete="off" style="flex:1;min-width:200px"/>',
    '          <button id="menuItemAvailabilityAddAll" class="btn btn-danger" style="white-space:nowrap">' + admin_local.make_unavailable_matching + '</button>',
    '          <button id="menuItemAvailabilityRemoveAll" class="btn btn-success" style="white-space:nowrap">' + admin_local.make_available_matching + '</button>',
    '        </div>',
    '        <div id="menuItemAvailabilitySearchResults" style="margin-top:.25rem;max-height:200px;overflow-y:auto;border:1px solid #ccc;border-radius:4px;display:none"></div>',
    '      </div>',
    '      <div class="modal-footer" style="justify-content:flex-start">',
    '        <button id="menuItemAvailabilityRestoreAll" class="btn btn-warning">' + admin_local.make_all_available + '</button>',
    '      </div>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join(''));
  $dialog.appendTo(document.body);

  // Items currently marked as unavailable (available === false) AND still active
  let unavailableItems = allItems.filter(item => item.available === false && item.isActive !== false);

  function renderList() {
    const $list = $dialog.find('#menuItemAvailabilityList');
    $list.empty();
    if (!unavailableItems.length) {
      $list.append('<span class="text-muted" style="line-height:2">' + admin_local.all_items_available + '</span>');
      return;
    }
    unavailableItems.forEach(item => {
      const name = itemDisplayName(item);
      const $badge = $('<span class="badge badge-danger" style="font-size:.9rem;padding:.35rem .55rem;display:inline-flex;align-items:center;gap:.3rem">' +
        '<span>' + $('<div>').text(name).html() + '</span>' +
        '<button class="close" data-id="' + item.id + '" style="font-size:1rem;line-height:1;margin-left:.2rem;color:white">&times;</button>' +
        '</span>');
      $list.append($badge);
    });
    $list.find('button.close').on('click', function () {
      const id = Number($(this).data('id'));
      menuitemUtils.modifyMenuItemsAvailabilty([id], true, d => {
        if (d) admin.categories = d;
        unavailableItems = unavailableItems.filter(i => i.id !== id);
        renderList();
      });
    });
  }

  renderList();

  function getSearchMatches() {
    const term = $dialog.find('#menuItemAvailabilitySearch').val().trim().toLowerCase();
    if (!term) return [];
    return allItems.filter(item => itemName(item).toLowerCase().includes(term));
  }

  function renderSearchResults(matches) {
    const $results = $dialog.find('#menuItemAvailabilitySearchResults');
    $results.empty();
    if (!matches.length) { $results.hide(); return; }
    matches.forEach(item => {
      const isUnavail = item.available === false;
      const $row = $('<div style="padding:.3rem .6rem;cursor:pointer;border-bottom:1px solid #eee;display:flex;justify-content:space-between;align-items:center">' +
        '<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:.5rem">' + $('<div>').text(itemDisplayName(item)).html() + '</span>' +
        '<span class="badge ' + (isUnavail ? 'badge-danger' : 'badge-success') + '" style="flex-shrink:0">' + (isUnavail ? admin_local.unavailable : admin_local.available) + '</span>' +
        '</div>');
      $row.on('mouseenter', function () { $(this).css('background', '#f0f0f0'); });
      $row.on('mouseleave', function () { $(this).css('background', ''); });
      $row.on('click', function () {
        const newAvail = item.available !== false;  // toggle
        menuitemUtils.modifyMenuItemsAvailabilty([item.id], !newAvail, d => {
          if (d) admin.categories = d;
          item.available = !newAvail;
          if (!newAvail) {
            unavailableItems = unavailableItems.filter(i => i.id !== item.id);
          } else {
            if (item.isActive !== false && !unavailableItems.some(i => i.id === item.id)) unavailableItems.push(item);
          }
          renderList();
          // refresh results display
          const newMatches = getSearchMatches();
          renderSearchResults(newMatches);
        });
      });
      $results.append($row);
    });
    $results.show();
  }

  $dialog.find('#menuItemAvailabilitySearch').on('input', function () {
    renderSearchResults(getSearchMatches());
  });

  // Disable all matching search results
  $dialog.find('#menuItemAvailabilityAddAll').on('click', function () {
    const matches = getSearchMatches().filter(item => item.available !== false && item.isActive !== false);
    if (!matches.length) return;
    menuitemUtils.modifyMenuItemsAvailabilty(matches.map(i => i.id), false, d => {
      if (d) admin.categories = d;
      matches.forEach(item => {
        item.available = false;
        if (!unavailableItems.some(i => i.id === item.id)) unavailableItems.push(item);
      });
      renderList();
      renderSearchResults(getSearchMatches());
    });
  });

  // Enable all matching search results
  $dialog.find('#menuItemAvailabilityRemoveAll').on('click', function () {
    const matches = getSearchMatches().filter(item => item.available === false && item.isActive !== false);
    if (!matches.length) return;
    menuitemUtils.modifyMenuItemsAvailabilty(matches.map(i => i.id), true, d => {
      if (d) admin.categories = d;
      matches.forEach(item => {
        item.available = true;
        unavailableItems = unavailableItems.filter(i => i.id !== item.id);
      });
      renderList();
      renderSearchResults(getSearchMatches());
    });
  });

  // Enable all items globally
  $dialog.find('#menuItemAvailabilityRestoreAll').on('click', function () {
    const toRestore = [...unavailableItems];
    if (!toRestore.length) return;
    menuitemUtils.modifyMenuItemsAvailabilty(toRestore.map(i => i.id), true, d => {
      if (d) admin.categories = d;
      toRestore.forEach(item => { item.available = true; });
      unavailableItems = [];
      renderList();
      renderSearchResults(getSearchMatches());
    });
  });

  $dialog.find('#menuItemAvailabilityClose').on('click', () => $dialog.remove());
  $dialog.on('click', function (e) {
    if ($(e.target).is($dialog)) $dialog.remove();
  });
};

export const payByCardSoftPos = async (tableMatePayments, callback) => {
  const payments = tableMatePayments[0].payments;
  if (typeof payments === "undefined" || payments.length === 0) {
    callback();
    return;
  }
  const paynancePos = payments.find(p => getPaymentMethod(p.paymentMethod).method.type === "paynance");
  if (false && paynancePos?.amount) {
    const currency = auth.myStatus.restaurant_currencies.find(c => c.currency.id == paynancePos.currency)?.currency;
    const sessionId = await generateSessionId(tableMatePayments[0].tableMate, tableMatePayments[0].orders, mateInState(getTableMate(tableMatePayments[0].tableMate), "wantsToPay")?.timestamp);
    _log("sessionId:" + tableMatePayments[0].tableMate + " " + tableMatePayments[0].orders + " " + mateInState(getTableMate(tableMatePayments[0].tableMate), "wantsToPay")?.timestamp + " " + sessionId);
    //eslint-disable-next-line no-undef
    const universalLink = universalLinks;
    //eslint-disable-next-line no-undef
    if (cordova?.plugins?.PaynanceGateway) {
      //eslint-disable-next-line no-undef
      cordova.plugins.PaynanceGateway.checkGateway((result) => {
        paynancePos.softPos = true;
        if (result) {

          if (window.universalLinksTimeout) {
            try {
              clearTimeout(window.universalLinksTimeout);
              window.universalLinksTimeout = null;
            } catch (ex) {
              console.error(ex);
            }
          }

          // Save existing handler to restore later if needed
          const oldHandleOpenURL = window.handleOpenURL;

          function handler() {
            document.removeEventListener("resume", handler);
            // Restore old handler (if any)
            if (oldHandleOpenURL) {
              window.handleOpenURL = oldHandleOpenURL;
            } else {
              delete window.handleOpenURL;
            }

            // Clear timeout
            clearTimeout(window.universalLinksTimeout);
            window.universalLinksTimeout = null;
            try {
              callback();
            } catch (err) {
              console.error('Error handling URL:', err);
            } finally {
            }
          }

          document.addEventListener("resume", handler);
          window.handleOpenURL = handler;

          // Set a timeout to clean up the handler if no event comes in
          window.universalLinksTimeout = setTimeout(() => {
            if (window.handleOpenURL === oldHandleOpenURL || !window.handleOpenURL) return;
            document.removeEventListener("resume", handler);
            if (oldHandleOpenURL) {
              window.handleOpenURL = oldHandleOpenURL;
            } else {
              delete window.handleOpenURL;
            }
            window.universalLinksTimeout = null;
          }, 60000);

          const bankTerminal = auth.myStatus.restaurant_bank_terminals.find(t => t.name === paynancePos.terminal);

          get("paymentService/" + localStorage.restaurantSelected + "/paynance/" + paynancePos.terminal + "/" + sessionId).done(result => {
            if (!result.paid) {
              //eslint-disable-next-line no-undef
              cordova.plugins.PaynanceGateway.openGateway({
                ownerAppPackage: 'eu.paynance.softpos.eatwithme',
                //ownerAppDeepLinkCallback: auth.server + '/eatwithme.server/paymentService/paynance/softposCallback?instance=' + localStorage.instance + "&paymentId=1123",
                ownerAppDeepLinkCallback: 'eatwithmeconsole://paynance',
                sessionId: sessionId,
                sourceCode: bankTerminal.terminal.split("/")[1],
                terminalId: bankTerminal.terminal.split("/")[0],
                cashRegisterId: 'CashRegisterId',
                amount: '' + paynancePos.amount * 100,
                currencyCode: '348',
                merchantReference: 'some-reference',
                customerTrns: 'some-reference',
                tipAmount: '4000',
                action: 'sale'
              }, function (successMsg) {
                //callback();
              }, function (errMsg) {
              });
            } else callback();
          });
        } else {
          //_log("payByCardSoftPos4");
          callback();
        }
      });
    } else {
      callback();
    }
    return
  }
  const teyaPos = payments.find(p => getPaymentMethod(p.paymentMethod).method.type === "teya");
  if (false && teyaPos?.amount) {
    const currency = auth.myStatus.restaurant_currencies.find(c => c.currency.id == teyaPos.currency)?.currency;
    const sessionId = await generateSessionId(tableMatePayments[0].tableMate, tableMatePayments[0].orders, mateInState(getTableMate(tableMatePayments[0].tableMate), "wantsToPay")?.timestamp);
    //eslint-disable-next-line no-undef
    const universalLink = universalLinks;
    //eslint-disable-next-line no-undef
    if (cordova?.plugins?.TeyaGateway) {
      _log("teyaPosGateway?");
      //eslint-disable-next-line no-undef
      cordova.plugins.TeyaGateway.checkGateway((result) => {
        _log("teyaPosGateway yes");
        teyaPos.softPos = true;
        if (result) {

          if (window.universalLinksTimeout) {
            try {
              clearTimeout(window.universalLinksTimeout);
              window.universalLinksTimeout = null;
            } catch (ex) {
              console.error(ex);
            }
          }

          // Save existing handler to restore later if needed
          const oldHandleOpenURL = window.handleOpenURL;

          window.handleOpenURL = function (url) {
            try {
              _log('handleOpenURL triggered with URL: ' + url);

              const parsedUrl = new URL(url);

              if (parsedUrl.hostname === 'teyatap') {
                callback();
              } else {
                _log('URL does not match expected path: ' + parsedUrl.hostname);
              }
            } catch (err) {
              console.error('Error handling URL:', err);
            } finally {
              // Restore old handler (if any)
              if (oldHandleOpenURL) {
                window.handleOpenURL = oldHandleOpenURL;
              } else {
                delete window.handleOpenURL;
              }

              // Clear timeout
              clearTimeout(window.universalLinksTimeout);
              window.universalLinksTimeout = null;
            }
          };

          // Set a timeout to clean up the handler if no event comes in
          window.universalLinksTimeout = setTimeout(() => {
            if (window.handleOpenURL === oldHandleOpenURL || !window.handleOpenURL) return;

            if (oldHandleOpenURL) {
              window.handleOpenURL = oldHandleOpenURL;
            } else {
              delete window.handleOpenURL;
            }
            window.universalLinksTimeout = null;
          }, 60000);


          //eslint-disable-next-line no-undef
          cordova.plugins.TeyaGateway.openGateway({
            session: sessionId,
            amount: '' + paynancePos.amount * 100,
            currency: 'HUF',
          }, function (successMsg) {
            //callback();
          }, function (errMsg) {
          });
        } else {
          //_log("payByCardSoftPos4");
          callback();
        }
      });
    } else {
      callback();
    }
    return;
  }
  const hellopayPos = payments.find(p => getPaymentMethod(p.paymentMethod).method.type === "hellopay");
  if (hellopayPos?.amount && localStorage.hellopay_terminal !== "undefined") {
    const terminal = getBankTerminal(localStorage.hellopay_terminal);
    const currency = auth.myStatus.restaurant_currencies.find(c => c.currency.id == hellopayPos.currency)?.currency;
    const sessionId = await generateSessionId(tableMatePayments[0].tableMate, tableMatePayments[0].orders, mateInState(getTableMate(tableMatePayments[0].tableMate), "wantsToPay")?.timestamp);
    //eslint-disable-next-line no-undef
    //eslint-disable-next-line no-undef
    if (terminal.format === "android_http") {
      _log("HelloPay executePayment");
      const payload = { payload: { requestId: sessionId, base: hellopayPos?.amount, tip: 0 } };
      if (window.HelloPay) {
        _log("HelloPay payment start");
        //eslint-disable-next-line no-undef
        window.HelloPay.pay(terminal.terminal, terminal.accessToken, payload, success => {
          _log("HelloPay payment success:" + JSON.stringify(success));
          if (success.errorCode === 0) {
            callback();
          }
          if (success.errorMessage) {
            $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", false);
            $("#tableMatePaid.modal button#save").prop("disabled", false);
            messageDialog(I18n.t("local.warning"), I18n.t("admin_local." + success.errorMessage) || success.errorMessage);
          }
        }, error => {
          messageDialog(I18n.t("local.warning"), I18n.t("admin_local." + error.errorMessage));
          _log("HelloPay payment error:" + JSON.stringify(error));
        }
        )
      } else {
        $("#tableMatePaid.modal button#save-and-unlock").prop("disabled", false);
        $("#tableMatePaid.modal button#save").prop("disabled", false);
      }
      return;
    } else {
      callback();
    }
    return;
  }
  callback();
}

export const getBankTerminal = (name) => {
  return auth.myStatus.restaurant_bank_terminals.find(t => t.name == name);
}

export const increase = event => {
  var li = $(
    $(event.currentTarget)
      .parents("li.mate")
      .get(0)
  );
  if (!li.hasClass("active")) return;
  li.attr("count", Number(li.attr("count")) + 1);
  li.find("span.times").text("x " + li.attr("count"));
  li.find("span.times").removeClass("hidden");
  event.stopPropagation();
};

export const decrease = event => {
  var li = $(
    $(event.currentTarget)
      .parents("li.mate")
      .get(0)
  );
  if (!li.hasClass("active")) return;
  if (li.attr("min") == null || li.attr("count") > li.attr("min")) li.attr("count", Number(li.attr("count")) - 1);
  else {
    li.click();
  }
  li.find("span.times").text("x " + li.attr("count"));
  event.stopPropagation();
};

var orderIndex = 0;

export const getMenuItemAdditions = (baseMenuItem, search, type, takeaway = undefined, additions, x) => {
  orderIndex = 0;
  var set2 = new SortedSet({
    comparator: function (a, b) {
      return a.value.localeCompare(b.value);
    }
  });
  var included = [];
  var set = new SortedSet({
    comparator: function (a, b) {
      if (included.indexOf(a.id) >= 0 && included.indexOf(b.id) < 0) return -1;
      if (included.indexOf(b.id) >= 0 && included.indexOf(a.id) < 0) return 1;
      var r = a.orderIndex - b.orderIndex;
      if (r == 0) return 0;
      return r;
    }
  });
  if (type == "optional") {
    _getMenuItemAdditions(baseMenuItem, search, set2, baseMenuItem.menuItemAdditions, "included", 0, takeaway);
    _getMenuCategoryAdditions(baseMenuItem, search, set2, baseMenuItem.menuCategoryAdditions, "included", 0, takeaway);
    set2.forEach(function (e) {
      //if (included.indexOf(e.id) < 0) included.push(e.id);
    });
  }
  _getMenuItemAdditions(baseMenuItem, search, set, baseMenuItem.menuItemAdditions, type, 0, takeaway);
  _getMenuCategoryAdditions(baseMenuItem, search, set, baseMenuItem.menuCategoryAdditions, type, 0, takeaway);

  /*
   * if (type=='optional') getAllMenuItemAdditions(baseMenuItem, search, set,
   * categories.activeMenuCategories, type);
   */


  if (type === "included" && additions) {
    additions.forEach(a => {
      const menuItem = getMenuItem(a.split("-")[0]);
      const resplus = getMenuItemAdditions(menuItem, search, type, takeaway, []);

      resplus.forEach(r => set.insert(r));
    })
  }

  var result = [];
  set.forEach(function (e) {
    if (type != "optional" || included.indexOf(e.id) == -1) {
      if (result.indexOf(e) < 0) result.push(e);
    }
  });
  return result;
};

export const activeMenuCategories = (category) => {
  if (!category) return [];
  return (category.activeMenuCategories ? category.activeMenuCategories : category.children ? category.children.filter(c => !c.availableQuantities) : []).sort((a, b) => a.globalOrder - b.globalOrder);
}

const defaultPOSFilter = additionOption => {
  if (additionOption.type === "meal_addition" || additionOption.type === "drink_addition") {
    const m = getMenuItem(additionOption.addition.id);
    return m?.defaultPos;
  } else if (additionOption.type === "mealcategory_addition" || additionOption.type === "drinkcategory_addition") {
    const m = getMenuCategory(additionOption.addition.id);
    return m?.defaultPos;
  } else if (additionOption.type === "meal" || additionOption.type === "drink") {
    return additionOption?.defaultPos;
  } else if (additionOption.type === "meal_category" || additionOption.type === "drink_category") {
    return additionOption?.defaultPos;
  }
  return true;
}

function f(addition) {
  return orderListUtil.additionFilter ? orderListUtil.additionFilter(addition) : defaultPOSFilter(addition);
}

export const activeMenuItems = (category, menuItem, sub = false, takeaway) => {
  // if menuItem has menuitem options from the same category, then only those options should be retured
  if (!category) return [];
  category = admin.getMenuCategory(category.id);
  var result = (category.activeMenuItems ? category.activeMenuItems.map(m => admin.getMenuItem(m.id)).filter(f) : category.children.map(m => admin.getMenuItem(m.id)).filter(c => c.availableQuantities).filter(f)).map(a => ({ ...a, availableQuantities: a.availableQuantities.filter(f) }));
  if (sub) {
    if (category.activeMenuCategories) {
      category.activeMenuCategories.filter(f).forEach(c => {
        const r = activeMenuItems(c, menuItem);
        r.forEach(rr => !result.find(e => e.id == rr.id) && result.push(rr));
      });
    } else if (category.children) {
      category.children.filter(f).filter(c => !c.availableQuantities).forEach(c => {
        const r = activeMenuItems(c, menuItem);
        r.forEach(rr => !result.find(e => e.id == rr.id) && result.push(rr));
      });
    }
  }

  var explicitOptionalMenuItems = [];
  var m = menuItem;
  while (m) {
    m.menuItemAdditions.forEach(a => explicitOptionalMenuItems.push(a));
    m = m.menuCategoryId ? getMenuCategory(m.menuCategoryId) : null;
  }

  if (menuItem && explicitOptionalMenuItems.filter(f).filter(a => {
    return a.additionType === "optional" && result.find(m => Number(m.id) === Number(a.additionId));
  }).length) {
    //limit the category menu items if items from it is listed explicitly as well
    result = result.flatMap(m => {
      const as = explicitOptionalMenuItems.filter(a => a.local === a.takeaway || a.local && !takeaway || a.takeaway && takeaway).filter(a => a.additionType === "optional" || a.additionType === "included").filter(a => Number(a.additionId) === Number(m.id));
      return as.length ? as.map(a => {
        return { ...m, availableQuantities: m.availableQuantities.filter(q => q.quantity == a.quantity) };
      }).filter(m => m) : null;
    }).filter(m => m);
  }
  return result.filter(f).filter(a => a.isActive || a.active);
}

function getAllMenuItemAdditions(baseMenuItem, search, set, categories, type, order) {
  categories.forEach(function (category) {
    getAllMenuItemAdditions(baseMenuItem, search, set, activeMenuCategories(category), type);
    activeMenuItems(category).filter(f).forEach(function (item) {
      item.availableQuantities.filter(f).forEach(function (q) {
        // quantityLabel = q.label;
        var i = { id: item.id, value: item.id + "-" + parseFloat(q.quantity), text: getLocale(item.name) };
        if (!set.contains(i)) set.insert({ id: item.id, orderIndex: order, visible: true, quantityType: getLocale(item.quantityType), value: item.id + "-" + parseFloat(q.quantity), text: getLocale(item.name) });
      });
    });
  });
}

function _getMenuItemAdditions(baseMenuItem, search, set, categories, type, order = 0, takeaway) {
  if (categories != undefined)
    categories.filter(f).forEach(function (addition) {
      if (typeof takeaway !== "undefined" && addition.local !== addition.takeaway) {
        if (addition.local && takeaway) {
          return;
        }
        if (addition.takeaway && !takeaway) {
          return;
        }
      }
      if (typeof type != "undefined" && type != addition.additionType) return;
      var regexp = new RegExp(search, "ig");
      var item = getMenuItem(addition.additionId);
      if (item.type == "deleted") return;
      if (regexp.test(getLocale(item.name))) {
        var quantity = getQuantity2(addition.quantity, item.quantityType);
        quantity = (quantity != "" ? " " : "") + quantity;
        var quantityLabel = "";
        item.availableQuantities.forEach(function (q) {
          if (q.quantity == addition.quantity) quantityLabel = q.label;
        });
        var i = { id: item.id, orderIndex: orderIndex++, value: item.id + "-" + parseFloat(addition.quantity), text: getLocale(item.name), proportional: addition.proportional };
        if (!set.contains(i)) set.insert({ id: item.id, local: addition.local, takeaway: addition.takeaway, orderIndex: order + addition.order, visible: true, quantityType: getLocale(item.quantityType), value: item.id + "-" + parseFloat(addition.quantity), text: getLocale(item.name), proportional: addition.proportional });
      }
    });
  if (baseMenuItem.menuCategoryId) {
    var parent = getMenuItemCategory(baseMenuItem.menuCategoryId);
    if (parent !== null)
      _getMenuItemAdditions(parent, search, set, parent.menuItemAdditions, type, (order + 1) * 1000, takeaway);
  }
}

function _getMenuCategoryAdditions(baseMenuItem, search, set, categories, type, order = 0, takeaway) {
  if (categories != undefined)
    categories.filter(f).forEach(function (addition) {
      if (typeof type != "undefined" && type != addition.additionType) return;
      if (addition.optionType && addition.optionType != "multiple") return;
      var regexp = new RegExp(search, "ig");
      var item = getMenuItemCategory(addition.additionId);
      if (item && regexp.test(getLocale(item.name))) {
        getMenuItemsForCategory(item).filter(f).forEach(function (item) {
          if (item.availableQuantities.length == 0) {
            var i = { id: item.id, visible: true, orderIndex: order + addition.order, quantityType: getLocale(item.quantityType), value: item.id + "-1", text: getLocale(item.name) };
            if (!set.contains(i)) set.insert(i);
          } else {
            item.availableQuantities.filter(f).forEach(function (quantity) {
              if (quantity.onMenu) {
                var i = { id: item.id, visible: true, orderIndex: order + addition.order, quantityType: getLocale(item.quantityType), value: item.id + "-" + parseFloat(quantity.quantity), text: getLocale(item.name) };
                if (!set.contains(i)) set.insert(i);
              }
            });
          }
        });
      }
    });
  if (baseMenuItem.menuCategoryId) {
    var parent = getMenuItemCategory(baseMenuItem.menuCategoryId);
    if (parent) {
      _getMenuCategoryAdditions(parent, search, set, parent.menuCategoryAdditions, type, (order + 1) * 1000, takeaway);
    }
  }
}

export const getMenuCategoryOptions = (baseMenuItem, additionsSelected) => {
  var result = [];
  _getMenuCategoryOptions(baseMenuItem, result, baseMenuItem.menuCategoryAdditions);
  additionsSelected && additionsSelected.forEach(a => {
    const aa = a.split("-")[2];
    if (aa === "true") {
      const menuItem = getMenuItem(a.split("-")[0]);
      var result2 = [];
      _getMenuCategoryOptions(menuItem, result2, menuItem.menuCategoryAdditions);
      result2.forEach(r => {
        if (!result.find(e => e.additionId === r.additionId && e.optionType === r.optionType)) {
          result.push({ ...r, baseMenuItem: menuItem });
        }
      });
    }
  });
  result = result.filter(c => getMenuCategory(c.additionId)).filter(c => {
    const mc = getMenuCategory(c.additionId);
    return mc.isActive || mc.active;
  });
  if (result)
    return result.sort((a, b) => a.order - b.order);
  else return [];
};
function _getMenuCategoryOptions(baseMenuItem, set, categoryAdditions) {
  if (categoryAdditions != undefined)
    categoryAdditions.filter(f).forEach(function (addition) {
      if (addition.optionType && addition.optionType != "multiple") {
        set.push(addition);
        return;
      }
    });
  if (baseMenuItem.menuCategoryId) {
    var parent = getMenuItemCategory(baseMenuItem.menuCategoryId);
    if (parent)
      _getMenuCategoryOptions(parent, set, parent.menuCategoryAdditions);
  }
}

function getMenuItemsForCategory(category) {
  var items = [];
  activeMenuItems(category).forEach(function (item) {
    items.push(item);
  });
  return items;
}

function getMenuItems(baseMenuItem, search) {
  var regexp = new RegExp(search, "ig");
  var set = new Set();
  var menuItem = _getMenuItems(baseMenuItem, regexp, set, activeMenuCategories(admin.categories));
  if (menuItem == "") {
    return null;
  }
  var result = [];
  set.forEach(function (e) {
    result[result.length] = e;
  });
  return result;
}

function _getMenuItems(baseMenuItem, regexp, set, categories) {
  categories.forEach(function (item) {
    if (item.isTop == true) {
      if (typeof item.activeMenuItems == "undefined") {
        if (item.type == baseMenuItem.type && regexp.test(item.name)) set.add({ value: item.id, text: getLocale(item.name) });
      } else {
        if (item.activeMenuCategories && item.activeMenuCategories.length > 0) _getMenuItems(baseMenuItem, regexp, set, item.activeMenuCategories);
        if (item.activeMenuItems && item.activeMenuItems.length > 0) _getMenuItems(baseMenuItem, regexp, set, item.activeMenuItems);
        if (item.children && item.children.length > 0) _getMenuItems(baseMenuItem, regexp, set, item.children);
      }
    }
  });
}

var tableNumber = "";

function keyDownHandler(e) {
  resetLockTimeout();
  if (e.isDefaultPrevented()) return;
  if (_keyDownHandler(e)) return true;
  if (e.isDefaultPrevented()) return;
  // eslint-disable-next-line no-fallthrough
  switch (e.which) {
    case 96: // 0
    case 97: // 1
    case 98: // 2
    case 99: // 3
    case 100: // 4
    case 101: // 5
    case 102: // 6
    case 103: // 7
    case 104: // 8
    case 105: // 9
      e.which -= 96 - 48;
    // eslint-disable-next-line no-fallthrough
    case 48: // 0
    case 49: // 1
    case 50: // 2
    case 51: // 3
    case 52: // 4
    case 53: // 5
    case 54: // 6
    case 55: // 7
    case 56: // 8
    case 57: // 9
      tableNumber += "" + (e.which - 48);
      var t = tableNumber;
      setTimeout(function () {
        if (t == tableNumber) {
          if (t.startsWith(0)) {
            //quickChangeToUser(tableNumber.substring(1));
          } else if (localStorage.locked == "true") {
            quickChangeToUser(tableNumber);
          } else {
            $("#c svg:visible .eatwithme-table.selectable.selected").removeClass("selected");
            var selected = $("#c svg:visible #" + tableNumber + ".eatwithme-table.selectable");
            select(selected);
          }
          tableNumber = "";
        }
      }, 1000);
      break;
    case 32: // space
      if (e.target.localName != "input") {
        var selected = $(
          $(".selectable.selectedTop")
            .find(".selectable.selected")
            .get(0)
        );
        if (selected.hasClass("list-group-item")) {
          if (typeof selected != "undefined" && selected.parents(".list-group.checked-list-box").length > 0) {
            selected.click();
            e.preventDefault();
          }
        } else if (selected.parents(".btn-group-toggle").length > 0) {
          selected.click();
          e.preventDefault();
        }
      }
      break;
    case 13: // enter
      if (typeof sessionStorage._editTable !== "undefined")
        return;
      if (e.target.localName != "input" && tableNumber != "") {
        if (tableNumber.startsWith(0)) {
          quickChangeToUser(tableNumber.substring(1));
        } else if (localStorage.locked == "true") {
          quickChangeToUser(tableNumber);
        } else {
          if (localStorage.locked != "true") {
            $("#c svg:visible .eatwithme-table.selectable.selected:not(.inactive)").removeClass("selected");
            var selected = $("svg").find("#" + tableNumber + ".eatwithme-table.selectable");
            select(selected);
          }
        }
        tableNumber = "";
      }
      if (e.target.localName != "input" && localStorage.locked != "true") {
        var id = $("#c svg:visible .eatwithme-table.selectable.selected:not(.inactive)").attr("id");
        if (id != undefined) {
          selectTableNumberSelected(id);
          updateTableMates().done(function () {
            orderListUtil.processOrders(orderListUtil.ordersCache);
            if (orderListUtil.tablesOverview) tableLayout.updateTableOccupations();
            var tab = $("#" + localStorage.atTheTableSelectedTab + ".tab-pane");
            if (tab == undefined || !isVisible(tab)) {
              tab = $("#left_pane .tab-content .tab-content .tab-pane").get(0);
              localStorage.atTheTableSelectedTab = $(tab).attr("id");
            }
            if (selected.attr("tableOccupations") == null) {
              tableLayout.pre_selected_action = "pre-lock-order";
              lockTable(sessionStorage.tableNumberSelected, 1, updateTableOccupationsAndSelect);
            }
            select(tab);
          });
        }
      }
      break;
      /*
    case 37: // left
    case 38: // up
      if (localStorage.locked == "true") return;
      if (!e.shiftKey && !e.ctrlKey && !e.altKey) {
        var selected = $("#c svg:visible .selectable.selected");
        var id = selected.length == 0 ? 2 : selected.attr("id");
        var i = 1;
        for (i = Number(id) - 1; i >= 0; i--) {
          var selected = $("#c svg:visible #" + i + ".eatwithme-table.selectable");
          if (selected.length != 0) break;
        }
        select(selected);
      }
      break;
    case 40: // down
    case 39: // right
      if (localStorage.locked == "true") return;
      if (!e.shiftKey && !e.ctrlKey && !e.altKey) {
        var selected = $("#c svg:visible .selectable.selected");
        var id = selected.length == 0 ? 0 : selected.attr("id");
        if (orderListUtil.tablesOverview)
          for (i = Number(id) + 1; i <= tableLayout.tables.length; i++) {
            var selected = $("#c svg:visible #" + i + ".eatwithme-table.selectable");
            if (selected.length != 0) break;
          }
        select(selected);
      }
      break;
      */
    default:
  }
  return e.target.localName != "input";
}
function order2(id) {
  var orders = [];
  orderListUtil.ordersCache.forEach(function (order) {
    if (order.state != "selected") {
      order = $.extend(true, {}, order);
      var forWhom = getTableMate(order.forWhomId);
      if (forWhom.payingMateId == id) {
        orders.push(order);
        order.quantityLabel = getQuantity(order);
        order.addition = true;
        var d = order.discountComment;
        order.discountComment = "";
        if (d != null && d != "")
          d.split(";").forEach(function (dis) {
            var dis2 = dis.split(",");
            order.discountComment += admin_local.discount + ": " + getDiscount(dis2[0]).name + " " + "\r\n";
          });
        order.orderId = order.id;
        order.menuItem = order.menuItem != null ? getMenuItem(order.menuItem.id) : {};
        order.childOrders.forEach(function (childorder) {
          childorder.menuItem = getMenuItem(childorder.menuItem.id);
          childorder.orderId = order.id;
          orders.push(childorder);
        });
      }
    }
  });
  return orders;
}


export const getAmountsToPay = set => {
  var amount = 0;
  set.forEach(function (t) {
    amount += getAmountToPay(t.id ? t.id : t);
  });
  return amount;
};

export const getOpenOrdersCount = set => {
  var count = 0;
  set.forEach(function (t) {
    count += getOrdersToPay(t.id ? t.id : t).length;
  });
  return count;
};

export const getAmountToPayExemptOfServiceFee = (id, date) => {
  var amount = 0;
  const containerChargeItem = getSetting("takeaway.containerChargeItem");
  var mates = [];
  getOrdersPaidBy(id, date).filter(o => o.menuItem.id == containerChargeItem).map(o => getOrderById(o.id)).forEach(function (order) {
    if (order.paid != true && order.state != "selected" && order.state != "ordered" && order.state != "cancelled") {
      amount += auth.round(order.fullPrice - order.discount);
      if (mates.indexOf(order.forWhomId) < 0) mates.push(order.forWhomId);
    }
  });
  /*mates.forEach(function (id) {
    amount -= getTableMate(id).discount;
  });*/
  return amount;
};

export const getAmountToPay = (id, date) => {
  var amount = 0;
  var mates = [];
  getOrdersPaidBy(id, date).map(o => getOrderById(o.id)).forEach(function (order) {
    const isPos = getTable(order.tableNumber).pos && featureEnabled("pos/payFirst");
    if (order.paid != true && (order.state != "selected" || isPos) && order.state != "ordered" && order.state != "cancelled") {
      amount += auth.round(order.fullPrice - order.discount - order.tableMateDiscount);
      amount += order.childOrders.filter(o => o.separate).map(o => (o.addition ? 1 : -1) * o.fullPrice).reduce((a, b) => a + b, 0);
      if (mates.indexOf(order.forWhomId) < 0) mates.push(order.forWhomId);
    }
  });
  /*
  mates.forEach(function (id) {
    amount -= getTableMate(id).discount;
  });*/
  return auth.round(amount);
};

export const getOrdersToPay = (id, date) => {
  const isPos = getTable(sessionStorage.tableNumberSelected)?.pos && featureEnabled("pos/payFirst");
  const oos = getOrdersPaidBy(id, date).map(o => getOrderById(o.id));
  var orders = oos.filter(order => order.paid != true && (order.state != "selected" || isPos) && order.state != "ordered").map(o => o.id);
  return orders;
}

export const getAmountsPaid = set => {
  var amount = 0;
  set.forEach(function (t) {
    amount += getAmountPaid(t.id ? t.id : t);
  });
  return auth.round(amount);
};

export const getAmountPaid = (id, date) => {
  var amount = 0;
  getOrdersPaidBy(id, date).forEach(function (order) {
    if (order.paid == true) {
      amount += (order.addition == true ? 1 : -1) * (order.fullPrice - order.discount - order.tableMateDiscount);
      amount += order.childOrders.filter(o => o.separate).map(o => o.fullPrice - o.discount).reduce((a, b) => a + b, 0);
    }
  });
  return auth.round(amount);
}

export const getOrdersPaid = (id) => {
  var orders = [];
  getOrdersPaidBy(id).forEach(function (order) {
    if (order.paid == true) orders[orders.length] = order.id;
  });
  return orders;
}

export const getStateIndex = (mate, s) => {
  var index = -1;
  mate.states.forEach(function (state, ind) {
    if (state.duration == 0 && state.state == s) index = ind;
  });
  return index;
};

const showqrcode_to_link_teammate = id => {
  //var tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);
  var tableOccupationQRCode = getTableMate(id).qrToken;
  var target = $("#editTable div#qrcode" + id);
  if (isVisible(target)) {
    $("#editTable ul#qrcode" + id + " li").show();
    $("#editTable div#qrcode" + id).hide();
    ReactDOM.unmountComponentAtNode(target.get(0));
    return;
  }
  $("#editTable ul.qrcode").show();
  $("#editTable div.qrcode").hide();
  $("#editTable ul#qrcode" + id + " li").hide();
  $("#editTable div#qrcode" + id).show();
  var url = "https://restaurant.eatwithme.online" + (auth.server.indexOf(":8444") > 0 ? ":8444" : "") + "/map.html?r=" + auth.myStatus.restaurant_global_id + "&t=" + sessionStorage.tableNumberSelected + "&m=" + id + "&q=" + tableOccupationQRCode + "&a=m";
  console.log(url);
  if (ReactDOM.findDOMNode(target.get(0)) !== null) ReactDOM.unmountComponentAtNode(target.get(0));
  ReactDOM.render(<ReactQRCode url={url} size={Math.min(target.get(0).getBoundingClientRect().height, target.get(0).getBoundingClientRect().width)} />, target.get(0));

  target.click(function () {
    $("#editTable ul#qrcode" + id + " li").show();
    $("#editTable div#qrcode" + id).hide();
    ReactDOM.unmountComponentAtNode(target.get(0));
  });

  /*
  var qrcode = $("div#qrcode" + id)
    .empty()
    .qrcode({
      // render method: 'canvas', 'image' or 'div'
      render: "image",
 
      // version range somewhere in 1 .. 40
      minVersion: 15,
      maxVersion: 30,
 
      // error correction level: 'L', 'M', 'Q' or 'H'
      ecLevel: "H",
 
      // offset in pixel if drawn onto existing canvas
      left: 0,
      top: 0,
 
      // size in pixel
      size: 1000,
 
      // code color or image element
      fill: "#000",
 
      // background color or image element, null for transparent background
      background: "#ffffff",
 
      text: url,
 
      radius: 0.0,
 
      // quiet zone in modules
      quiet: 0,
 
      // modes
      // 0: normal
      // 1: label strip
      // 2: label box
      // 3: image strip
      // 4: image box
      mode: 1,
 
      mSize: 0.06,
      mPosX: 0.5,
      mPosY: 0.7,
 
      label: String.format(String.format(local.unknown_person, getTableMate(id).seqNr)),
      fontname: "sans",
      fontcolor: "#000",
 
      image: null
    });
  qrcode.find("img").css("height", "100%");
  qrcode.find("img").css("width", "100%");
  $("li#payer" + id)
    .get(0)
    .scrollIntoView({ behavior: "instant", block: "start", inline: "nearest" });
  qrcode.find("img").click(function() {
    $("#editTable ul#qrcode" + id).show();
    $("#editTable div#qrcode" + id).hide();
  });
  */
};

function userConnected() {
  var occupation = getTableOccupation(sessionStorage.tableOccupationSelected);
  return occupation ? occupation.connected : false;
}

export const afterLockTable = data => {
  updateTableOccupationsAndSelect(data, true);
  if (Number(sessionStorage.tableNumberSelected) === getPickupTableNumber() || Number(sessionStorage.tableNumberSelected) === getHomeDeliveryTableNumber()) {
    setTakeAway();
  }
};

var searchActive = false;
var lastSearch = "";
export const filterAdditions = search => {
  if (search == "") {
    $("div.additionsBlock .list-group-item.optional").removeClass("hidden");
    return;
  }
  var items = $("div.additionsBlock .list-group-item.optional").addClass("hidden");
  var items = $("div.additionsBlock .list-group-item.optional span:contains('" + search + "')");
  items.parent().removeClass("hidden");
};

export const userChanged = () => {
  $("#quickAccessBar").empty();
  $("script#quickAccessTemplate")
    .tmpl(tmplparams())
    .appendTo("#quickAccessBar");
  $("div#locked").hide();
  if ($(".bar").length)
    $(".bar").replaceWith($("script#tablesOverviewBarTemplate").tmpl({ includableFrames: includableFrames, ...tmplparams() }));
  ////$(".bar").replaceWith($("script#barTemplate").tmpl(tmplparams()));
  if ($("#softphonePlaceholder").get(0))
    ReactDOM.render(<Softphone store={store} />, $("#softphonePlaceholder").get(0));
  tableLayout.renderLayoutModeControls();
  $(".movableBox .user-img").attr("src", "");
  loadMyImage();
};

export const updateLeftTabs = () => {
  updateOrderListByCustomer(false);
  updateOrderListByTiming(false);
  updateOrderList(false);
  orderListUtil.updateHooks();
  topUpdateHooks();
};

function updateOrderListByCustomer(force) {
  var o = orderListUtil.isFiltered() && typeof orderListUtil.orders.count != "undefined" ? orderListUtil.orders : orderListUtil.allOrders;
  var block = $("ul#orderListByCustomer");
  if (($('#editTable:not(.hidden)').length > 0 && $('#editTable #byCustomer.tab-pane.active').length > 0) && (block.hasClass("outdated")) || force) {
    var newContent = $("<div/>");

    o.ordersByPayer.forEach(function (order) {
      if ($("#userSelector button.active.sticky").length && order.count === 0)
        return;
      if (orderListUtil.show(order))
        if (order.customer && (getTableMate(order.customer.id).active == true || order.count > 0))
          $("script#ordersByPayerTemplate")
            .tmpl({ ...order, ...tmplparams() })
            .appendTo(newContent);
    });

    var target = $("#editTable div.customerQRCode");
    target.each((ind, target) => {
      if (ReactDOM.findDOMNode(target) !== null) ReactDOM.unmountComponentAtNode(target);
    });

    replaceContent(block, newContent);
    block.removeClass("outdated");
    updateToolTips();
  } else {
    block.addClass("outdated");
  }
}

function updateOrderListByTiming(force) {
  var o = orderListUtil.isFiltered() && typeof orderListUtil.orders.count != "undefined" ? orderListUtil.orders : orderListUtil.allOrders;
  var block = $("ul#orderListByTiming");
  if (($('#editTable:not(.hidden)').length > 0 && $('#editTable #byTiming.tab-pane.active').length > 0) && (block.hasClass("outdated")) || force) {
    var newContent = $("<div/>");
    var ordersByTiming = {};
    o.ordersByTiming.forEach(function (order) {
      if (orderListUtil.show(order)) {
        ordersByTiming[order.timing] = order;
      }
    });
    $("script#ordersByTimingTemplate")
      .tmpl({ ...ordersByTiming, ...tmplparams() })
      .appendTo(newContent);
    replaceContent(block, newContent);
    block.removeClass("outdated");
    updateToolTips();
  } else {
    block.addClass("outdated");
  }
}

export const editDiscounts = (tableMate, handler) => {
  var modal = $("#editDiscountDialog");
  modal.empty();
  var orderIds = [];
  var tableMateIds = [];
  var selectedItem = "none";
  const activeTab = $(".nav-link.btn.btn-info.active").attr("href");
  if (activeTab == "#orders" || !orderListUtil.tablesOverview) {
    var orders = $(orderListUtil.selected).find("div.order.orderTableItem");
    orderIds = orders.attr("orders") != null ? orders.attr("orders").split(",") : [];
    if (orderIds.length > 0)
      selectedItem = "order";
    else {
      var orders = $(".byCustomer.menuItem-order.selected");
      orderIds = orders.attr("orderids") != null ? orders.attr("orders").split(",") : [];
      if (orderIds.length > 0)
        selectedItem = "order";
    }
  } else if (!tableMate && activeTab === "#byCustomer") {
    var orders = $(".byCustomer.menuItem-order.selected");
    orderIds = orders.attr("orderids") != null ? orders.attr("orderids").split(",") : [];
    if (orderIds.length > 0)
      selectedItem = "order";
    else
      $('#byCustomer.tab-pane.container.active .customer.list-group-item.selected').each((ind, t) => {
        if ($(t).attr("id").startsWith("payer"))
          var id = Number($(t).attr("id").substring(5));
        else
          var id = Number($(t).attr("id"));
        tableMateIds.push(id);
        selectedItem = "tableMate";
      })
  } else if (tableMate) {
    tableMateIds.push(tableMate);
    selectedItem = "tableMate";
  }
  $("#editDiscountsTemplate")
    .tmpl({ selectedItem: selectedItem, ...tmplparams() })
    .appendTo(modal);
  var modal = $("#editDiscounts");
  var tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);
  tableOccupation.discounts.forEach(function (discount) {
    modal.find("#discountsBlock .list-group-item#" + discount.id).addClass("active");
    modal.find("#discountsBlock .list-group-item#" + discount.id + " input").prop("checked", true);
    modal.find("#discountsBlock .list-group-item#" + discount.id + " span.glyphicon").removeClass("glyphicon-unchecked");
    modal.find("#discountsBlock .list-group-item#" + discount.id + " span.glyphicon").addClass("glyphicon-check");
  });
  tableOccupation.tableMates.forEach(tableMate => {
    if (tableMateIds.indexOf(tableMate.id) === -1) {
      return;
    }
    tableMate.discounts.forEach(discount => {
      modal.find("#selectedDiscountsBlock .list-group-item#" + discount.id).addClass("active");
      modal.find("#selectedDiscountsBlock .list-group-item#" + discount.id + " input").prop("checked", true);
      modal.find("#selectedDiscountsBlock .list-group-item#" + discount.id + " span.glyphicon").removeClass("glyphicon-unchecked");
      modal.find("#selectedDiscountsBlock .list-group-item#" + discount.id + " span.glyphicon").addClass("glyphicon-check");

    });
  })
  if (selectedItem === "none") {
    modal.find("#selectedDiscountsBlock .list-group-item").addClass("disabled");
  }
  updateCheckBoxesById(modal.find("li.list-group-item"));
  orderListUtil.ordersCache.forEach(order => {
    if (orderIds.indexOf("" + order.id) === -1) return;
    if (order.tableOccupationId != sessionStorage.tableOccupationSelected) return;
    if (order.discounts)
      order.discounts.forEach(discount => {
        modal.find("#selectedDiscountsBlock .list-group-item#" + discount.id).addClass("active");
        modal.find("#selectedDiscountsBlock .list-group-item#" + discount.id + " input").prop("checked", true);
        modal.find("#selectedDiscountsBlock .list-group-item#" + discount.id + " span.glyphicon").removeClass("glyphicon-unchecked");
        modal.find("#selectedDiscountsBlock .list-group-item#" + discount.id + " span.glyphicon").addClass("glyphicon-check");
      });
  });
  modal.find("button#save").click(function () {
    var discounts = {};
    var orderDiscounts = {};
    const tableMateDiscounts = {};

    orderListUtil.ordersCache.forEach(order => {
      if (orderIds.indexOf("" + order.id) !== -1) return;
      if (order.tableOccupationId != sessionStorage.tableOccupationSelected) return;
      if (order.discounts)
        order.discounts.forEach(discount => {
          if (orderDiscounts[discount.id] == undefined) orderDiscounts[discount.id] = { discountId: discount.id, discountTarget: "Order", ids: [] };
          orderDiscounts[discount.id].ids.push(order.id);
        });
    });
    tableOccupation.tableMates.forEach(tableMate => {
      if (tableMateIds.indexOf(tableMate.id) === -1) {
        tableMate.discounts.forEach(discount => {
          const tmid = tableMate.id;
          if (tableMateDiscounts[discount.id])
            tableMateDiscounts[discount.id].ids.push(tmid);
          else
            tableMateDiscounts[discount.id] = { discountId: discount.id, discountTarget: "TableMate", ids: [tmid] };
        });
        return;
      }
    })


    getTableOccupation(sessionStorage.tableOccupationSelected).tableMates.forEach(tableMate => {
    });
    modal.find("#selectedDiscountsBlock .list-group-item.active").each(function (ind, t) {
      if (selectedItem === "order") {
        if (!orderDiscounts[Number($(t).attr("id"))]) orderDiscounts[Number($(t).attr("id"))] = { discountId: $(t).attr("id"), discountTarget: "Order", ids: [] };
        orderIds.forEach(id => {
          orderDiscounts[Number($(t).attr("id"))].ids.push(id);
        });
      } else if (selectedItem === "tableMate") {
        if (!tableMateDiscounts[Number($(t).attr("id"))]) tableMateDiscounts[Number($(t).attr("id"))] = { discountId: $(t).attr("id"), discountTarget: "TableMate", ids: [] };
        tableMateIds.forEach(id => {
          tableMateDiscounts[Number($(t).attr("id"))].ids.push(id);
        });
      }
    });
    modal.find("#discountsBlock .list-group-item.active").each(function (ind, t) {
      var v = {};
      discounts[$(t).attr("id")] = { discountId: $(t).attr("id"), discountTarget: "TableOccupation", ids: [] };
    });
    discounts = [...Object.values(discounts), ...Object.values(orderDiscounts), ...Object.values(tableMateDiscounts)];

    admin.updateDiscountsForTableOccupation(sessionStorage.tableOccupationSelected, discounts, function (data) {
      $("div.modal-backdrop.fade.show").hide();
      updateAndCloseModal(data, handler);
    });
  });
  modal.modal("show", {
    keyboard: false,
  });

  modal.on("hidden.bs.modal", function () {
    $("#edit-discount").attr("disabled", null);
  });
};

export const showTableOccupationList = () => {
  localStorage.tableOccupations_fromDate = moment()
    .startOf("day")
    .toDate()
    .getTime();
  localStorage.tableOccupations_toDate = moment()
    .endOf("day")
    .toDate()
    .getTime();
  localStorage.removeItem("tableOccupations_tableNumber");
  localStorage.tableOccupations_active = false;
  // eslint-disable-next-line no-restricted-globals
  history.push("/reportsMenu/tableOccupations");
};

function addAdditionalTable(handler) {
  tablePicker(function (event) {
    var tableId = $(event.currentTarget).attr("id");
    if (tableId == sessionStorage.tableNumberSelected) {
      messageDialog(local.message, admin_local.target_table_same_and_source);
      return;
    }
    var tableOccupationTables = getTableOccupationTablesForTable(tableId);
    if (tableOccupationTables.length == 0 || getTable(tableId).shareable) {
      // this is an empty table
      choiceDialog2(local.confirmation, String.format(admin_local.confirm_additional_table, tableId), [admin_local.yes]).done(function (data) {
        admin.addAdditionalTable(sessionStorage.tableOccupationSelected, tableId, update);
      });
    }
  });
}

export const changeToTable = (table) => {
  const def = $.Deferred();
  if (table) {
    var tableId;
    if (table === "homedelivery") {
      tableId = getHomeDeliveryTableNumber();
    }
    else if (table === "pickup")
      tableId = getPickupTableNumber();
    if ($("#editTable").hasClass("selectTableOccupation") || orderListUtil.tableOccupationSelected?.length > 0) {
      selectTableNumberSelected(tableId);
      updateTableOccupations([], []);
      def.resolve();
      if (table === "homedelivery" && auth.showTheMap) {
        showMap(true);
      }
    } else {
      choiceDialog2(local.confirmation, table === "homedelivery" ? admin_local.confirm_change_to_homedelivery : admin_local.confirm_change_to_pickup, [admin_local.yes]).done(function (data) {
        admin.changeToTable(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, tableId, function (data) {
          selectTableNumberSelected(tableId);
          update(data);
          def.resolve();
          if (table === "homedelivery" && auth.showTheMap) {
            showMap(true);
          }

        });
      });
    }
    return def.promise();
  }

  tablePicker(function (event) {
    var tableId = $(event.currentTarget).attr("id");
    if (tableId == sessionStorage.tableNumberSelected) {
      messageDialog(local.message, admin_local.target_table_same_and_source);
      return;
    }
    var tableOccupationTables = getTableOccupationTablesForTable(tableId).filter(t => {
      const tt = getTableOccupation(t.tableOccupationId || t.id);
      return tt?.occupationStart;
    });
    if (tableOccupationTables.length == 0) {
      // this is an empty table
      choiceDialog2(local.confirmation, String.format(admin_local.confirm_change_to_table, tableId), [admin_local.yes]).done(function (data) {
        admin.changeToTable(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, tableId, function (data) {
          selectTableNumberSelected(tableId);
          update(data);
        });
      });
    } else if (tableOccupationTables.length >= 1) {
      // this is an table with existing occupation
      if (getTable(tableOccupationTables[0].restaurantTable.number).shareable) {
        choiceDialog2(local.confirmation, String.format(admin_local.confirm_table_change_to_shared_table, tableId), [admin_local.new_independent_occupation, admin_local.joins, admin_local.extend_occupation]).done(
          function (data) {
            switch (data) {
              case 0:
                // new occupation
                console.log("new occupation")
                admin.createNewTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, -1, tableId, true, update);
                break;
              case 1:
                // joins occupation
                admin.changeTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, -1, tableOccupationTables[0].tableOccupationId, tableId, true, update);
                break;
              case 2:
                // add to existing occupation
                admin.changeTableForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, -1, tableId, true, update);
                break;
            }
          }
        );
      } else {
        choiceDialog2(local.confirmation, String.format(admin_local.confirm_table_change_to_table, tableId), [admin_local.yes]).done(function (data) {
          // joins occupation
          admin.changeTableOccupationForMate(sessionStorage.tableOccupationSelected, sessionStorage.tableNumberSelected, -1, tableOccupationTables[0].tableOccupationId, tableId, true, update);
        });
      }
    }
  });
}

export const showEditTable = () => {
  $("div#orders.tab-pane.container").empty();
  $("script#orderListMainTemplate")
    .tmpl(tmplparams())
    .appendTo($("div#orders.tab-pane.container"));

  $("#freezelock").removeClass("icon-lock");
  $("#freezelock").addClass("icon-lock-open");
  $("#editTable").length && $("#editTable").removeClass("hidden");
  $("#main-floorplan").addClass("hidden");
  $("tbody#orderList").addClass("outdated");
  $('#left_pane .tab-content').removeClass('hidden');

  //ReactDOM.render(<Softphone store />, $("#softphonePlaceholder").get(0));

  if (sessionStorage.tableNumberSelected == getPickupTableNumber() || sessionStorage.tableNumberSelected == getHomeDeliveryTableNumber()) {
    $("#tableOccupation-selector").addClass('selectTableOccupation');
    $('#left_pane .tab-content').addClass('hidden');
  }

  if (sessionStorage._editTable != "true" && sessionStorage.tableOccupationSelected)
    get("adminService/" + localStorage.restaurantSelected + "/tableEditStart/" + sessionStorage.tableOccupationSelected + "/" + sessionStorage.tableNumberSelected, undefined, undefined, undefined, false).fail(() => { auth.ajaxError = false });
  sessionStorage._editTable = true;
};

function tablePicker(tableClickHandler) {
  var handler = function (event) {
    event.preventDefault();
    event.stopPropagation();
    showEditTable();
    shown = false;
    setBigTableNumber();
    $("#c svg[visible='true'] g.eatwithme-table").unbind("click", handler);
    $("body").unbind("keydown", tableKeyDown);
    tableClickHandler(event);
  };
  var tableKeyDown = null;
  var shown = true;
  tableKeyDown = function (event) {
    event.preventDefault();
    event.stopPropagation();
    shown = false;
    showEditTable();
    setBigTableNumber();
    sessionStorage._editTable = true;
    $("#c svg[visible='true'] g.eatwithme-table").unbind("click", tableClickHandler);
    $("body").unbind("keydown", tableKeyDown);
  };
  $("#editTable").addClass("hidden");
  $("#main-floorplan").removeClass("hidden");
  delete sessionStorage._editTable;
  $("#c svg[visible='true'] g.eatwithme-table").each(function (ind, item) {
    var handlers = $._data(item, "events");
    var clickHandlers = [];
    handlers.click.forEach(function (click) {
      clickHandlers.push(click.handler);
    });
    const $item = $(item);
    $(item).off();
    $(item).on("click", handler);
    clickHandlers.forEach(function (click) {
      $(item).click(click);
    });

    var handlers = $._data($("body").get(0), "events");
    var keyDownHandlers = [];
    handlers.keydown.forEach(function (keydown) {
      keyDownHandlers.push(keydown.handler);
    });
    $("body").unbind("keydown");
    $("body").keydown(tableKeyDown);
    keyDownHandlers.forEach(function (keydown) {
      $("body").keydown(keydown);
    });
    setTimeout(function () {
      if (shown) {
        showEditTable();
        setBigTableNumber();
        sessionStorage._editTable = true;
        $("#c [visible='true'] g.eatwithme-table").unbind("click", handler);
        $("body").unbind("keydown", tableKeyDown);
        $("#c [visible='true'] g.eatwithme-table").unbind("click", tableClickHandler);
        $("body").unbind("keydown", tableKeyDown);
      }
    }, 6000);
  });
}

export const setBigTableNumber = () => {
  var table = getTable(sessionStorage.tableNumberSelected);
  if (table == undefined) return;
  var t = table.name ? table.name : "" + table.number;
  var tt = $("#editTable .tableNumber");
  tt.html(t);
  if (t.length <= 3) tt.css("font-size", "30vmin");
  else if (t.length <= 6) tt.css("font-size", "20vmin");
  else tt.css("font-size", "15vmin");
};

export const pickFrame = (side, frame) => {
  localStorage["extra_frame_" + side] = frame;
  _log("LOGIN: picked frame " + frame + " for side " + side);
  setTimeout(() => {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  }, 1000);
};

export const pickSkin = (skin) => {
  localStorage.skin = skin;
  document.getElementById("root").setAttribute('theme', localStorage.skin);
  _log("LOGIN: picked skin " + skin);
  setTimeout(() => {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  }, 1000);
};

const tableReadyForDelivery = (t) => {
  const timing = $(t).attr('timing');
  const tableOccupation = $(t).attr('tableOccupation');
  const tableNumber = $(t).attr('tableNumber');
  const tableName = getTable(tableNumber).name ? getTable(tableNumber).name : tableNumber;
  const text = "<html><body><div>" + String.format(I18n.t("admin_local.table_ready_for_delivery"), tableName, tableOccupation, getLocale2(auth.myStatus.restaurant_settings.timings[timing].langs).name) + "!LF!LF!LF</div></body></html>";
  var o = /*orderListUtil.orders ? orderListUtil.orders :*/ orderListUtil.allOrders;
  var pls = [];
  o.tables.forEach(function (order) {
    if (orderListUtil.show(order)) {
      if (order.timing !== timing)
        return;
      order.timingOrder = alltimings.indexOf(order.timing);
      for (var pl in order.productionLinesInvolved) {
        if (pl == "pl") continue;
        if (pls.indexOf(pl.id) < 0) {
          pls.push(Number(order.productionLinesInvolved[pl].id));
        }
      }
    }
  });
  var printerOptions = [];
  Object.keys(getLocalPrinterSettings().productionLines).forEach(function (key) {
    printerOptions.push({ productionLine: Number(key.substring(3)), printer: getLocalPrinterSettings().productionLines[key] });
  });
  const printers = [];
  auth.myStatus.restaurant_production_lines.filter(pl => pls.indexOf(pl.id) !== -1).forEach(pl => {
    console.log(pl);
    const po = printerOptions.find(po => po.productionLine === pl.id);
    if (po)
      printers.indexOf(po.printer) === -1 && printers.push(po.printer);
    else
      printers.indexOf(pl.printer.id) === -1 && printers.push(pl.printer.id);
  })
  printers.forEach(printer => {
    post("printerServerClient/" + localStorage.restaurantSelected + "/printerMessage/" + printer, { text: text });
  })
}

const bookTable = () => {
  $("#bookTable").removeClass("hidden");
  ReactDOM.render(<Provider store={store}><TableReservationComponent onClose={closeBookTable} /></Provider>, $("#bookTable").get(0));
}

const closeBookTable = () => {
  ReactDOM.unmountComponentAtNode($("#bookTable").get(0));
  $("#bookTable").addClass("hidden");
}

var bookingMap;

export const showMap = (show) => {
  /*
  if ($('#tableOccupation-selector-map').length == 0)
    return;*/
  auth.showTheMap = show;
  if (isHomeDelivery() && show && $('#tableOccupation-selector-map').length) {
    //$("#tableOccupation-selector").addClass('hidden');
    $("#tableOccupation-selector-map").removeClass('hidden');

    bookingMap = ReactDOM.hydrate(<BookingMap date={Number(tablesOverview.selectedDate)} myStatus={auth.myStatus} deliveryUsers={tablesOverview.context ? tablesOverview.context.props.deliveryUsers : []} tableOccupations={orderListUtil.occupationsSelected} />, $('#tableOccupation-selector-map').get(0));
    $("#tableOccupation-selector li:not(.group-functions) input.custom-control-input").each((ind, i) => {
      bookingMap && bookingMap.selectTableOccupation($(i).parent().parent().attr("id"), i.checked);
    })
    $("#tableOccupation-selector").show();
    $("#container.left-right").removeClass("hidden");
    $("#editTable").addClass("show-map");
  } else {
    $("#editTable").removeClass("show-map");
    $("#tableOccupation-selector-map").addClass('hidden');
    //$("#tableOccupation-selector").removeClass('hidden')
    if ($('#tableOccupation-selector-map').get(0)) {
      ReactDOM.unmountComponentAtNode($('#tableOccupation-selector-map').get(0));
      bookingMap = undefined;
    }
  }
  filterForMapView();
}

export const setSelectedScale = (scale) => {
  localStorage.selected_scale = scale;
  $('#orderMenuItem #selectedScale').html(scale);
}

function customerDblClickHandler(event, id) {
  event.stopPropagation();
  selectNewOrders();
  const i = $('#userSelector button#' + id);
  if (i.hasClass("sticky")) {
    i.triggerHandler("change");
    i.removeClass("active");
    i.removeClass("sticky");
    i.find("input").prop('checked', false);
    updateOrders([]);
  } else {
    i.triggerHandler("change");
    i.addClass("active");
    i.addClass("sticky");
    i.find("input").prop('checked', true);
    updateOrders([]);
  }

}

export const printDailyClosing = () => {
  const start = moment().startOf("day");
  const end = moment();
  if (auth.myStatus.restaurant_settings["business-day-starts-at"] > auth.myStatus.restaurant_settings["business-day-ends-at"] && end.hour() < auth.myStatus.restaurant_settings["business-day-ends-at"]) {
    start.add(-1, "day");
  }
  start.add("hour", auth.myStatus.restaurant_settings["business-day-starts-at"]);
  var search = {
    fromDate: start.valueOf(),
    toDate: end.valueOf(),
    labels: []
  }

  function print(datas) {

    var data = {
      date: start.format("YYYY-MM-DD"),
      tables: 0,
      orders: 0,
      cancelledOrders: 0,
      personCount: 0,
      consumption: 0,
      discount: 0,
      payable: 0,
      paid: 0,
      tip: 0,
      serviceFee: 0,
      serviceFeeNet: 0,
      payments: [],
      deliveries: [],
      vats: [],
      menuItems: [],
      types: []
    }

    datas.forEach(d => {
      data.tables += d.occupationCount;
      data.orders += d.orderCount;
      data.cancelledOrders += d.deletedOrderCount;
      data.personCount += d.persons;
      data.consumption += d.price + d.pending;
      data.discount += d.discount + d.tm_discount;
      data.payable = data.consumption - data.discount;
      data.paid += d.paid;
      data.tip += d.tip;
      data.serviceFee += d.serviceFee;
      data.serviceFeeNet += d.serviceFeeNet;


      d.payments.forEach(p => {
        var payment = data.payments.find(pp => p.receivedById === pp.receivedById && p.cashRegister === pp.cashRegister && p.paymentMethod === pp.method && p.currency === pp.currency);
        if (!payment) {
          data.payments.push({
            cashier: p.receivedByName,
            receivedById: p.receivedById,
            cashRegister: p.cashRegister,
            method: p.paymentMethod,
            currency: p.currency,
            amount: p.amount,
            exchangeRate: p.exchangeRate,
            paymentCount: p.paymentCount
          })
        } else {
          payment.amount += p.amount;
          payment.paymentCount += p.paymentCount;
        }

      });

      d.deliveries.forEach(p => {
        var payment = data.deliveries.find(pp => p.receivedById === pp.receivedById && p.cashRegister === pp.cashRegister && p.paymentMethod === pp.method && p.currency === pp.currency);
        if (!payment) {
          data.deliveries.push({
            cashier: p.receivedByName,
            receivedById: p.receivedById,
            cashRegister: p.cashRegister,
            method: p.paymentMethod,
            currency: p.currency,
            amount: p.amount,
            exchangeRate: p.exchangeRate,
          })
        } else {
          payment.amount += p.amount;
        }

      });


      Object.keys(d.drinksIncome).forEach(key => {
        const p = {
          vat: key,
          amount: d.drinksIncome[key]
        }
        var vat = data.vats.find(pp => p.vat === pp.vat && pp.type === "drink");
        if (!vat) {
          data.vats.push({
            vat: p.vat,
            type: "drink",
            amount: p.amount
          })
        } else {
          vat.amount += p.amount;
        }
      });

      Object.keys(d.mealsIncome).forEach(key => {
        const p = {
          vat: key,
          amount: d.mealsIncome[key]
        }
        var vat = data.vats.find(pp => p.vat === pp.vat && pp.type === "meal");
        if (!vat) {
          data.vats.push({
            vat: p.vat,
            type: "meal",
            amount: p.amount
          })
        } else {
          vat.amount += p.amount;
        }
      });
      Object.keys(d.serviceFeeIncome).forEach(key => {
        const p = {
          vat: key,
          amount: d.serviceFeeIncome[key]
        }
        if (p.amount === 0) return;
        var vat = data.vats.find(pp => p.vat === pp.vat && pp.type === "service_fee");
        if (!vat) {
          data.vats.push({
            vat: p.vat,
            type: "service_fee",
            amount: p.amount
          })
        } else {
          vat.amount += p.amount;
        }
      });


      var type = data.types.find(pp => pp.name === d.type);
      if (!type) {
        data.types.push({
          name: d.type,
          amount: d.paid,
          count: d.occupationCount,
          entry: d.orderCount,
          payable: d.price + d.pending,
          discount: d.discount + d.tm_discount,
        })
      } else {
        type.amount += d.paid;
        type.count += d.occupationCount;
        type.payable += d.price + d.pending;
        type.discount += d.discount + d.tm_discount;
      }

    });

    data.payments.sort((a, b) => {
      if (a.cashier !== b.cashier) {
        return a.cashier.localeCompare(b.cashier);
      } else if (a.cashRegister === b.cashRegister) {
        return a.method - b.method;
      } else {
        return a.cashRegister - b.cashRegister
      }
    })

    data.deliveries.sort((a, b) => {
      if (a.cashier !== b.cashier) {
        return a.cashier.localeCompare(b.cashier);
      } else if (a.cashRegister === b.cashRegister) {
        return a.method - b.method;
      } else {
        return a.cashRegister - b.cashRegister
      }
    })

    data.payments.filter(t => t.amount).forEach(t => {
      t.method = auth.myStatus.restaurant_payment_methods.find(p => p.method.id == t.method)?.method?.name;
      t.currency = auth.myStatus.restaurant_base_currency.id === t.currency ? auth.myStatus.restaurant_base_currency.name : auth.myStatus.restaurant_currencies.find(p => p.currency.id == t.currency)?.currency?.name;
      t.amount = Math.round(t.amount).toLocaleString();
      t.exchangeRate = t.exchangeRate !== 1 ? t.exchangeRate.toLocaleString() : "";
      t.cashRegister = t.cashRegister === -1 ? I18n.t("admin_local.VATInvoice") : t.cashRegister ? auth.myStatus.restaurant_cash_registers.find(p => p.id == t.cashRegister).name : "";
    });
    data.deliveries.forEach(t => {
      t.method = auth.myStatus.restaurant_payment_methods.find(p => p.method.id == t.method).method.name;
      t.currency = auth.myStatus.restaurant_base_currency.id === t.currency ? auth.myStatus.restaurant_base_currency.name : auth.myStatus.restaurant_currencies.find(p => p.currency.id == t.currency).currency.name;
      t.amount = Math.round(t.amount).toLocaleString();
      t.exchangeRate = t.exchangeRate !== 1 ? t.exchangeRate.toLocaleString() : "";
      t.cashRegister = t.cashRegister === -1 ? I18n.t("admin_local.VATInvoice") : t.cashRegister ? auth.myStatus.restaurant_cash_registers.find(p => p.id == t.cashRegister).name : "";
    });


    data.vats.forEach(t => {
      t.type = admin_local[t.type] ? admin_local[t.type] : t.type;
      t.amount = Math.round(t.amount).toLocaleString();
    });

    data.types.forEach(t => {
      t.name = t.name ? t.name : "onsite"
      t.name = admin_local[t.name] ? admin_local[t.name] : t.name;
      t.count = t.count.toLocaleString();
      t.payable = Math.round(t.payable).toLocaleString();
      t.amount = Math.round(t.amount).toLocaleString();
      t.discount = Math.round(t.discount).toLocaleString();
    });

    data.tables = data.tables.toLocaleString();
    data.orders = data.orders.toLocaleString();
    data.cancelledOrders = data.cancelledOrders.toLocaleString();
    data.personCount = Math.round(data.personCount).toLocaleString();
    data.consumption = Math.round(data.consumption).toLocaleString();
    data.discount = Math.round(data.discount).toLocaleString();
    data.payable = Math.round(data.payable).toLocaleString();
    data.paid = Math.round(data.paid).toLocaleString();
    data.tip = Math.round(data.tip).toLocaleString();
    data.serviceFee = Math.round(data.serviceFee).toLocaleString();
    data.serviceFeeNet = Math.round(data.serviceFeeNet).toLocaleString();
    var x2js = new X2JS();
    var xmlAsStr = '<?xml version="1.0" encoding="utf-8"?><root>' + x2js.js2xml(data) + "</root>";
    var file = "dailyClosing_" + localStorage.id + (new Date().getTime());
    var printer = getLocalPrinterSettings().printerActions.pa_printInvoice ? getPrinter(getLocalPrinterSettings().printerActions.pa_printInvoice).name : auth.myStatus.restaurant_printer_actions?.printInvoice?.name || auth.myStatus.restaurant_printer_actions?.printVATInvoice?.name;
    if (!printer) printer = auth.myStatus.restaurant_printers?.find(p => p.name == "pult")?.name;
    if (!printer) printer = "local";
    printPdf("dailyClosing", "html", localStorage.language, "../birt/preview?__report=" + getReportUrl('dailyClosing') + "&__format=html&__locale=" + localStorage.language, file, xmlAsStr, printer);

  }

  post("adminService/" + localStorage.restaurantSelected + "/filterDayClosing?lang=" + localStorage.language + "&quick=" + !hasAccess("sales.dailyreport.fullreport"), search).done(print);
}


function increasePersonCount() {
  get("adminService/" + localStorage.restaurantSelected + "/incrementPersonCount/" + sessionStorage.tableOccupationSelected).done(update)
}

function decreasePersonCount() {
  get("adminService/" + localStorage.restaurantSelected + "/decrementPersonCount/" + sessionStorage.tableOccupationSelected).done(update)
}

function toggleShowState(event) {
  $(event.target).toggleClass("active");
  var state = $(event.target).attr("state");
  const active = $(event.target).hasClass("active");
  localStorage["mapShowState" + state] = active;
  updateTableOccupationSelector();
}

function maptoggleShowState(event) {
  $(event.target).toggleClass("active");
  var state = $(event.target).attr("state");
  const active = $(event.target).hasClass("active");
  localStorage["mapmapShowState" + state] = active;
  updateTableOccupationSelector();
}

function setBookedPaymentMethod(id) {
  var tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);
  var bookedProperties = tableOccupation.bookedProperties;
  bookedProperties.payment_method = id;
  post("adminService/" + localStorage.restaurantSelected + "/updateBooking/" + sessionStorage.tableOccupationSelected, bookedProperties).done(data => {
    update(data);
  }).fail((error) => {
    console.error(error);
  });
}

function setBookingComment() {
  var tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);
  var bookedProperties = tableOccupation.bookedProperties;
  getInputDialog(I18n.t("admin_local.comment"), I18n.t("admin_local.tooltip.user_comment"), bookedProperties.comment).done((i, comment) => {
    bookedProperties.comment = comment;
    post("adminService/" + localStorage.restaurantSelected + "/updateBooking/" + sessionStorage.tableOccupationSelected, bookedProperties).done(data => {
      update(data);
    }).fail((error) => {
      console.error(error);
    });
  })
}
function setUserComment() {
  var tableOccupation = getTableOccupation(sessionStorage.tableOccupationSelected);
  var bookedProperties = tableOccupation.bookedProperties;
  getInputDialog(I18n.t("admin_local.comment"), I18n.t("admin_local.tooltip.user_comment"), bookedProperties.comment).done((i, comment) => {
    bookedProperties.comment = comment;
    post("adminService/" + localStorage.restaurantSelected + "/updateBooking/" + sessionStorage.tableOccupationSelected, bookedProperties).done(data => {
      update(data);
    }).fail((error) => {
      console.error(error);
    });
  })
}
